// Declare app level module which depends on filters, and services
angular.module('proso.anatomy', [
    'angulartics',
    'angulartics.google.analytics',
    'angular-svg-round-progressbar',
    'gettext',
    'infinite-scroll',
    'ngRoute',
    'ngAnimate',
    'ngCookies',
    'ngSanitize',
    'ngLocationUpdate',
    'proso.anatomy.filters',
    'proso.anatomy.services',
    'proso.anatomy.directives',
    'proso.anatomy.controllers',
    'proso.anatomy.templates',
    'proso.apps',
    'smoothScroll',
    'ui.bootstrap',
    'angularDjangoCsrf',
    'xeditable',
    'countTo',
    'cfp.hotkeys',
])

.constant('domain', window.domain || '')

.config(['$routeProvider', '$locationProvider', '$analyticsProvider',
    function($routeProvider, $locationProvider, $analyticsProvider) {
        'use strict';
        $routeProvider.when('/', {
            templateUrl : 'static/tpl/homepage.html'
        }).when('/home', {
            templateUrl : 'static/tpl/homepage.html'
        }).when('/_=_', {
            redirectTo : '/overview/'
        }).when('/login/:somepath/', {
            controller : 'reloadController',
            templateUrl : 'loading.html'
        }).when('/subscription/subscribe/:somepath?', {
            controller : 'reloadController',
            templateUrl : 'loading.html'
        }).when('/about', {
            templateUrl : 'static/tpl/about.html'
        }).when('/terms-of-use-cs', {
            templateUrl : 'static/tpl/terms_of_use_cs.html'
        }).when('/terms-of-use-en', {
            templateUrl : 'static/tpl/terms_of_use_en.html'
        }).when('/privacy-policy-cs', {
            templateUrl : 'static/tpl/privacy_policy_cs.html'
        }).when('/privacy-policy-en', {
            templateUrl : 'static/tpl/privacy_policy_en.html'
        }).when('/offer', {
            templateUrl : 'static/tpl/offer.html'
        }).when('/unauthorized/', {
            templateUrl : 'static/tpl/unauthorized.html'
        }).when('/view/:category?/image/:context?', {
            controller : 'viewController',
            templateUrl : 'static/tpl/view_tpl.html'
        }).when('/view/:category?/:user?', {
            controller : 'viewController',
            templateUrl : 'static/tpl/view_tpl.html'
        }).when('/image/generator', {
            controller : 'imageGeneratorController',
            templateUrl : 'static/tpl/image_generator.html'
        }).when('/image/:context?', {
            controller : 'imageViewController',
            templateUrl : 'static/tpl/image_view_page.html'
        }).when('/practice/', {
            controller : 'practiceController',
            templateUrl : 'static/tpl/practice_tpl.html'
        }).when('/refreshpractice/:category?/:category2?', {
            redirectTo : '/practice/:category/:category2'
        }).when('/practice/:category?/:category2?', {
            controller : 'practiceController',
            templateUrl : 'static/tpl/practice_tpl.html'
        }).when('/overview/tab/:tab', {
            controller : 'overviewController',
            templateUrl : 'static/tpl/overview_tpl.html'
        }).when('/overview/:user?', {
            controller : 'overviewController',
            templateUrl : 'static/tpl/overview_tpl.html'
        }).when('/relationsoverview/:user?', {
            controller : 'overviewController',
            templateUrl : 'static/tpl/overview_tpl.html'
        }).when('/u/:user?', {
            controller : 'userController',
            templateUrl : 'static/tpl/user_tpl.html'
        }).when('/premium/', {
            controller : 'premiumController',
            templateUrl : 'static/tpl/premium.html'
        }).when('/settings/', {
            controller : 'settingsController',
            templateUrl : 'static/tpl/settings.html'
        }).when('/relations/:category?/:user?', {
            controller : 'relationsController',
            templateUrl : 'static/tpl/relations.html'
        }).otherwise({
            templateUrl : 'static/tpl/404.html'
        });

        var languages = ['cs', 'en'];
        for (var i = 0; i < languages.length; i++) {
            $routeProvider.when('/' + languages[i] + '/:somepath?', {
                controller : 'reloadController',
                templateUrl : 'loading.html'
            }).when('/' + languages[i] + '/:somepath/:more?/:path?', {
                controller : 'reloadController',
                templateUrl : 'loading.html'
            });
        }

        $locationProvider.html5Mode(true);

        $analyticsProvider.registerPageTrack(function (path) {

            var pageTrackArray = [];
            pageTrackArray.push('virtualPage');

            if(path){
                pageTrackArray.push({url : path});
            }

          if(window.__insp) {
            window.__insp.push(pageTrackArray);
          }

        });
    }
])

.config(['hotkeysProvider', function(hotkeysProvider) {
  hotkeysProvider.includeCheatSheet = false;
}])

.run(['$rootScope', '$analytics', 'editableOptions', 'configService', 'userService',
    function($rootScope, $analytics, editableOptions, configService, userService) {
        'use strict';
        $analytics.settings.pageTracking.autoTrackFirstPage = false;

        editableOptions.theme = 'bs3';

        $rootScope.$on('questionSetFinished', function() {
          var checkPoints = configService.getConfig(
            'proso_feedback', 'evaluation_checkpoints', []);
          var answered_count = userService.user.profile.number_of_answers;
          var setLength = configService.getConfig('proso_models', 'practice.common.          set_length', 10); 

          angular.forEach(checkPoints, function(checkPoint) {
            if (checkPoint - setLength < answered_count && answered_count <= checkPoint) {
              $rootScope.$emit("openRatingModal");
            }
          });
          $analytics.eventTrack('eventName', {
            category: 'practice',
            action: 'finished',
            value: answered_count,
          });
        });
}])

.run(['$rootScope', 'userService', '$location',
    function($rootScope, userService, $location) {
  $rootScope.$on('$locationChangeStart', function(event, next) {
    if (next.indexOf('/relations') !== -1 &&
        next.indexOf('/relationsoverview') === -1 &&
        next.indexOf('/demo') === -1 &&
        !(userService.user &&
          userService.user.profile &&
          userService.user.profile.subscribed)) {
      $location.replace();
      $location.path('/unauthorized/');
    }
    $rootScope.isPractice = next.indexOf('/practice') !== -1;
  });
}])

.run(['$rootScope', '$window', function($rootScope, $window) {
  $rootScope.$on('userLogin', function() {
    console.log('userLogin');
    $window.location.reload();
  });
}]);

angular.module('proso.anatomy.controllers', []);

// put controllers in folder /anatomy/static/js/controllers

angular.module('proso.anatomy.controllers')

.controller('anatomyImageController', ['$scope', '$element', 'imageService', '$window', '$', 'colorService', '$timeout', '$filter', 'colors',
    function($scope, $element, imageService, $window, $, colorService, $timeout, $filter, colors) {
  var ANIMATION_TIME_MS = 1000;
  $element.parent().addClass('anatomy-image');
  $element.parent().addClass('image-' + $scope.code);

  function setMinImageHeight() {
    angular.element('body').removeClass('horizontal');
    var screenAspectRatio = $window.innerHeight / $window.innerWidth;

    if (screenAspectRatio < 1 && $window.innerWidth > 600) {
      angular.element('body').addClass('horizontal');
      $element.css("min-height", $window.innerHeight * 0.8);
    } else {
      $element.css("min-height", $window.innerHeight / 2);
    }
  }
  setMinImageHeight();
  angular.element(window).bind('resize', function() {
    setMinImageHeight();
  });

  var initImage = function(image){
    var paper = {
      x : 0,
      y : 0,
    };
    $element.attr("oncontextmenu", "return false;");
    $element[0].innerHTML = "";
    var r = Raphael($element[0]);
    var clickFn;


    function clickHandler(){
      var clickedCode = this.data('code');
      if (!clickedCode || $scope.$parent.canNext) {
        return;
      }
      if (clickFn) clickFn(clickedCode);
      $scope.$parent.$apply();
    }

    var paths = [];
    var pathsObj = {};
    var pathsByCode = {};
    var rPathsObj = {};

    var highlights = [];
    var highlightsByCode = {};

    var that = {
      onClick: function(callback) {
        clickFn = callback;
      },
      highlightItem : function(code, color, animate) {
        var paths = code ? (pathsByCode[code] || []) : [];
        var bbox = getBBox(paths.map(function(p) {return p.getBBox();}));
        angular.forEach(paths, function(path) {
          if (color == 'no-change') {
            color = chroma(path.data('color')).darken().hex();
          }
          if (color) {
            path.attr({
              'fill' : animate ? '#fff' : path.data('color'),
              'stroke' : animate ? '#fff' : path.data('stroke-color'),
            });
            var animAttrs = {
              'fill' : color,
              'stroke' : color,
              'opacity' : 1,
            };
            path.animate(animAttrs, ANIMATION_TIME_MS, '>');
            path.data('highlight-color', color);
            highlights.push(path);
          }
        });

        if (animate) {
          var highlightEllipse = r.circle(
            bbox.x + bbox.width / 2,
            bbox.y + bbox.height / 2,
            Math.max(bbox.width, bbox.height) / 2);
          highlightEllipse.attr({
            'stroke-width' : image.bbox.height / 100,
            'stroke' : color,
            'stroke-opacity' : 0.5,
            'transform' : 's ' + getZoomRatio(bbox),
          });
          var animAttrs = {
            transform : '',
          };
          highlightEllipse.animate(animAttrs, ANIMATION_TIME_MS / 2, '>', function() {
            highlightEllipse.remove();
          });
        }
      },

      clearHighlights : function() {
        for (var i = 0; i < highlights.length; i++) {
          highlights[i].attr({
            'fill' : highlights[i].data('color'),
            'stroke' : highlights[i].data('stroke-color'),
            'opacity' : highlights[i].data('opacity'),
          });
          highlights[i].data('highlight-color', undefined);
        }
        highlights = [];
        highlightsByCode = {};
      },
      setColor : function(code, color) {
        var paths = pathsByCode[code] || [];
        for (var i = 0; i < paths.length; i++) {
          paths[i].data('color', color);
          paths[i].data('stroke-color', color);
          paths[i].attr({
            'fill' : color,
            'stroke' : color,
          });
        }
      },
      hoverIn : hoverInHandler,
      hoverOut : hoverOutHandler,
      highlightAnswer : function (question, selected) {
          var asked = question.description;
          if ($filter('isFindOnMapType')(question)) {
              that.highlightItem(asked, colors.GOOD);
          }
          that.highlightItem(selected, asked == selected ? colors.GOOD : colors.BAD);
          /*
          if ((question.question_type == 't2ts' ||
                question.question_type == 'ts2t') &&
              question.additional_info) {
            that.highlightItem(
              question.additional_info.descriptions[question.question_type],
              question.isCorrect ? colors.GOOD : colors.BAD);

          }
          */
      },
      highlightQuestion : function (question) {
        if ($filter('isPickNameOfType')(question)) {
          var callback = function(iteration) {
            that.highlightItem(
              question.description, colors.HIGHLIGHTS[1], true);
            $timeout(function() {
              if (!question.responseTime) {
                callback(iteration + 1);
              }
            }, 2 * ANIMATION_TIME_MS * iteration * iteration);
          };
          callback(1);
        }
        if ($filter('isFindOnMapType')(question) && question.options) {
          for (var i = 0; i < question.options.length; i++) {
            question.options[i].bgcolor = colors.HIGHLIGHTS[i];
            question.options[i].color = colors.HIGHLIGHTS_CONTRAST[i];
            that.highlightItem(
              question.options[i].description,
              colors.HIGHLIGHTS[i]);
          }
        }
      },

    };

    function hoverInHandler(pathCode) {
      var path = pathsByCode[pathCode] && pathsByCode[pathCode][0] || this;
      setHoverColor(path, true);
    }

    function hoverOutHandler(pathCode) {
      var path = pathsByCode[pathCode] && pathsByCode[pathCode][0] || this;
      setHoverColor(path, false);
    }

    function getZoomRatio(bbox) {
      var widthRatio =  image.bbox.width / bbox.width;
      var heightRatio = image.bbox.height / bbox.height;
      var minRatio = Math.min(widthRatio, heightRatio);
      var zoomRatio = Math.max(1.05, minRatio);
      return zoomRatio;
    }

    function canBeSelected(code) {
      return $filter('isFindOnMapType')($scope.$parent.question) &&
        !$scope.$parent.canNext &&
        $filter('isAllowedOption')($scope.$parent.question, code);
    }

    function setHoverColor(path, lower) {
        var code = path && path.data && path.data('code');
        if (code && (!$scope.practice || canBeSelected(code))) {
          var paths = (pathsByCode[code] || []).concat(
              highlightsByCode[code] || []);
          for (var i = 0; i < paths.length; i++) {
            var attr = getHoverAttr(paths[i], lower);
            paths[i].attr(attr);
          }
        }
    }

    function getHoverAttr(path, lower) {
      var attr;
      var color = path.data('highlight-color') || path.data('color');
      var strokeColor = path.data('highlight-color') || path.data('stroke-color');
      if (lower) {
        attr = {
          'fill' : chroma(color).darken().hex(),
          'stroke' : strokeColor && chroma(strokeColor).darken().hex(),
          'cursor' : 'pointer',
        };
      } else {
        attr = {
          'fill' : color,
          'stroke' : strokeColor,
          'cursor' : 'default',
        };
      }
      return attr;
    }

    function getBBox(bboxes) {
      var xs = bboxes.map(function(b){return b.x;});
      var minX = Math.min.apply(Math, xs);
      var ys = bboxes.map(function(b){return b.y;});
      var minY = Math.min.apply(Math, ys);
      var x2s = bboxes.map(function(b){return b.x2;});
      var maxX = Math.max.apply(Math, x2s);
      var y2s = bboxes.map(function(b){return b.y2;});
      var maxY = Math.max.apply(Math, y2s);
      return {
        x : minX,
        y : minY,
        width : maxX - minX,
        height : maxY - minY,
      };
    }


    for (var i = 0; i < image.paths.length; i++) {
      var p = image.paths[i];
      var simplePathString = p.d;
      var path = r.path(simplePathString);
      var color = colorService.toGrayScale(p.color);
      var strokeColor = p.stroke && colorService.toGrayScale(p.stroke);
      path.attr({
        'fill' : color,
        'opacity' : p.opacity,
        'stroke-width' : p.stroke_width,
        'stroke' : strokeColor,
      });
      path.data('id', p.id);
      path.data('color', color);
      path.data('stroke-color', strokeColor);
      path.data('opacity', p.opacity);
      path.click(clickHandler);
      path.hover(hoverInHandler, hoverOutHandler);
      p.bbox = p.bbox || path.getBBox();
      paths.push(path);
      rPathsObj[p.id] = path;
      var code = p.term;
      path.data('code', code);
      if (!pathsByCode[code]) {
        pathsByCode[code] = [];
      }
      pathsByCode[code].push(path);
      pathsObj[p.id] = p;
    }

    image.bbox = image.bbox || getBBox(image.paths.map(function(p) {
      p.bbox.x2 = p.bbox.x + p.bbox.width;
      p.bbox.y2 = p.bbox.y + p.bbox.height;
      return p.bbox;
    }));

    function setTermsConteinerHeight(screenAspectRatio) {
      if (!$scope.practice) {
        var height;
        if (screenAspectRatio < 1) {
          height = $window.innerHeight * 0.7;
        } else {
          height = ($window.innerHeight / 2) - 40;
        }
        angular.element('.terms-container').css('max-height', height + 'px');
      }
    }

    function getHorizontalViewDimensions(paper){
      var imageOfWindowWidthRatio = 0.7;
      if ($scope.practice) {
        var headerHeight = angular.element('.header-practice').height() || 0;
        headerHeight += angular.element('#nav-main').height() || 0;
        headerHeight -= Math.min(60, angular.element($window).scrollTop());
        var alertHeight = angular.element('.beta-alert').outerHeight() ||
          angular.element('.bottom-alert').outerHeight() || 0;
        paper.height = $window.innerHeight - (25 + headerHeight + alertHeight);
        paper.width = $window.innerWidth  * 0.7 - 20;
      } else {
        paper.height = $window.innerHeight * 0.7 - 90;
        paper.width = $('.panel-body').innerWidth() * imageOfWindowWidthRatio - 40;
      }
      return paper;
    }

    function onWidowResize(){
      angular.element('body').removeClass('horizontal');
      var screenAspectRatio = $window.innerHeight / $window.innerWidth;

      if (screenAspectRatio < 1 && $window.innerWidth > 600) {
        angular.element('body').addClass('horizontal');
        paper = getHorizontalViewDimensions(paper);
      } else {
        paper.height = ($window.innerHeight / 2) * ($scope.relativeHeight || 1);
        paper.width = $window.innerWidth - ($scope.practice ? 35 : 75);
      }
      setTermsConteinerHeight(screenAspectRatio);

      r.setSize(paper.width, paper.height);
      r.setViewBox(image.bbox.x, image.bbox.y, image.bbox.width, image.bbox.height, true);
    }
    onWidowResize();
    angular.element($window).bind('resize', function() {
      onWidowResize();
    });
    if ($scope.practice) {
      angular.element("html, body").animate({
        scrollTop: (angular.element('.navbar').height() - 8) + "px"
      }, function() {
        onWidowResize();
      });
    }

    return that;
  };

  $scope.$watch('code', function(value) {
    if (value) {
      imageService.getImage(function(i) {
        if (typeof i == 'string') {
          $scope.alert = i;
        } else {
          return initImage(i);
        }
      });
    }
  });
}]);

angular.module('proso.anatomy.controllers')

.controller('imageGeneratorController', ['$scope', '$rootScope', 'contextService', 'imageService',
    function($scope, $rootScope, contextService, imageService) {
  'use strict';
    contextService.getAllContexts().then(function(data) {
      $scope.contexts = data.data.data;
      $scope.contexts.forEach(function(context) {
        contextService.getContext(context.id).then(function(data) {
          context.content = data.content;
          imageService.setImage(context.content, function() {
            $rootScope.$emit('imageDisplayed', context.identifier, true);
          });
        });
      });
    });
}]);



angular.module('proso.anatomy.controllers')

.controller('imageModalController', ['$scope', '$rootScope', '$modal', '$routeParams',
        function ($scope, $rootScope, $modal, $routeParams) {

    $scope.openModal = function(config) {

        var modalInstance = $modal.open({
            templateUrl: '/static/tpl/image_modal.html',
            controller: 'imageModalInstanceController',
            size: 'lg',
            resolve: {
                data: function () {
                  return {
                    contextId: config.contextId,
                    context: $scope.context,
                    contexts: $scope.contexts,
                    category: $scope.category,
                  };
                },
            }
        });
        modalInstance.result.then(function () {
        }, function () {
          if ($scope.context) {
            $scope.context = undefined;
            $scope.openAction(undefined);
          }
        });
    }; 

    $scope.$on('$routeChangeSuccess', function() {
      if ($routeParams.contextmodal) {
        $scope.openModal({contextId: $routeParams.contextmodal});
      }
    });

    $scope.$watch('context', function() {
      if ($scope.context) {
        $scope.openModal({});
      }
    });
}]);

angular.module('proso.anatomy.controllers')

.controller('imageModalInstanceController', ['$scope', '$modalInstance', 'data', 'contextService', '$location',
    function ($scope, $modalInstance, data, contextService, $location) {
  $scope.contextId = data.contextId || data.context.identifier;
  $scope.context = data.context;
  $scope.contexts = data.contexts || [];
  $scope.category = data.category;
  
  prefetchContext(+1);

  $scope.close = function() {
    $modalInstance.dismiss('cancel');
  };

  $scope.setNextContext = function(n) {
    var nextContext = getNextContext(n);
    $scope.context = nextContext;
    $scope.contextId = nextContext.identifier;
    setPath();
    prefetchContext(n * 2);
  };

  function setPath() {
    if ($scope.category) {
      $location.update_path('/view/' + $scope.category.identifier +
        ($scope.context ? '/image/' + $scope.context.identifier : ''));
    }
  }

  function getNextContext(n) {
   return $scope.contexts[($scope.contexts.indexOf($scope.context) + n + $scope.contexts.length) % $scope.contexts.length];
  }

  function prefetchContext(n) {
    var context = getNextContext(n);
    contextService.getContextByIdentifier(context.identifier);
  }

}]);


angular.module('proso.anatomy.controllers')

.controller('imageViewController', ['$scope', '$routeParams', 'contextService', 'imageService', 'flashcardService', 'colorScale', 'userService',
    function($scope, $routeParams, contextService, imageService, flashcardService, colorScale, userService) {
  'use strict';
  $scope.contextId = $scope.contextId || $routeParams.context;
  $scope.userService = userService;


  $scope.$watch('contextId', function() {
    if ($scope.contextId) {
      $scope.context = undefined;

      contextService.getContextByIdentifier($scope.contextId).then(function(data) {
        $scope.context = data;
        if ($scope.stats) {
          $scope.context.stats = $scope.stats;
        }
      });
    }
  });

  $scope.$watch('context', function() {
    if ($scope.context) {
      imageService.setImage($scope.context.content, function(ic) {
        var filter = {
          filter : [
              ['context/' + $scope.contextId],
          ],
          stats : true,
          user : $routeParams.user,
        };
        if ($scope.category) {
          filter.filter.push(['category/' + $scope.category.identifier]);
        }
        $scope.imageController = ic;
        if ($scope.category && $scope.context.stats.number_of_items != $scope.context.flashcards.length) {
          $scope.context.flashcards = [];
        }
        flashcardService.getFlashcards(filter).then(function(data) {
          $scope.context.flashcards = data;
          for (var i = 0; i < $scope.context.flashcards.length; i++) {
            var fc = $scope.context.flashcards[i];
            $scope.imageController.setColor(fc.description, colorScale(fc.prediction).hex());
          }
          if (!$scope.context.stats) {
            computeStats($scope.context); 
          }
        });
      });
    }
  });

  function computeStats(context) {
    context.stats = {
      number_of_items : context.flashcards.length,
      number_of_practiced_items : context.flashcards.filter(function(fc) {
        return fc.practiced;}).length,
      number_of_mastered_items : context.flashcards.filter(function(fc) {
        return fc.mastered;}).length,
    };
  }
}]);


angular.module('proso.anatomy.controllers')

.controller('mainController', ['$scope', '$rootScope', 'userService', 'pageTitle', 'configService', 'gettextCatalog', '$location', 'categoryService', 'termsLanguageService',
    function($scope, $rootScope, userService, pageTitle, configService, gettextCatalog, $location, categoryService, termsLanguageService) {
  'use strict';
  $scope.configService = configService;
  $rootScope.userService = userService;
  $rootScope.$location = $location;

  $rootScope.initTitle = function (title) {
      $rootScope.initialTitle = title;
      $rootScope.title = title;
  };

  $rootScope.$on("$routeChangeStart", function(event, next) {
    categoryService.getAllByType().then(function(){
      $rootScope.title = pageTitle(next, $rootScope.initialTitle);
    });
  });

  $scope.initLanguageCode = function (code) {
      gettextCatalog.setCurrentLanguage(code);
      $rootScope.LANGUAGE_CODE = code;
      termsLanguageService.init(code);
  };
  if ($location.search().sessionid) {
    userService.loadUser();
    $location.search('sessionid', undefined);
  } else {
    $scope.initUser = function (data) {
        userService.processUser(data);
    };
  }

  $scope.setStats = function(stats) {
      $rootScope.stats = stats;
  };

  $scope.logout = function() {
      $rootScope.user = userService.logout();
  };
}]);

angular.module('proso.anatomy.controllers')

.controller('overviewController', ['$scope', '$routeParams', 'categoryService', 'userStatsService', 'gettextCatalog', '$cookies', '$filter', '$location', 'userService',
    function($scope, $routeParams, categoryService, userStatsService, gettextCatalog, $cookies, $filter, $location, userService) {
  'use strict';

  $scope.absUrl = $location.absUrl();
  var overviewType = $location.path().split('/')[1];
  var activeTypeCookieName = overviewType + 'activeType';
  var selectedCategoriesCookieName = overviewType + 'selectedCategoires';
  if (overviewType == 'overview') {
    $scope.viewPath = 'view';
    $scope.practicePath = '/practice/';
    $scope.disabled = false;
    $scope.allCategory = 'images';
    $scope.defaultTab = 'system';
    $scope.secondTab = 'location';
    $scope.headline = gettextCatalog.getString("Přehled znalostí");
  } else {
    $scope.viewPath = 'relations';
    $scope.practicePath = '/practice/relations/';
    $scope.disabled = !userService.user.profile || !userService.user.profile.subscribed;
    $scope.allCategory = 'relations';
    $scope.defaultTab = 'relation';
    $scope.secondTab = 'location';
    $scope.headline = gettextCatalog.getString("Souvislosti");
  }

  $scope.activateCatType = function(categoryType) {
    angular.forEach($scope.categoriesByType, function(ct) {
      ct.isActive = ct == categoryType;
    });
    $cookies.put(activeTypeCookieName, categoryType.categories[0] && categoryType.categories[0].type);
  };

  $scope.toggleSelectedCategories = function(selected) {
    angular.forEach($scope.categories, function(c) {
      c.selected = selected;
    });
    $scope.saveSelectedCategoriesToCookie();
  };

  $scope.saveSelectedCategoriesToCookie = function() {
    var selected = $filter('getSelectedIdentifiers')($scope.categories);
    $cookies.put(selectedCategoriesCookieName, selected);
  };

  function isActive(categoryType) {
    if ($routeParams.tab && $routeParams.tab != $cookies.get('activeTypeCookieName')){
      $cookies.put(activeTypeCookieName, $routeParams.tab);
    }
    return $cookies.get(activeTypeCookieName) == categoryType ||
      (categoryType == $scope.defaultTab && !$cookies.get(activeTypeCookieName));
  }

  $scope.user = $routeParams.user || '';
  categoryService.getAllByType().then(function(categoriesByType){
      $scope.categories = categoriesByType.system.concat(
        categoriesByType.location).concat(categoriesByType.relation);
      $scope.categoriesByType = [ {
        name: gettextCatalog.getString('Části těla'),
        categories : categoriesByType.location,
        isActive : isActive('location'),
      }];
      if ($location.path().indexOf('relations') === -1) {
        $scope.categoriesByType.unshift({
          name: gettextCatalog.getString('Orgánové systémy'),
          categories : categoriesByType.system,
          isActive : isActive('system'),
        });
      } else {
        $scope.categoriesByType.unshift({
          name: gettextCatalog.getString('Souvislosti'),
          categories : categoriesByType.relation,
          isActive : isActive('relation'),
        });
      }
      userStatsService.clean();
      userStatsService.addGroup('all', []);
      userStatsService.addGroupParams('all', [['category/' + $scope.allCategory]]);
      for (var i = 0; i < $scope.categories.length; i++) {
        var cat = $scope.categories[i];
        var id = cat.identifier;
        userStatsService.addGroup(id, {});
        userStatsService.addGroupParams(id, [
          ['category/' + $scope.allCategory],
          ['category/' + cat.identifier]]);

        cat.selected = ($cookies.get(selectedCategoriesCookieName) + '').indexOf(id) != -1;
      }

      userStatsService.getStatsPost(true, $scope.user).success(processStats);

      function processStats(data) {
        $scope.userStats = data.data;
        $scope.stats = {};
        angular.forEach($scope.categories, function(map) {
          map.placeTypes = [];
          var key = map.identifier;
          map.stats = data.data[key];
        });
        $scope.stats = data.data.all;
        $scope.statsLoaded = true;
      }
  }, function(){
    $scope.error = true;
  });
}]);

angular.module('proso.anatomy.controllers')

.controller('practiceController', ['$scope', '$routeParams', '$timeout', '$filter', '$rootScope',
    'practiceService', 'userService', 'imageService', 'termsLanguageService',
    'contextService',
    function($scope, $routeParams, $timeout, $filter, $rootScope,
        practiceService, userService, imageService, termsLanguageService,
        contextService) {
        'use strict';

        $scope.categoryId = $routeParams.category;
        $scope.category2Id = $routeParams.category2;
        $scope.progress = 0;

        var controller = {
          highlight : function() {
            $scope.imageController.highlightQuestion($scope.question);
          },
          getFlashcardByDescription : function(description) {
            if ($scope.question.context.flashcards) {
              //TODO fix this
              for (var i = 0; i < $scope.question.context.flashcards.length; i++) {
                var fc = $scope.question.context.flashcards[i];
                if (fc.description == description) {
                  return fc;
                }
              }
            }
          },
          checkAnswer : function(selected, keyboardUsed) {
              if ($scope.checking) {
                return;
              }
              $scope.checking = true;

              var selectedFC;
              if (selected && (selected.description || selected.term_secondary)) {
                selectedFC = selected;
                selected = selected.description;
              }
              $scope.question.selectedFC = selectedFC;
              $scope.question.isCorrect = (selected && $scope.question.description == selected) || $scope.question.id == (selectedFC && selectedFC.id);
              saveAnswer(selected, keyboardUsed, selectedFC);
              controller._postProcessAnswer(selected, keyboardUsed);
          },
          _postProcessAnswer : function(selected) {
              if ($scope.imageController) {
                $scope.imageController.highlightAnswer($scope.question, selected);
              }
              $scope.progress = 100 * (
                practiceService.getSummary().count /
                practiceService.getConfig().set_length);
              if ($scope.question.isCorrect) {
                  $timeout(function() {
                      controller.next(function() {
                        $scope.checking = false;
                      });
                  }, 700);
              } else {
                  $scope.checking = false;
                  $scope.canNext = true;
              }
              addAnswerToUser($scope.question.isCorrect);
              $rootScope.$emit('questionAnswered');
          },
          next : function(callback) {
              if ($scope.progress < 100) {
                  $scope.loadingNextQuestion = true;
                  practiceService.getQuestion().then(function(q) {
                      $scope.loadingNextQuestion = false;
                      q.payload.question_type = q.question_type;
                      setQuestion(q.payload);
                      if (callback) callback();
                  }, function(){
                      $scope.loadingNextQuestion = false;
                      $scope.error = true;
                  });
              } else {
                  setupSummary();
                  if (callback) callback();
              }
          },
          highlightFlashcard : function(fc) {
            $scope.activeQuestion = fc;
          },
        };
        $scope.controller = controller;


        function saveAnswer(selected, keyboardUsed, selectedFC) {
          $scope.question.answered_code = selected;
          $scope.question.answered_term_secondary = selectedFC && selectedFC.term_secondary;
          $scope.question.responseTime = new Date().valueOf() - $scope.question.startTime;
          var isCorrect = $scope.question == selected;
          if (!selectedFC) {
            selectedFC = isCorrect ?
              $scope.question :
              controller.getFlashcardByDescription(selected);
          }
          var meta;
          if (keyboardUsed) {
            meta = {keyboardUsed: keyboardUsed};
          }
          practiceService.saveAnswerToCurrentQuestion(
            selectedFC && selectedFC.id, $scope.question.responseTime, meta);
        }

        function addAnswerToUser(isCorrect) {
          if (userService.user.profile) {
            userService.user.profile.number_of_answers++;
            if (isCorrect) {
              userService.user.profile.number_of_correct_answers++;
            }
          }
        }

        function setupSummary() {
            $scope.question.slideOut = true;
            $scope.showSummary = true;
            angular.element("html, body").animate({ scrollTop: "0px" }, function() {
              angular.element(window).trigger('resize');
            });
            $rootScope.$emit('questionSetFinished');
        }

        function setQuestion(active) {
            if ($scope.question) {
                $scope.question.slideOut = true;
            }
            $scope.question = active;
            $scope.activeQuestion = active;
            $scope.question.startTime = new Date().valueOf();
            $scope.questions.push(active);
            active.context.content = angular.fromJson(active.context.content);

            if (active.context.content.paths) {
              $scope.canNext = false;
              imageService.setImage(active.context.content, setImageCallback);
            } else if (active.additional_info) {
              active.additional_info = angular.fromJson(active.additional_info);
              var contextId = active.additional_info.contexts[active.question_type];
              if (contextId) {
                contextService.getContextByIdentifier(contextId).then(function(context) {
                  context.content = angular.fromJson(context.content);
                  $scope.canNext = false;
                  imageService.setImage(context.content, setImageCallback);
                });
              } else {
                imageService.setImage(undefined, function(){});
              }
            }

            function setImageCallback(ic) {
              if (ic) {
                $scope.imageController = ic;

                $scope.imageController.clearHighlights();
                controller.highlight();

                $scope.imageController.onClick(function(code) {
                    if ($filter('isFindOnMapType')($scope.question) &&
                        !$scope.canNext &&
                        $filter('isAllowedOption')($scope.question, code)) {

                        controller.checkAnswer(code);
                        $scope.$apply();
                    }
                });
              }
            }
        }

        function categoryToFilter(c) {
          return c.split('-').map(function(c) {
            return 'category/' + c;
          });
        }

        $scope.mapCallback = function() {
            practiceService.initSet($routeParams.config || 'common');
            var filter = {
              filter: [],
            };
            if ($routeParams.category) {
              filter.filter.push(categoryToFilter($routeParams.category));
            }
            if ($routeParams.category2) {
              filter.filter.push(categoryToFilter($routeParams.category2));
            }
            if ($routeParams.context) {
                filter.filter.push(['context/' + $routeParams.context]);
            }
            if (!(userService.user.profile && userService.user.profile.subscribed) &&
                $scope.categoryId != 'relations') {
              filter.filter.push(['category/images']);
            }
            filter.language = termsLanguageService.getTermsLang();
            practiceService.setFilter(filter);
            practiceService.getQuestion().then(function(q) {
                $scope.questions = [];
                q.payload.question_type = q.question_type;
                setQuestion(q.payload);

            }, function(){
                $scope.error = true;
            });

        };
        $scope.mapCallback();
  }]);

angular.module('proso.anatomy.controllers')

.controller('premiumController', ['$scope', 'userService', 'subscriptionService', 'smoothScroll', '$routeParams', 'gettextCatalog',
    function($scope, userService, subscriptionService, smoothScroll, $routeParams, gettextCatalog){
  $scope.userService = userService;
  $scope.discountCode = $routeParams.discount_code;
  $scope.discountCodeInput = $routeParams.discount_code;
  $scope.isSubscribed = subscriptionService.isSubscribed;

  var errorMessages = {
    'discount_code_limit_exceeded' : gettextCatalog.getString(
      "Zadaný slevový kód byl již použit maximálním počtem uživatelů."),
    'discount_code_already_used' : gettextCatalog.getString(
      "Zadaný slevový kód nemůžež použít podruhé."),
  };

  subscriptionService.getPlans($routeParams.discount_code).success(function(data) {
    $scope.plans = data.data;
    loadDiscountCodeUsage();
  }).error(function(data, status) {
    if ($routeParams.discount_code && status == 404) {
      $scope.error = gettextCatalog.getString(
        "Byl zadán neplatný slevový kód '{{discountCode}}'.", $scope);
    } else if ($routeParams.discount_code && status == 400) {
      $scope.error = errorMessages[data.error_type];
    } else {
      $scope.error = true;
    }
  }).finally(scrollToPlans);


  function scrollToPlans() {
    if ($routeParams.discount_code) {
      var elem = document.getElementById("plans");
      smoothScroll(elem, {
        offset: 10,
        duration: 200,
      });
    }
  }

  function loadDiscountCodeUsage() {
    if ($routeParams.discount_code) {
      subscriptionService.getDiscountCode($routeParams.discount_code).success(function(data) {
        $scope.discountCodeUsage = data.data;
        $scope.discountCodeUsage.usage_left = Math.max(0,
          $scope.discountCodeUsage.usage_limit - $scope.discountCodeUsage.usage);
      });
    }
  }

  $scope.buyPlan = function(plan) {
    subscriptionService.buyPlan(plan,
      $routeParams.discount_code,
      $routeParams.referral_username);
  };
}]);

angular.module('proso.anatomy.controllers')

.controller('relationsController', ['$scope',  '$routeParams', 'categoryService', 'contextService', 'userStatsService', 'flashcardService',
    function($scope, $routeParams, categoryService, contextService, userStatsService, flashcardService) {
  $scope.user = $routeParams.user || '';
  var category = 'relations';
  var subcategory;

  var filter = {
      filter : [['category/' + category]],
  };

  if ($routeParams.category) {
      subcategory = $routeParams.category;
      filter.filter.push(['category/' + $routeParams.category]);
  }

  categoryService.getAllByType().then(function(){
    $scope.category = categoryService.getCategory(category);
    if (subcategory) {
      $scope.subcategory = categoryService.getCategory(subcategory);
    }

    $scope.subcategories = categoryService.getSubcategories(
      (subcategory == 'foramina') ?
      subcategory :
      category);

    flashcardService.getFlashcards(
            angular.extend(filter, {with_contexts:true})).then(function(data) {
        $scope.flashcards = data;
        $scope.parseRelations();

        flashcardService.getFlashcards(
            angular.extend(filter, {stats:true})).then(function(data) {
          $scope.flashcards = data;
          $scope.flashcards.forEach(function(fc) {
            var originalFc = $scope.flashcardsById[fc.id];
            if (originalFc) {
              originalFc.prediction = fc.prediction;
              originalFc.practiced = fc.practiced;
              originalFc.mastered = fc.mastered;
            }
          });
          makeRelationsStats();
        });
    });
  });

  function makeRelationsStats() {
    $scope.relations.forEach(function(relation) {
      var mastered = 0;
      var practiced = 0;
      var total = 0;
      for (var i = 0; i < $scope.subcategories.length; i++) {
        var c = $scope.subcategories[i].identifier;
        if (!relation[c]) {
          continue;
        }
        for (var j = 0; j < relation[c].length; j++) {
          mastered += relation[c][j].mastered;
          practiced += relation[c][j].practiced;
          total++;
        }
      }
      relation.stats = {
        number_of_practiced_items: practiced,
        number_of_mastered_items: mastered,
        number_of_items: total
      };
    });
  }

  $scope.parseRelations = function() {
    var relationsByMuscle = {};
    $scope.flashcardsById = {};
    $scope.flashcards.forEach(function(fc) {
      var relationsObj = relationsByMuscle[fc.term.identifier] || {};
      relationsObj.primaryTerm = fc.term;
      relationsObj[fc.context.identifier] = relationsObj[fc.context.identifier] || [];
      var fc_secondary = angular.copy(fc);
      fc_secondary.term = fc_secondary.term_secondary;
      relationsObj[fc.context.identifier].push(fc_secondary);
      relationsByMuscle[fc.term.identifier] = relationsObj;
      $scope.flashcardsById[fc_secondary.id] = fc_secondary;
    });
    $scope.relations = [];
    for (var i in relationsByMuscle) {
      $scope.relations.push(relationsByMuscle[i]);
    }
    $scope.relations = $scope.relations.sort(function(a, b) {
      return a.primaryTerm.name < b.primaryTerm.name ? -1 : 1;
    });
  };

  $scope.activateRelation = function(relation) {
    if ($scope.user) {
      return;
    }
    $scope.activeRelation = $scope.activeRelation !== relation ? relation : undefined;
  };

  var catId = category;
  userStatsService.clean();
  userStatsService.addGroup(catId, {});
  userStatsService.addGroupParams(catId, filter.filter);
  userStatsService.getStatsPost(true, $scope.user).success(function(data) {
    $scope.stats = data.data[catId];
  });

  $scope.rowsLimit = 30;
  $scope.addRows = function() {
    if ($scope.relations && $scope.rowsLimit < $scope.relations.length) {
      $scope.rowsLimit += 30;
    }
  };
}]);

angular.module('proso.anatomy.controllers')

.controller('relationsModalController', [
    '$scope', '$rootScope', '$modal', '$routeParams', 'userService',
    function ($scope, $rootScope, $modal, $routeParams, userService) {
  $scope.openModal = function() {
    $modal.open({
      templateUrl: '/static/tpl/relations_modal.html',
      size: 'md',
    });
  }; 

  $scope.$on('$routeChangeSuccess', function() {
    if ($routeParams.relationsmodal) {
      $scope.openModal();
    }
  });

  $rootScope.$on('questionSetFinished', function() {
    var showNumberOfAnswers = 30;
    var shouldShow = !userService.status.loading &&
      !userService.user.profile.subscribed &&
      userService.user.profile.number_of_answers >= showNumberOfAnswers && 
      userService.user.profile.number_of_answers < showNumberOfAnswers + 10;
    if (shouldShow) {
      $scope.openModal();
    }
  });
}]);


angular.module('proso.anatomy.controllers')

.controller('reloadController', ['$window', function($window){
    'use strict';
    $window.location.reload();
}]);

angular.module('proso.anatomy.controllers')

.controller('settingsController', ['$scope', 'userService', 'configService', 'customConfigService', 'gettextCatalog',
    function($scope, userService, configService, customConfigService, gettextCatalog) {
  var keys = {
    targetDifficulty: "item_selector.parameters.target_probability",
    setLength: 'practice.common.set_length',
    allowOpenQuestions: "options_count.parameters.allow_zero_options",
    forbidWriting: "options_count.parameters.allow_zero_options_restriction",
  };
  $scope.form = {
    targetDifficulty: configService.getConfig("proso_models", keys.targetDifficulty, 65),
    questionType: getQuestionType(),
    setLength: configService.getConfig("proso_models", keys.setLength, 10),
  };
  console.log($scope.form);
  $scope.user = userService.user;

  $scope.save = function() {
    $scope.message = gettextCatalog.getString('Ukládání změn...');
    $scope.messageType = 'info';

    customConfigService.setConfig({
      app_name: 'proso_models',
      key : keys.targetDifficulty,
      value: $scope.form.targetDifficulty,
    });

    customConfigService.setConfig({
      app_name: 'proso_models',
      key : keys.setLength,
      value: $scope.form.setLength,
    });

    customConfigService.setConfig({
      app_name: 'proso_models',
      key : keys.allowOpenQuestions,
      value: $scope.form.questionType != 'options-only',
    });

    customConfigService.setConfig({
      app_name: 'proso_models',
      key : keys.forbidWriting,
      value: $scope.form.questionType != 'all',
    }).success(function () {
      $scope.message = gettextCatalog.getString('Nastavení bylo uloženo.');
      $scope.messageType = 'success';
    }).error(function () {
      $scope.message = gettextCatalog.getString('Ukládání nastavení selhalo.');
      $scope.messageType = 'danger';
    });
  };

  function getQuestionType() {
    var allowOpenQuestions = configService.getConfig("proso_models", keys.allowOpenQuestions);
    var forbidWriting = configService.getConfig("proso_models", keys.forbidWriting);
    if (allowOpenQuestions === false) {
      return 'options-only';
    } else if (forbidWriting === true) {
      return 'no-write';
    } else {
      return 'all';
    }
  }
}]);

angular.module('proso.anatomy.controllers')

.controller('shareController', ['$scope', '$modalInstance', 'loginModal', 'userService', 'gettextCatalog', '$analytics', '$location', '$window', 'data',
    function ($scope, $modalInstance, loginModal, userService, gettextCatalog, $analytics, $location, $window, data) {

  $scope.credentials = {};
  $scope.alerts = [];
  $scope.title = data.shareTitle;
  $scope.url = data.shareUrl;
  $scope.demoTitle = data.shareDemoTitle;

  $scope.cancel = function () {
      $modalInstance.dismiss('cancel');
  };

  $scope.openSharePage = function(site) {
    var siteUrls = {
      facebook : "https://www.facebook.com/sharer/sharer.php?u=",
      twitter : "http://twitter.com/home?status=",
      google : "https://plus.google.com/share?url=",
      demo : "",
    };
    if (userService.user.username) {
      var shareUrl = siteUrls[site] + data.shareUrl;
      $window.open(shareUrl, "_blank");
    } else {
      loginModal.open();
    }
  };

  $scope.closeAlert = function(index) {
      $scope.alerts.splice(index, 1);
  };
}]);

angular.module('proso.anatomy.controllers')

.controller('termLabelController', ['$scope', '$element', 'colorScale', 'gettextCatalog',
    function($scope, $element, colorScale, gettextCatalog) {
    'use strict';
  $element.addClass('label');
  $element.addClass('label-default');
  $scope.$watch('flashcard.prediction', update);

  function update() {
    $element.css('border-bottom', '5px solid #777');
    if ($scope.flashcard.prediction) {
      $element.css('border-bottom', '5px solid ' + 
        colorScale(Math.ceil(10 * $scope.flashcard.prediction) / 10).hex());
      if ($scope.flashcard.practiced) {
        $element.css('border-left', '5px solid #fe3');
      }
      if ($scope.flashcard.mastered) {
        $element.css('border-left', '5px solid #5ca03c');
      }
      var alternativeNames = $scope.flashcard.term.name.split(';').splice(1).join('<br>');
      $element.tooltip({
        html : true,
        placement: 'bottom',
        container: 'body',
        title : ($scope.flashcard.term_secondary && $scope.flashcard.context ?
             '<div>' +
               $scope.flashcard.context.name + ': ' +
               '<strong>' + $scope.flashcard.term_secondary.name + '</strong>' +
             '</div><br>':
             '') +
              '<div class="skill-tooltip">' +
              gettextCatalog.getString('Odhad znalosti') +
              ' <span class="badge badge-default">' +
                '<i class="color-indicator" style="background-color :' +
                colorScale(Math.ceil(10 * $scope.flashcard.prediction) / 10).hex() + '"></i>' +
                (Math.ceil(10 * $scope.flashcard.prediction)) + ' / 10 ' +
              '</span>' +
             '</div>' +
             (alternativeNames ?
             '<div>' +
              gettextCatalog.getString('Alternativní názvy') +
              ':<br> <strong>' + alternativeNames + '</strong>' +
             '</div>':
             ''),
      });
    }
  }
  update();
}]);


angular.module('proso.anatomy.controllers')

.controller('tileController', ['$scope', '$element', '$timeout', 'thumbnailService',
    function($scope, $element, $timeout, thumbnailService) {
    'use strict';
  $element.bind("mouseover", wasHovered);
  $element.bind("touchstart", wasHovered);

  function wasHovered(){
    if (!$scope.wasHovered) {
      $scope.$apply(function () {
        $scope.wasHovered = true;
      });
    }
  }

  $scope.clickFn = function(event) {
    if ($scope.clickAction) {
      $scope.clickAction($scope.category);
      event.preventDefault();
    }
  }; 

  $scope.bigThumbnail = $scope.thumbnailPath + $scope.category.identifier + '.png';
  $scope.thumbnail = thumbnailService.getThumbnail($scope.bigThumbnail);

  var img  = new Image();
  img.src = $scope.bigThumbnail;
  img.onload = function() {
    $scope.thumbnail = $scope.bigThumbnail;
  };

  $timeout(function() {
    $scope.showProgress = true;
  }, $scope.index * 100 + 1000);
}]);


angular.module('proso.anatomy.controllers')

.controller('userController', ['$scope', 'userService', '$routeParams',
    '$timeout', 'gettextCatalog',
    function($scope, userService, $routeParams, $timeout, gettextCatalog) {

  $scope.isOwnProfile = !$routeParams.user || $routeParams.user == userService.user.username;
  if ($scope.isOwnProfile) {
    $scope.user = userService.user;
    $scope.editRights = true;
    if ($routeParams.edit !== undefined && $scope.editRights) {
      $timeout(function() {
        $scope.editableForm.$show();
      },10);
    }
  } else {
    $scope.user = {username: $routeParams.user};
    userService.getUserProfile($routeParams.user, true).success(function(response){
      $scope.user = response.data;
    }).error(function() {
      $scope.error = gettextCatalog.getString("Hledaný profil neexistuje.");
      console.error($scope.error);
    });
  }

  $scope.saveUser = function() {
    // $scope.user already updated!
    return userService.updateProfile($scope.user).error(function(err) {
      if(err.field && err.msg) {
        // err like {field: "name", msg: "Server-side error for this username!"}
        $scope.editableForm.$setError(err.field, err.msg);
      } else {
        // unknown error
        $scope.editableForm.$setError('name', gettextCatalog.getString("V aplikaci bohužel nastala chyba."));
      }
    });
  };
}]);

angular.module('proso.anatomy.controllers')

.controller('viewController', ['$scope', '$routeParams', 'contextService', 'categoryService', 'userStatsService', '$cookies', '$location', '$rootScope',
    function($scope, $routeParams, contextService, categoryService, userStatsService, $cookies, $location, $rootScope) {
  'use strict';
  $scope.user = $routeParams.user || '';

  var filter = {
      filter : [ $routeParams.category ? ['category/' + $routeParams.category] : []],
  };
  filter.filter.push(['category/images']);

  categoryService.getAllByType().then(function(){
    $scope.category = categoryService.getCategory($routeParams.category);
    $scope.subcategories = categoryService.getSubcategories($routeParams.category);
  }, function() {
    $scope.error = true;
  });

  contextService.getContexts(filter).then(function(data) {
    $scope.contexts = data;

    userStatsService.clean();
    for (var i = 0; i < data.length; i++) {
      var context = data[i];
      var id = context.identifier;
      userStatsService.addGroup(id, {});
      userStatsService.addGroupParams(id, filter.filter.concat([['context/' + id]]));
    }
    userStatsService.getStatsPost(true, $scope.user).success(function(data) {
      angular.forEach($scope.contexts, function(context) {
        context.placeTypes = [];
        var id = context.identifier;
        context.stats = data.data[id];
      });
        if ($routeParams.context) {
          var context = $scope.contexts.filter(function(c) {
            return c.identifier == $routeParams.context;
          })[0];
          if (context) {
            $scope.activateContext(context);
          } else {
            $location.path($location.path().replace(
              '/view/' + $routeParams.category, ''));
          }
        }
    });
  }, function() {
    $scope.error = true;
  });

  if ($routeParams.user == 'average') {
    filter.new_user_predictions = true;
  }

  var catId = $routeParams.category;
  userStatsService.clean();
  userStatsService.addGroup(catId, {});
  userStatsService.addGroupParams(catId, filter.filter);
  userStatsService.getStatsPost(true, $scope.user).success(function(data) {
    $scope.stats = data.data[catId];
  });

  $scope.activateContext = function(context) {
    if ($scope.user) {
      return;
    }
    $scope.activeContext = $scope.activeContext !== context ? context : undefined;
    $location.update_path('/view/' + $routeParams.category +
      ($scope.activeContext ? '/image/' + $scope.activeContext.identifier : ''));
    var contextName = $scope.activeContext ? context.name + ' - ' : '';
    setTimeout(function() {
      $rootScope.title = contextName + $rootScope.title;
    }, 10);
  };

  $scope.usePracticeDwopdown = function() {
    $cookies.put('practiceDropdownUsed', true);
  };
}]);

/* Directives */
angular.module('proso.anatomy.directives', ['proso.anatomy.templates'])

  .directive('termLabel', [function() {
    return {
      restrict : 'A',
      template : '{{flashcard.term.name}}',
      controller : 'termLabelController',
    };
  }])

.directive('anatomyImage', [function() {
  return {
      restrict: 'A',
      scope: {
          code: '=code',
          practice: '=practice',
      },
      controller : 'anatomyImageController',
      template: '<div class="alert alert-info" ng-if="alert">{{alert}}</div>',
  };
}])

  .directive('email', function() {
    return {
      restrict : 'C',
      compile : function(elem) {
        var emailAddress = elem.html();
        emailAddress = emailAddress.replace('{zavinac}', '@');
        emailAddress = '<a href="mailto:' + emailAddress +
  '">' + emailAddress +
  '</a>';
        elem.html(emailAddress);
      }
    };
  })

  .directive('categoryProgress', [function() {
    return {
      restrict : 'A',
      templateUrl : 'static/tpl/progress_tpl.html',
      scope : {
        skills : '=skills',
        hideLabels : '=hideLabels',
      },
    };
  }])

  .directive('progressLabels', [function() {
    return {
      restrict : 'A',
      templateUrl : 'static/tpl/progress_labels.html',
      scope : {
        skills : '=skills',
        hideLabels : '=hideLabels',
      },
    };
  }])

  .directive('myGooglePlus', ['$window', function ($window) {
    return {
      restrict: 'A',
      link: function (scope, element) {
        element.addClass('g-plus');
        scope.$watch(function () { return !!$window.gapi; },
          function (gapiIsReady) {
            if (gapiIsReady) {
              $window.gapi.plus.go(element.parent()[0]);
            }
          });
      }
    };
  }])

  .directive('myFbShare', ['$window', function ($window) {
    return {
      restrict: 'A',
      link: function (scope, element) {
        element.addClass('fb-share-button');
        scope.$watch(function () { return !!$window.FB; },
          function (fbIsReady) {
            if (fbIsReady) {
              $window.FB.XFBML.parse(element.parent()[0]);
            }
          });
      }
    };
  }])

  .directive('locationAppend', ['$rootScope', '$location',
      function ($rootScope, $location) {
    return {
      restrict: 'A',
      link: function ($scope, element, attrs) {
        var url = attrs.href.substring(0, 3);
        $rootScope.$on("$routeChangeSuccess", function() {
          element.attr('href', url + $location.path());
        });
      }
    };
  }])

  .directive('trackClick', ['$analytics', function ($analytics) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        element.bind("click", function(){
          $analytics.eventTrack('click', {
            category: attrs.trackClick,
            label: attrs.trackLabel || attrs.href,
            value: attrs.trackValue,
          });
        });
      }
    };
  }])

  .directive('trackShow', ['$analytics', function ($analytics) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        $analytics.eventTrack('show', {
          category: attrs.trackShow,
          label: attrs.trackLabel,
          value: attrs.trackValue,
        });
      }
    };
  }])

  .directive('trackHover', ['$analytics', function ($analytics) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        element.bind("mouseover", function(){
          $analytics.eventTrack('hover', {
            category: attrs.trackHover,
          });
        });
      }
    };
  }])

  .directive('dynamicTitle', ['$rootScope', 'pageTitle', '$route', '$timeout',
      function ($rootScope, pageTitle, $route, $timeout) {
    return {
      restrict : 'A',
      scope : {},
      link : function (scope, element, attrs) {
        $rootScope.$on("$locationChangeSuccess", function() {
          $rootScope.title = pageTitle($route.current) + attrs.dynamicTitle;
          $timeout(function() {
            element.text($rootScope.title);
          }, 0, false);
        });
      }
    };
  }])

  .directive('setPlaceTypeNames', ['places', function (places) {
    return {
      restrict : 'A',
      link : function (scope, element, attrs) {
        var obj = angular.fromJson(attrs.setPlaceTypeNames);
        places.setPlaceTypeNames(obj);
      }
    };
  }])

  .directive('errorMessage', ['gettextCatalog', function (gettextCatalog) {
    return {
      restrict : 'A',
      template: '<div class="alert alert-danger">' +
                  '<p><strong>' +
                  gettextCatalog.getString("V aplikaci bohužel nastala chyba.") +
                  '</strong></p>' +
                  '<ul><li>' +
                    gettextCatalog.getString('Pro vyřešení problému zkuste') +
                    ' <a href="" onClick="window.location.href=window.location.href" ' +
                        'class="btn btn-default">' +
                      gettextCatalog.getString('obnovit stránku') +
                    '</a>' +
                  '</li><li>' +
                    gettextCatalog.getString("Pokud problém přetrval zkuste to znovu později nebo") +
                    ' <a feedback-comment class="btn btn-default" email="{{email}}" href=""> ' +
                       gettextCatalog.getString('nám napiště')  +
                    '</a>' +
                  '</li></ul>' +
                '</div>',
    };
  }])

  .directive('pageNumber', ['gettextCatalog', function (gettextCatalog) {
    return {
      restrict : 'A',
      scope : true,
      template: '<span ng-show="pageNumber" class="page-number" > ' +
                gettextCatalog.getString('Zdroj') + ': ' +
                  ' <a href="http://anatomie.memorix.cz">' +
                  gettextCatalog.getString('Memorix anatomie') + '</a>, ' +
                  gettextCatalog.getString('str.') + ' {{pageNumber}}' +
                ' </span>',
      link : function($scope, elem, attrs) {
        $scope.pageNumber = attrs.pageNumber;
        attrs.$observe('pageNumber', function(value) {
          if (value) {
            $scope.pageNumber = value;
          }
        });
      },
    };
  }])

  .directive('isActive',['$location', '$rootScope',
      function($location, $rootScope) {
    return {
      restrict: 'A',
      link: function(scope, element) {
        $rootScope.$on("$routeChangeSuccess", function() {
          var href = element.children('a').attr('href');
          if ($location.path() == href) {
            element.addClass('active');
          } else {
            element.removeClass('active');
          }
        });
      }
    };
  }])

  .directive('shareButton', ['shareModal', function(shareModal) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        element.bind('click', function(){
          shareModal.open(attrs);
        });
      }
    };
  }])

  .directive('imageModal', [function() {
    return {
      scope: {
        category: '=category',
        context: '=context',
        contexts: '=contexts',
        openAction: '=openAction',
      },
      restrict: 'E',
      controller: 'imageModalController',
    };
  }])

  .directive('relationsModal', [function() {
    return {
      scope: {
      },
      restrict: 'E',
      controller: 'relationsModalController',
    };
  }])

  .directive('imageClickHelp', ['userService', '$cookies', '$timeout',
      function(userService, $cookies, $timeout) {
    return {
      scope: {
        question: '=question',
      },
      restrict: 'A',
      link: function ($scope) {
        $scope.userService = userService;
        $scope.cookieSet = $cookies.get('imageHelpClosed');
        $timeout(function() {
          $scope.timeouted = true;
        }, 5000);
      },
      templateUrl: 'static/tpl/image_click_help.html',
    };
  }])

  .directive('imageView', [function() {
    return {
      scope: {
        context: '=?context',
        category: '=?category',
        contextId: '=?contextId',
        stats: '=stats',
      },
      restrict: 'A',
      templateUrl: 'static/tpl/image_view.html',
      controller: 'imageViewController',
    };
  }])

  .directive('signInBanner', ['userService', 'signupModal',
      function(userService, signupModal) {
    return {
      restrict: 'A',
      templateUrl : 'static/tpl/sign_in_banner.html',
      link: function ($scope) {
        $scope.userService = userService;
        $scope.openSignupModal = function() {
            signupModal.open();
        };
      }
    };
  }])

  .directive('covidBanner', ['userService', '$location',
      function(userService, $location) {
    return {
      restrict: 'A',
      templateUrl : 'static/tpl/covid_banner.html',
      link: function ($scope) {
        $scope.show = !userService.status.loading && !userService.user.profile.subscribed && !$scope.closed;

        $scope.close = function() {
          $scope.closed = true;
        };

        $scope.goto = function(link) {
          $scope.closed = true;
          $scope.show = false;
          $location.url(link);
        };
      }
    };
  }])

  .directive('premiumBanner', ['userService', '$timeout', '$rootScope', '$location',
      function(userService, $timeout, $rootScope, $location) {
    return {
      restrict: 'A',
      templateUrl : 'static/tpl/premium_banner.html',
      link: function ($scope) {
        $scope.userService = userService;

        $rootScope.$on('questionSetFinished', function() {
          var shouldShow = !userService.status.loading &&
            !userService.user.profile.subscribed &&
            !$scope.closed &&
            userService.user.profile.number_of_answers >= 40;
          if (shouldShow) {
            $scope.show = true;
            $timeout(function() {
              $scope.class = 'alert-grow';
            }, 5000);
          }
        });

        $scope.close = function() {
          $scope.closed = true;
        };

        $scope.goto = function(link) {
          $scope.closed = true;
          $scope.show = false;
          $location.url(link);
        };
      }
    };
  }])

  .directive('mySubscriptions', ['subscriptionService', '$location',
      function(subscriptionService, $location) {
    return {
      restrict: 'A',
      templateUrl : 'static/tpl/my_subscriptions_tpl.html',
      link: function ($scope) {
        subscriptionService.getMyScubscriptions().success(function(data) {
          $scope.subscriptions = data.data;
        }).error(function() {
          $scope.error = true;
        });
        $scope.referalLink = $location.absUrl().split('?')[0].replace(
          'u/', 'premium/?referal_username=');
      }
    };
  }])

  .directive('paymentState', ['gettextCatalog', function(gettextCatalog) {
    return {
      restrict: 'A',
      scope: {
        paymentState: '=paymentState',
      },
      templateUrl : 'static/tpl/payment_state_tpl.html',
      link: function ($scope) {
        $scope.paymentStates = {
          'PAID': gettextCatalog.getString('Zaplaceno'),
          'TIMEOUTED': gettextCatalog.getString('Vypršel časový limit na zaplacení'),
          'CREATED': gettextCatalog.getString('Vytvořeno'),
          'CANCELED': gettextCatalog.getString('Zrušeno'),
          'AUTHORIZED': gettextCatalog.getString('Předautorizováno'),
          'REFUNDED': gettextCatalog.getString('Refundováno'),
          'PARTIALLY_REFUNDED': gettextCatalog.getString('Částečně refundováno')
        };
        $scope.getLabelClass = function() {
          return {
            'PAID': 'success',
            'CREATED': 'warning',
            'TIMEOUTED': 'danger',
          }[$scope.paymentState] || 'default';
        };
      }
    };
  }])

  .directive('setCookieOnClick', ['$cookies', function($cookies) {
    return {
      restrict: 'A',
      link: function ($scope, element, attrs) {
        element.bind('click', function(){
          $cookies.put(attrs.setCookieOnClick, 'true');
        });
      }
    };
  }])

  .directive('countFrom', ['$interval', function($interval) {
    var stop;
    return {
      restrict: 'A',
      template: '<span>{{count | number}}</span>',
      link: function ($scope, element, attrs) {
        if (angular.isDefined(stop)) {
          $interval.cancel(stop);
          stop = undefined;
        }

        $scope.count = attrs.countFrom;
        var step = 1000 / attrs.countPerSecond;

        if (attrs.countPerSecond > 0) {
          stop = $interval(function() {
            $scope.count++;
          }, step);
        }
      }
    };
  }])

  .directive('colorScaleLegend', [function() {
    return {
      restrict: 'A',
      replace: true,
      templateUrl : 'static/tpl/color_scale_legend.html',
      link: function ($scope) {
        $scope.values = [];
        for (var i = 1; i <= 10; i++) {
          $scope.values.push(i);
        }
      }
    };
  }])

  .directive('summary', ['practiceService', 'hotkeys', '$location', '$routeParams',
      function(practiceService, hotkeys, $location, $routeParams) {
    return {
      restrict: 'A',
      replace: true,
      scope: {
        controller: '=controller',
        categoryId: '=categoryId',
        category2Id: '=category2Id',
      },
      templateUrl : 'static/tpl/summary_tpl.html',
      link: function ($scope) {
        $scope.intro = $routeParams.config === 'intro';
        $scope.summary = practiceService.getSummary();
        $scope.summary.correctlyAnsweredRatio =
          $scope.summary.questions.filter(function(q) {
            return q.payload.isCorrect;
          }).length / 
          $scope.summary.questions.length;

        hotkeys.bindTo($scope).add({
          combo: 'enter',
          description: 'Pokračovat',
          callback: function() {
            var url = "/refreshpractice/" + ($scope.categoryId || "") +
              "/" + ($scope.category2Id || "");
            $location.url(url);
          }
        });

      },
    };
  }])

  .directive('tile', [function(){
    return {
      restrict: 'A',
      replace: true,
      scope: {
        category: '=category',
        index: '=index',
        clickAction: '=clickAction',
        practicePath: '=practicePath',
        viewPath: '=viewPath',
        disabled: '=disabled',
        thumbnailPath: '=thumbnailPath',
        hideSelect: '=?hideSelect',
      },
      controller : 'tileController',
      templateUrl : 'static/tpl/tile.html',
    };
  }])

  .directive('shortcut', [function() {
    return {
      restrict: 'A',
      scope: {
        shortcut: '@shortcut',
      },
      template: '<span class="pull-right shortcut-info hidden-xs hidden-sm" ' +
            'title="{{\'Klávesová zkratka: \' | translate}}{{shortcut}}"> ' +
          '&nbsp;&nbsp;[{{shortcut}}]' +
        '</span>',
      replace: true,
    };
  }])

  .directive('optionButtons', ['$rootScope', 'serverLogger', 'hotkeys',
      function($rootScope, serverLogger, hotkeys) {
    return {
      restrict: 'A',
      scope: {
        question: '=question',
        imageController: '=imageController',
        canNext: '=canNext',
        controller: '=controller',
      },
      templateUrl : 'static/tpl/option_buttons_tpl.html',
      link: function ($scope) {

        function optionSelected(event, action) {
          var option = $scope.question && $scope.question.options && $scope.question.options[action.combo[0] - 1];
          if (option && ! option.disabled) {
            $scope.controller.checkAnswer(option, true);
          }
        }

        for (var i = 1; i <= 6; i++) {
          hotkeys.bindTo($scope)
          .add({
            combo: '' + i,
            description: 'Vybrat možnost ' + i,
            callback: optionSelected
          });
        }

        $rootScope.$on('questionAnswered', function() {
            highlightOptions();
        });

        function highlightOptions() {
            ($scope.question.options || []).map(function(o) {
                o.correct = o.term_secondary ?
                  o.term_secondary.id == $scope.question.term_secondary.id :
                  o.description == $scope.question.description;
                o.selected = o.term_secondary ?
                  $scope.question.answered_term_secondary &&
                    o.term_secondary.id == $scope.question.answered_term_secondary.id :
                  o.description == $scope.question.answered_code;
                if (o.selected || o.correct) {
                  o.bgcolor = undefined;
                  o.color = undefined;
                }
                o.disabled = true;
                return o;
            });
        }
      }
    };
  }])

  .directive('questionAndAnswer', ['flashcardService', function(flashcardService) {
    return {
      restrict: 'A',
      scope: {
        question: '=question',
        imageController: '=imageController',
        clickFn: '=clickFn',
        categoryId: '=categoryId',
        category2Id: '=category2Id',
      },
      templateUrl : 'static/tpl/question_and_answer_tpl.html',
      link: function ($scope) {
        $scope.getFlashcardByDescription = function(description) {
          for (var i = 0; i < $scope.question.context.flashcards.length; i++) {
            var fc = $scope.question.context.flashcards[i];
            if (fc.description == description) {
              return fc;
            }
          }
        };
        $scope.wrongAnswers = [];
        if ($scope.question.options && $scope.question.options.length === 0) {
          var question = $scope.question.question_type == 't2ts' ?
            'term' : 'term_secondary';
          var answer = $scope.question.question_type == 'ts2t' ?
            'term' : 'term_secondary';
          flashcardService.getAllFlashcards().then(function(flashcards) {
            $scope.wrongAnswers = flashcards.filter(function(fc) {
              return fc.context_id == $scope.question.context.id &&
                fc[question] && fc[question].id == $scope.question[question].id &&
                fc[answer] && fc[answer].id != $scope.question[answer].id;
            });
          });
        }
      },
    };
  }])

  .directive('practiceHeader', ['userService', function(userService) {
    return {
      restrict: 'A',
      replace: true,
      scope: {
        question: '=question',
        categoryId: '=categoryId',
      },
      templateUrl : 'static/tpl/practice_header_tpl.html',
      link: function ($scope) {
        $scope.userService = userService;
        $scope.$watch('question', function() {
          if ($scope.question) {
            if ($scope.question.additional_info && 
                $scope.question.additional_info.contexts) {
              $scope.contextId = $scope.question.additional_info.contexts[
                $scope.question.question_type];
            } else {
              $scope.contextId = $scope.question.context.identifier;
            }
          }
        });
      }
    };
  }])

  .directive('practiceSetting', ['termsLanguageService',
      function(termsLanguageService) {
    return {
      restrict: 'A',
      replace: true,
      scope: {
        categoryId: '=categoryId',
        category2Id: '=category2Id',
      },
      templateUrl : 'static/tpl/practice_setting_tpl.html',
      link: function ($scope) {
        $scope.possibleLangs = termsLanguageService.getPossibleTermsLangs();
        $scope.setTermsLang = termsLanguageService.setTermsLang;
        $scope.getTermsLang = termsLanguageService.getTermsLang;
      }
    };
  }])

  .directive('practiceActionButtons', ['userService', 'hotkeys',
      function(userService, hotkeys) {
    return {
      restrict: 'A',
      replace: true,
      scope: {
        question: '=question',
        canNext: '=canNext',
        controller: '=controller',
      },
      templateUrl : 'static/tpl/practice_action_buttons_tpl.html',
      link: function ($scope) {
        $scope.userService = userService;

        hotkeys.bindTo($scope)
        .add({
          combo: 'enter',
          description: 'Pokračovat',
          callback: function() {
            if ($scope.canNext) {
              $scope.controller.next();
            }
          }
        })
        .add({
          combo: 'esc',
          description: 'Nevím',
          callback: function() {
            if (!$scope.canNext) {
              $scope.controller.checkAnswer(undefined, true);
            }
          }
        });

      }
    };
  }])

  .directive('imageScreenShot', ['$rootScope', '$http', '$timeout',
      function($rootScope, $http, $timeout) {
    var screenshotTaken;
    return {
      restrict: 'A',
      replace: true,
      template : '<canvas style="display: none" id="screen-shot"></canvas> ',
      link: function () {
        function takeScreenshot(event, identifier, force) {
          if (screenshotTaken && !force) {
            return;
          }
          var allSvg = document.querySelectorAll(".image-" + identifier.split('--')[0] + " svg");
          var lastSvg = allSvg[allSvg.length - 1];
          var svgData = new XMLSerializer().serializeToString(lastSvg);
          var canvas = document.getElementById("screen-shot");
          window.canvg(canvas, svgData);
          var imgSrc    = canvas.toDataURL("image/png");
          var data = {
            name : identifier,
            image : imgSrc,
          };
          $http.post('/savescreenshot/', data);
          screenshotTaken = true;
        }
        $rootScope.$on('imageDisplayed', function(event, identifier, force) {
          $timeout(function() {
            takeScreenshot(event, identifier, force);
          }, 500);
        });

      }
    };
  }])

  .directive('openQuestionsAlert', ['configService',
      function(configService) {
    return {
      restrict: 'A',
      replace: true,
      scope: {
      },
      templateUrl : 'static/tpl/open_questions_alert_tpl.html',
      link: function ($scope) {
        var restrictionKey = 'proso_models.options_count.parameters.allow_zero_options_restriction';
        $scope.configService = configService;
        $scope.openQuestionsDisabled = configService.getOverridden()[restrictionKey];

        $scope.allowOpenQuestions = function() {
          configService.override(restrictionKey, false);
          $scope.openQuestionsDisabled = false;
        };
      }
    };
  }])

  .directive('scrollTop', ['smoothScroll', function(smoothScroll) {
    return {
      restrict: 'A',
      link: function ($scope, element) {
        element.bind('click', function(){
          var elem = document.getElementById('wrap');
          smoothScroll(elem, {
            offset: 10,
            duration: 200,
          });
        });
      }
    };
  }])

  .directive('openAnswer', ['flashcardService', 'configService', '$window', '$filter', 'serverLogger',
      function(flashcardService, configService, $window, $filter, serverLogger) {
    return {
      restrict: 'A',
      replace: true,
      scope: {
        question: '=question',
        canNext: '=canNext',
        controller: '=controller',
      },
      templateUrl : 'static/tpl/open_answer_tpl.html',
      link: function ($scope, element) {
        $scope.canNext = false;

        var question = angular.copy($scope.question);
        $scope.questionAndAnswer = toQuestionAndAnswer(question);
        $scope.questionsAndAnswers = [$scope.questionAndAnswer];

        $scope.$watch('answer', function() {
          if ($scope.answer && $scope.questionsAndAnswers.length <= 1) {
            serverLogger.error("User typed something before typeahead loaded", {    
               question : question,   
               answer : $scope.answer,   
             });
          }
        });

        flashcardService.getAllFlashcards().then(function(flashcards) {
          var qaaByAnswer = {};
          $scope.questionsAndAnswers = flashcards.filter(function(fc) {
            return fc.term && fc.term.name;
          }).map(toQuestionAndAnswer
            ).filter(function(qaa) {
              return qaa.answer;
          }).filter(function(qaa) {
            if (qaa.question == $scope.questionAndAnswer.question &&
                qaa.answer != $scope.questionAndAnswer.answer) {
              return false;
            }
            if (!qaaByAnswer[qaa.answer]) {
              qaaByAnswer[qaa.answer] = qaa;
              return true;
            } else if (qaa.question == $scope.questionAndAnswer.question) {
              qaaByAnswer[qaa.answer].flashcard = qaa.flashcard;
              qaaByAnswer[qaa.answer].question = qaa.question;
            }
            return false;
          }).sort(function(a, b){
            return a.answer.length - b.answer.length;
          });
        });

        function toQuestionAndAnswer(fc) {
          return {
            question: $filter('stripAlternatives')(
              $scope.question.question_type == 't2ts' ?
              fc.term.name : (fc.description ||
                (fc.term_secondary && fc.term_secondary.name))),
            answer: $filter('stripAlternatives')(
              $scope.question.question_type == 't2ts' ?
              (fc.term_secondary && fc.term_secondary.name) : fc.term.name),
            flashcard: fc,
          };
        }

        $scope.canAnswer = function() {
          return !$scope.canNext && $scope.answer && (
            $scope.answer.answer);
        };
        $scope.checkAnswer = function(keyboardUsed) {
          if ($scope.canAnswer()) {
            if ($scope.answer.question == $scope.questionAndAnswer.question) {
              $scope.answer = $scope.questionAndAnswer;
            }
            $scope.controller.checkAnswer(keyboardUsed);
            if ($scope.answer.answer == $scope.questionAndAnswer.answer) {
              $scope.question.isCorrect = true;
            } else {
              $scope.question.isIncorrect = true;
            }
          }
        };
        $scope.disableOpenQuestions = function() {
          var restrictionKey = 'proso_models.options_count.parameters.allow_zero_options_restriction';
          configService.override(restrictionKey, true);
          $window.location.reload();
        };

        element.children('input').focus();
        $scope.inputKeypress = function($event) {
          if ($event.which == 13) {
            $scope.checkAnswer(true);
          }
        };
      }
    };
  }])

  .directive("preloadResource", ["resourceCache", 
    function(resourceCache) {
      return { link: function (scope, element, attrs) { 
        resourceCache.put(attrs.preloadResource, element.html()); 
        element.html('');
      }};
    }
  ]);

/* Filters */
angular.module('proso.anatomy.filters', [])

  .filter('percent', function() {
    return function(n) {
      n = n || 0;
      return Math.round(100 * n) + '%';
    };
  })

  .filter('StatesFromPlaces', function() {
    return function(data) {
      var places = {};
      if (data && data[0]) {
        angular.forEach(data, function(category) {
          if (!category.haveMaps && category.places) {
            angular.forEach(category.places, function(place) {
              places[place.description] = place;
            });
          }
        });
      }
      return places;
    };
  })

  .filter('colNum', function() {
    return function(colsCount) {
      return Math.floor(12 / colsCount);
    };
  })

  .filter('isFindOnMapType', function() {
    return function(question) {
      return question && question.question_type == "t2d";
    };
  })

  .filter('isPickNameOfType', function() {
    return function(question) {
      return question && question.question_type == "d2t";
    };
  })

  .filter('isAllowedOption', function() {
    return function(question, code) {
      return !question.options || 
        0 === question.options.length || 
        1 === question.options.filter(function(option) {
          return option.description == code;
        }).length;
    };
  })

  .filter('questionText', ['gettextCatalog', '$rootScope', '$filter',
      function(gettextCatalog, $rootScope, $filter) {
    return function(question) {
      var stripAlts = $filter('stripAlternatives');
      var type = question && question.question_type;
      var lang = $rootScope.LANGUAGE_CODE;
      if (type == "t2d") {
        return gettextCatalog.getString("Vyber");
      } else if (type == "d2t") {
        return gettextCatalog.getString("Co je zvýrazněno?");
      } else if (type == "t2ts") {
        return question.context.content.question[lang][type].replace('{}',
          '<span class="label label-default">' + stripAlts(question.term.name) + '</span>');
      } else if (type == "ts2t") {
        return question.context.content.question[lang][type].replace('{}',
          '<span class="label label-default">' + stripAlts(question.term_secondary.name) + '</span>');
      }
      return "";
    };
  }])

  .filter('isTypeCategory', function() {
    return function(types, category) {
      types = types && types.filter(function(t){
        return category.types.filter(function(slug){
          return slug == t.identifier;
        }).length == 1;
      });
      return types;
    };
  })

  .filter('categoryIdToName',['categoryService', function(categoryService) {
    return function(id) {
      var category = categoryService.getCategory(id);
      return category ? category.name + ' - ' : '';
    };
  }])

  .filter('probColor', ['colorScale', function(colorScale) {
    return function(probability) {
      return colorScale(probability).hex();
    };
  }])

  .filter('stripAlternatives', [ function() {
    String.prototype.mapReplace = function(map) {
        var regex = [];
        for(var key in map)
            regex.push(key.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&"));
        return this.replace(new RegExp(regex.join('|'),"g"),function(word){
            return map[word];
        });
    };

    var replacements = {
      'musculi': 'mm.',
      'venae ': 'vv. ',
      'nervi ': 'nn. ',
      'arteriae ': 'aa. ',
      'rami ': 'rr. ',
      'ligamenta ': 'ligg. ',
      'musculus': 'm.',
      'vena ': 'v. ',
      'nervus ': 'n. ',
      'arteria ': 'a. ',
      'ramus ': 'r. ',
      'ligamentum ': 'lig. ',
    };
    return function(name) {
      return name && name.mapReplace(replacements).split(';')[0];
    };
  }])

  .filter('alternativeNames', ['gettextCatalog', function(gettextCatalog) {
    return function(name) {
      var names = (name || '').split(';');
      if (names.length > 1) {
        return gettextCatalog.getString('Alternativní názvy') +
          ':<br> <strong>' + names.splice(1).join('<br>') + '</strong>';
      }
      return '';
    };
  }])

  .filter('sumCounts', [ function() {
    return function(layers) {
      if (!layers || layers.length === 0) {
        return 0;
      }
      var sum = layers.map(function(p){
        return p.count;
      }).reduce(function(a, b) {
        return a + b;
      });
      return sum;
    };
  }])

  .filter('stripedStyle', [function () {
    return function (goal, isLearnedBar) {
      var barWidth =  isLearnedBar ? goal.progress : goal.progress_diff;
      var deg = isLearnedBar ? "90" : "270";
      var noOfDays = (new Date(goal.finish_date) - new Date(goal.start_date)) /
        (24 * 60 * 60 * 1000);
      var dayWidth = 1 / noOfDays;
      var relDayWidth = dayWidth / barWidth;
      var dayPercent = relDayWidth * 100 + '%';
      var startPercent = (relDayWidth * 100) - (0.5 / barWidth) + '%';
      var style = {
        "background-image" :
        "repeating-linear-gradient( " + deg + "deg, transparent, transparent " +
          startPercent + ", rgba(0,0,0,0.2) " + startPercent + ", rgba(0,0,0,0.2) " + dayPercent + ")"
      };
      return style;
    };
  }])

  .filter('reportText', ['gettextCatalog', '$filter', '$location',
      function(gettextCatalog, $filter, $location) {
    return function(question, categoryId) {
      var text = gettextCatalog.getString(
        'Na obrázku: "{{imageName}}"\n{{url}}\nv otázce:\n{{question}}\nje tato chyba:',
        {
          imageName: question.context.name,
          url: $location.protocol() + '://' + $location.host() + ':' +  $location.port() +
            "/view/" + (categoryId || '').split('-')[0] +
            "?context=" + question.context.identifier,
          question: $filter('questionText')(question) +
            (question.question_type == 'd2t' && question.options ?
              '\n  ' + question.options.map(function(o) {
                return o.term.name;}).join('\n  ') :
              ' "' + question.term.name + '"'),
        });
      return text;
    };
  }])

  .filter('getSelectedIdentifiers', ['$filter', function($filter) {
    return function(categories, type) {
      var selected = $filter('getSelectedCategories')(categories, type);
      selected = selected.map(function(c) {
        return c.identifier;
      }).join('-');
      if (!selected && type == 'relation') {
        selected = 'relations';
      }
      return selected;
    };
  }])

  .filter('getSelectedCategories', [function() {
    return function(categories, type) {
      var selected = categories || [];
      selected = selected.filter(function(c) {
        return c.selected && (c.type == type || !type);
      });
      return selected;
    };
  }])

  .filter('getSelectedCategoriesText', ['gettextCatalog', '$filter',
      function(gettextCatalog, $filter) {

    function getSection(title, categories, categoryType) {
      var selectedCategoires = $filter('getSelectedCategories')(
          categories, categoryType).map(function(c) {
        return c.name;
      });
      var text = '';
      if (selectedCategoires.length) {
        text += title + '<br>' + '<b>' + selectedCategoires.join(', ') + '</b><br><br>';
      }
      return text;
    }
    return function(categories) {
      var text;
      if ($filter('getSelectedCategories')(categories).length === 0) {
        text = gettextCatalog.getString('Vyber si libovolnou kombinaci orgánových sytémů a částí těla (v pravém horním rohu každé dlaždice).');
      } else {
        text = getSection(gettextCatalog.getString('Vybrané orgánové systémy:'),
          categories, 'system');
        text += getSection(gettextCatalog.getString('Vybrané části těla:'),
          categories, 'location');
        text += getSection(gettextCatalog.getString('Vybrané typy souvislostí:'),
          categories, 'relation');
      }
      return text;
    };
  }])

  .filter('currencySymbol', [function () {
      var symbols = {
        'CZK': 'Kč',
        'EUR': '€',
      };
      return function(code) {
        return symbols[code];
      };
  }]);


/* Services */
angular.module('proso.anatomy.services', ['ngCookies'])

  .value('chroma', chroma)

  .value('$', jQuery)

  .value('colors', {
    'GOOD': '#5CA03C',
    'BAD': '#e23',
    'HIGHLIGHTS' : [
      '#f9b234',
      '#1d71b9',
      '#36a9e0',
      '#312883',
      '#fdea11',
      '#951b80',
    ],
    'HIGHLIGHTS_CONTRAST' : [
      '#000',
      '#fff',
      '#000',
      '#fff',
      '#000',
      '#fff',
    ],
  })

  .factory('colorScale', ['colors', 'chroma', function(colors, chroma) {
    var scale = chroma.scale([
        colors.BAD,
        '#f40',
        '#fa0',
        '#fe3',
        colors.GOOD
      ]);
    return scale;
  }])

  .factory('mapTitle', ['places', function(places) {
    'use strict';
    return function(part, user) {
      var name = places.getName(part);
      if (!name) {
        return;
      } else if (user === '' || user == 'average') {
        return name;
      } else {
        return name + ' - ' + user;
      }
    };
  }])

  .factory('events', function() {
    'use strict';
    var handlers = {};
    return {
      on : function(eventName, handler) {
        handlers[eventName] = handlers[eventName] || [];
        handlers[eventName].push(handler);
      },
      emit : function(eventName, args) {
        handlers[eventName] = handlers[eventName] || [];
        handlers[eventName].map(function(handler) {
          handler(args);
        });
      }
    };
  })

  .factory('pageTitle',['categoryService', 'gettextCatalog', function(categoryService, gettextCatalog) {
    'use strict';
    function addCategoryName(title, categoryId) {
        var longerNames = {
          'Hb' : gettextCatalog.getString('Mozková část hlavy'),
          'Hf' : gettextCatalog.getString('Obličejová část hlavy'),
        };
        if (longerNames[categoryId]) {
          return addIfExists(title, longerNames[categoryId]);
        }
        var category = categoryService.getCategory(categoryId);
        return addIfExists(title, category && category.name);
    }
    function addIfExists(title, addition) {
        if (addition) {
          title += addition + ' - ';
        }
        return title;
    }

    return function (route, initTitle) {
      var titles = {
        'static/tpl/about.html' : gettextCatalog.getString('O projektu'),
        'static/tpl/overview_tpl.html' : gettextCatalog.getString('Atlas anatomie lidského těla'),
        'static/tpl/practice_tpl.html' : gettextCatalog.getString('Procvičuj'),
      };
      var title = "";
      if (titles[route.templateUrl]) {
        title = titles[route.templateUrl] + 
          (route.controller == "AppPractice" ? ': ' : ' - ');
      }
      title = addCategoryName(title, route.params.category2);
      title = addCategoryName(title, route.params.category);
      title = addIfExists(title, route.params.user);

      if (route.$$route && route.$$route.originalPath == '/practice/') {
        title = gettextCatalog.getString('Opakování lékařské anatomie') + ' - ';
      }
      if (route.$$route && route.$$route.originalPath == '/') {
        title = initTitle;
      } else {
        title += gettextCatalog.getString('Anatom.cz');
      }
      return title;
    };
  }])

  .factory('contextService', ["$http", "$q", "userStatsService",
      function ($http, $q, userStatsService) {
    'use strict';
    var that = {
      getAllContexts: function () {
        var filter = {
          db_orderby : 'name',
          without_content : 'True',
          all : 'True',
        };
        return $http.get('/flashcards/contexts', {params: filter, cache: true});
      },
      getContexts: function (filter) {
        var deferredContext = $q.defer();
        that.getAllContexts().success(function(data) {
          userStatsService.clean();
          for (var i = 0; i < data.data.length; i++) {
            var context = data.data[i];
            var id = context.identifier;
            userStatsService.addGroup(id, {});
            userStatsService.addGroupParams(id, filter.filter.concat([['context/' + id]]));
          }
          var contexts = data.data;

          userStatsService.getToPracticeCounts().success(function(data) {
            for (var i = 0; i < contexts.length; i++) {
              var context = contexts[i];
              var id = context.identifier;
              context.stats = data.data[id];
            }
            contexts = contexts.filter(function(c) {
              return c.stats.number_of_items > 2;
            });
            deferredContext.resolve(contexts);
          });
        }).error(function(error){
          console.error("Something went wrong while loading contexts from backend.");
          deferredContext.reject(error);
        });
        return deferredContext.promise;
      },
      getContext: function (id) {
        var deferredContext = $q.defer();
        $http.get('/flashcards/context/' + id + '?contexts_with_flashcards=true', {cache: true}
        ).success(function(data) {
          if (data.data.content) {
            data.data.content = angular.fromJson(data.data.content);
          }
          deferredContext.resolve(data.data);
        }).error(function(error){
          console.error("Something went wrong while loading contexts from backend.");
          deferredContext.reject(error);
        });
        return deferredContext.promise;
      },
      getContextByIdentifier: function (id, params) {
        var deferredContext = $q.defer();
        $http.get('/flashcards/contexts' +
          '?filter_value=' + id + 
          (params && params.withoutFlashcards ? '' : '&contexts_with_flashcards=true') +
          '&filter_column=identifier',
          {cache: true}
        ).success(function(data) {
          if (data.data.length == 1) {
            data.data = data.data[0];
          }
          if (data.data.content) {
            data.data.content = angular.fromJson(data.data.content);
          }
          deferredContext.resolve(data.data);
        }).error(function(error){
          console.error("Something went wrong while loading contexts from backend.");
          deferredContext.reject(error);
        });
        return deferredContext.promise;
      },
    };
    return that;
  }])

  .factory('categoryService', [
      "$http", "$q", "userStatsService", "$cookies", "resourceCache",
      function ($http, $q, userStatsService, $cookies, resourceCache) {
    'use strict';
    var categories = [];
    var categoriesByIdentifier = {};
    var httpPromise;
    var deferredCategory = $q.defer();
    var categoriesByType = {};
    function init(){
      var filter = {
        all : 'True',
        db_orderby : 'identifier',
      };
      httpPromise = $http.get('/flashcards/categorys', {
        params: filter,
        cache: resourceCache,
      }).success(function(data) {
        categories = data.data;
        for (var i = 0; i < data.data.length; i++) {
          categoriesByIdentifier[data.data[i].identifier] = data.data[i];
          if (!categoriesByType[data.data[i].type]) {
            categoriesByType[data.data[i].type] = [];
          }
          categoriesByType[data.data[i].type].push(data.data[i]);
        }
        deferredCategory.resolve(angular.copy(categoriesByType));
      }).error(function(error){
        console.error("Something went wrong while loading categories from backend.");
        deferredCategory.reject(error);
      });
    }
    init();

    function mapSubcategories(category) {
      var subcategories = [];
      if (category.type == "system") {
        subcategories = angular.copy(categoriesByType.location);
      } else if (category.type == "location") {
        subcategories = angular.copy(categoriesByType.system);
      } else if (category.identifier == "foramina") {
        subcategories = angular.copy(categoriesByType.subrelation);
      } else if (category.identifier == "relations") {
        subcategories = angular.copy(categoriesByType.relation);
      } else if (category.type == "relation") {
        subcategories = angular.copy(categoriesByType.location);
      }
      return subcategories;
    }
    var that = {
      getCategory: function (identifier) {
        return categoriesByIdentifier[identifier];
      },
      getAllByType: function () {
        return deferredCategory.promise;
      },
      getSubcategories: function (identifier) {
        var category = categoriesByIdentifier[identifier];
        var subcategories = [];
        if (!category) {
          return subcategories;
        }
        var filter = {
          filter : identifier ? ['category/' + identifier] : [],
        };

        subcategories = mapSubcategories(category);

        userStatsService.clean();
        for (var i = 0; i < subcategories.length; i++) {
          var id = subcategories[i].identifier;
          userStatsService.addGroup(id, {});
          userStatsService.addGroupParams(id, [filter.filter, ['category/' + id]]);
        }
        userStatsService.getToPracticeCounts().success(function(data) {
          for (var i = 0; i < subcategories.length; i++) {
            var subcategory = subcategories[i];
            var id = subcategory.identifier;
            subcategory.stats = data.data[id];
          }
          if (!$cookies.get('practiceDropdownUsed')) {
            setTimeout(function() {
              angular.element('.practice-dropdown').click();
            }, 1);
          }
        });
        return subcategories;
      },
    };
    return that;
  }])

  .factory('termsLanguageService', ["$cookies", "$location",
      function($cookies, $location) {
    var termsLang;
    var uiLang;
    var possibleLangs = {
      'cs': [{
        code : 'cs',
        name : 'Latinsky',
      }, {
        code : 'cc',
        name : 'Česky',
      }],
      'en': [{
        code : 'la',
        name : 'Latin',
      }, {
        code : 'en',
        name : 'English',
      }],
    };
    var that = {
      init : function(lang) {
        uiLang = lang;
        if ($location.search().termsLang) {
          termsLang = $location.search().termsLang;
        } else if ($cookies.get('termsLang')) {
          termsLang = $cookies.get('termsLang');
        } else {
          termsLang = lang;
        }
        $cookies.put('termsLang', termsLang);
      },
      setTermsLang : function(lang) {
        termsLang = lang;
        $cookies.put('termsLang', termsLang);
      },
      getTermsLang : function() {
        return termsLang;
      },
      getPossibleTermsLangs : function() {
        return possibleLangs[uiLang];
      },
    };
    return that;
  }])

  .factory('flashcardService', ["$http", "$q", "termsLanguageService",
      function ($http, $q, termsLanguageService) {
    'use strict';

    var that = {
      getFlashcards: function (filter) {
        var deferredFlashcards = $q.defer();
        filter = angular.copy(filter);
        for (var i in filter) {
          filter[i] = angular.toJson(filter[i]);
        }
        filter.language = termsLanguageService.getTermsLang();
        filter.all = 'True';
        if (!filter.with_contexts) {
          filter.without_contexts = 'True';
        }
        $http.get('/models/to_practice/', {
          params: filter,
          cache: true,
        }).success(function(data) {
          deferredFlashcards.resolve(data.data);
        }).error(function(data) {
          deferredFlashcards.reject(data);
        });
        return deferredFlashcards.promise;
      },
      getAllFlashcards: function () {
        var deferredFlashcards = $q.defer();
        var filter = {};
        filter.language = termsLanguageService.getTermsLang();
        $http.get('/all_flashcards/', {
          params: filter,
          cache: true,
        }).success(function(data) {
          deferredFlashcards.resolve(data.data);
        }).error(function(data) {
          deferredFlashcards.reject(data);
        });
        return deferredFlashcards.promise;
      },
    };
    return that;
  }])

.service('colorService', function() {
  function lowerContrast(grayValue) {
    grayValue = grayValue - 128;
    grayValue = grayValue * 0.5;
    grayValue = grayValue + 128;
    return grayValue;
  }

  var that = {
    hexToRgb : function(c) {
      var red = parseInt(c.substr(1, 2), 16);
      var green = parseInt(c.substr(3, 2), 16);
      var blue = parseInt(c.substr(5, 2), 16);
      return [red, green, blue];
    },
    rgbToHex : function(rgb) {
      var ret = '#';
      for (var i = 0; i < rgb.length; i++) {
        ret += rgb[i].toString(16);
      }
      return ret;
    },
    isGray : function(c) {
      var rgb = that.hexToRgb(c);
      return Math.max(Math.abs(rgb[0] - rgb[1]), Math.abs(rgb[0] - rgb[2])) < 10;
    },
    toGrayScale : function(c) {
      if (that.isGray(c) || c == 'none') {
        return c;
      }
      var rgb = that.hexToRgb(c);
      var weights =  [0.299, 0.587, 0.114];
      var graySum = 0;
      for (var i = 0; i < rgb.length; i++) {
        graySum += 3.7 * rgb[i] * weights[i];
      }
      var grayAverage = Math.min(235, Math.round(lowerContrast(graySum / 3)));
      var grayAverageHex = grayAverage.toString(16);
      if (grayAverageHex == 'NaN') {
        return '#000000';
      }
      for (i = 0; i < rgb.length; i++) {
        rgb[i] = Math.floor((rgb[i] + grayAverage * 18) / 19);
      }
      return that.rgbToHex(rgb);
    },
  };
  return that;
})

.service('imageService', ['gettextCatalog', function(gettextCatalog) {
  var image;
  var callback;
  var callback2;

  return {
    setImage : function(i, fn) {
      if (!i) {
        i = gettextCatalog.getString('Tato otázka je bez obrázku.');
      }
      if (callback) {
        fn(callback(i));
        callback = undefined;
      } else {
        image = i;
        callback2 = fn;
      }
    },
    getImage : function(fn) {
      if (image) {
        callback2(fn(image));
        image = undefined;
        callback2 = undefined;
      } else {
        callback = fn;
      }
    },
  };
}])


  .factory('confirmModal', ["$modal", function ($modal) {
    'use strict';
    var ModalConfirmCtrl = ['$scope', '$modalInstance', 'question', 'confirm',
        function ($scope, $modalInstance, question, confirm) {
      $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
      };
      $scope.confirm = confirm;
      $scope.question = question;
    }];

    return {
      open : function(question, callback) {
        $modal.open({
          templateUrl: 'static/tpl/confirm_modal.html',
          controller: ModalConfirmCtrl,
          resolve: {
            confirm: function () {
              return  callback;
            },
            question: function () {
              return  question;
            },
          },
        });
      }
    };
  }])

  .factory('shareModal', ["$modal", function($modal) {
    return {
      open: function(attrs) {
        $modal.open({
          templateUrl: 'static/tpl/share-modal.html',
          controller: 'shareController',
          resolve: {
            data: function() {
              return attrs;
            },
          },
        });
      }
    };
  }])

  .factory('subscriptionService', ["$http", "$window", "userService", "$location", "loginModal", "$analytics", "$routeParams",
      function($http, $window, userService, $location, loginModal, $analytics, $routeParams) {


    var that = {
      trackSubsctription: function(subscription) {
        if (subscription && $routeParams.return_from_payment &&
          subscription.payment.status.state == 'PAID') {
          $analytics.eventTrack('pay', {
            category: 'subscription paid',
            label: subscription.plan_description.name,
            value: subscription.payment.status.amount / 100,
          });
        }
      },
      getMyScubscriptions: function() {
        var mySubscriptionsPromise = $http.get('/subscription/mysubscriptions/');
        mySubscriptionsPromise.success(function(data) {
          data.data.map(function(subscription) {
            subscription.created = new Date(subscription.created);
            subscription.expiration = new Date(subscription.expiration);
            return subscription;
          });
          that.trackSubsctription(data.data[0]);
        });
        return mySubscriptionsPromise;
      },
      getPlans: function(discountCode) {
        var url = '/subscription/plans/' +
          (discountCode ? '?discount_code=' + discountCode : '');
        return $http.get(url);
      },
      getDiscountCode: function(discountCode) {
        var url = '/subscription/discount_code/' + discountCode;
        return $http.get(url);
      },
      buyPlan: function(plan, discountCode, referralUsername) {
        //testing card number 4188030000000003
        var return_url = $location.absUrl().split('?')[0].replace('premium','u/') +
          '?return_from_payment=true';
        if (that.isSubscribed()) {
          var url = plan.description.actions.subscribe + '?return_url=' + return_url;
          if (discountCode) {
            url += '&discount_code=' + discountCode;
          }
          if (referralUsername) {
            url += '&referral_username=' + referralUsername;
          }
          $http.get(url).success(function(data) {
            if (plan.description.price_after_discount !== 0) {
              $window.location.href = data.data.payment.status.gw_url;
            } else {
              $window.location.href = '/u/' + userService.user.username;
            }
          }).error(function() {
            $window.alert('Subscription failed');
          });
        } else {
          loginModal.open();
        }
      },
      isSubscribed: function() {
        return userService.status.logged && !userService.status.loading;
      }
    };

    return that;
  }])

  .factory('customConfigService', ["$http", "configService", function($http, configService) {
    var that = {
      setConfig: function (config) {
        var promise = $http.post('/common/custom_config/', config);
        promise.success(function() {
          configService.loadConfig();
        });
        return promise;
      },
    };
    return that;
  }])

  .factory('thumbnailService', ["$http", function($http) {
    var thumbnailsBase64 = {};
    var promise = $http.get('/static/dist/thumbnails.json', {cache : true});
    promise.success(function(data) {
      thumbnailsBase64 = data;
    });

    var that = {
      getThumbnail: function (path) {
        if (thumbnailsBase64[path]) {
          return 'data:image/png;base64,' + thumbnailsBase64[path];
        }
      },
    };
    return that;
  }])

  .factory("resourceCache",["$cacheFactory",
    function($cacheFactory) { 
      return $cacheFactory("resourceCache"); 
    }
  ]);

angular.module('gettext').run(['gettextCatalog', function (gettextCatalog) {
/* jshint -W100 */
    gettextCatalog.setStrings('cs', {"1. Vybereš si orgánový systém nebo část těla":"1. Vybereš si orgánový systém nebo část těla","2. Poznáváš anatomické struktury a názvy":"2. Poznáváš anatomické struktury a názvy","3. Sleduješ, jak ti rostou znalosti":"3. Sleduješ, jak ti rostou znalosti","Adresa profilu":"Adresa profilu","Anatom.cz":"Anatom.cz","Ano":"Ano","Body":"Body","Chybné odpovědi":"Chybné odpovědi","Co získám?":"Co získám?","Cvičením a opakováním rostou Tvoje znalosti. V \n      <a href=\"/overview/\">přehledu znalostí</a> vidíš,\n      co Ti jde dobře a co je potřeba ještě cvičit.":"Cvičením a opakováním rostou Tvoje znalosti. V \n      <a href=\"/overview/\">přehledu znalostí</a> vidíš,\n      co Ti jde dobře a co je potřeba ještě cvičit.","Data od všech uživatelů":"Data od všech uživatelů","E-mail":"E-mail","Heslo":"Heslo","Heslo znovu":"Heslo znovu","Jak to funguje?":"Jak to funguje?","Jméno":"Jméno","Kvalitní obrázky":"Kvalitní obrázky","Moje znalosti":"Moje znalosti","Moje časté chyby":"Moje časté chyby","Můžeš si vybrat, co chceš procvičovat. Obrázky jsou setřízeny podle\n      orgánového systému a základního umístění na těle.":"Můžeš si vybrat, co chceš procvičovat. Obrázky jsou setřízeny podle\n      orgánového systému a základního umístění na těle.","Nahlásit chybu":"Nahlásit chybu","Ne":"Ne","Nevím":"Nevím","Otázky Tobě na míru":"Otázky Tobě na míru","Pokračovat":"Pokračovat","Poslat mi email při neplnění cílů":"Poslat mi email při neplnění cílů","Procvičovat":"Procvičovat","Procvičování anatomie člověka na míru tvým znalostem.":"Procvičování anatomie člověka na míru tvým znalostem.","Prohlížet":"Prohlížet","Průměrný nový uživatel":"Průměrný nový uživatel","Přehled znalostí":"Přehled znalostí","Přehled znalostí uživatele":"Přehled znalostí uživatele","Přehledná anatomické schámata z úspěšné učebnice \n        <a href=\"http://memorix.cz/\">Memorix Anatomie</a>.\n        Obrázky byly vybrány tak, aby reprezentovaly základní znalosti, které\n        mohou být u studentů medicíny vyžadovány u zkoušky z anatomie.":"Přehledná anatomické schémata z úspěšné učebnice \n        <a href=\"http://memorix.cz/\">Memorix Anatomie</a>.\n        Obrázky byly vybrány tak, aby reprezentovaly základní znalosti, které\n        mohou být u studentů medicíny vyžadovány u zkoušky z anatomie.","Přiblížit mapu můžete i kolečkem myši nebo dotykovým gestem.":"Přiblížit mapu můžete i kolečkem myši nebo dotykovým gestem.","Přihlásit se":"Přihlásit se","Příjmení":"Příjmení","Registrace proběhla úspěšně. Můžete pokračovat v používání aplikace.":"Registrace proběhla úspěšně. Můžete pokračovat v používání aplikace.","Registrovat se":"Registrovat se","Registrujte se":"Registrujte se","Sdílej svůj profil":"Sdílej svůj profil","Správné odpovědi":"Správné odpovědi","Uložit":"Uložit","Umíš pojmenovat zvýrazněný sval? Umíš na obrázku najít zadanou strukturu?\n      Po odpovědi se okamžitě dozvíš správnou odpověď.":"Umíš pojmenovat zvýrazněný sval? Umíš na obrázku najít zadanou strukturu?\n      Po odpovědi se okamžitě dozvíš správnou odpověď.","Upravit profil":"Upravit profil","Uživatelské jméno":"Uživatelské jméno","V čem je Anatom.cz výjimečný?":"V čem je Anatom.cz výjimečný?","Vybráno":"Vybráno","Začít procvičovat":"Začít procvičovat","Znovu procvičovat":"Znovu procvičovat","Znovu zvýraznit":"Znovu zvýraznit","Zrušit":"Zrušit","a získejte všechny výhody registrovaných uživatelů.":"a získejte všechny výhody registrovaných uživatelů.","přes E-mail":"přes E-mail","přes Facebook":"přes Facebook","přes Google":"přes Google","přibývají za každou správnou odpověď":"přibývají za každou správnou odpověď","Úspěšnost":"Úspěšnost","Žádné časté chyby nebyly nalezeny":"Žádné časté chyby nebyly nalezeny"});
    gettextCatalog.setStrings('en', {"1. Vybereš si orgánový systém nebo část těla":"1. Choose an organ system or a body part","2. Poznáváš anatomické struktury a názvy":"2. Recognize the anatomical structure and its name","3. Sleduješ, jak ti rostou znalosti":"3. Watch your knowledge growing","Alternativní názvy":"Alternative names","Anatom.cz":"PracticeAnatomy.com","Anatom.cz je vyvíjen na <a href=\"http://www.fi.muni.cz/\">\n    Fakultě informatiky Masarykovy univerzity</a>, \n    konkrétně v rámci skupiny <a href=\"http://www.fi.muni.cz/adaptivelearning/\">Adaptive Learning</a>.":"PracticeAnatomy.com is being developed at <a href=\"http://www.fi.muni.cz/\">Faculty of Informatics of Masaryk University</a> (Brno, Czech republic) by  <a href=\"http://www.fi.muni.cz/adaptivelearning/\">Adaptive Learning research group</a>.","Anatomická schémata laskavě poskytli autoři úspěšné učebnice <a href=\"http://anatomie.memorix.cz/\">Memorix Anatomie</a>. Za zpracování obrázků a\n    medicínskou správnost zodpovídá: MUDr. <strong>Linda\n    Kašičková</strong> (koordinátorka, lékařka FN Ostrava), MUDr. <strong>Marek\n    Čierny</strong> (lékař Medical College of Wisconsin), MUDr. <strong>Ondřej Volný</strong>\n    (anatom, lékař NK FN u Sv. Anny). Na tvorbě obsahu Anatoma se významně podílejí následující studenti léařství LF MU v Brně: \n      <strong>David Dufek, Lýdia Nováková, Adriana Slaníková, Albert Štěrba, a Magda Šubrtová.</strong>           \n    Děkujeme studentům a studentkám, kteří s tvorbou Anatoma pomáhali v minulosti: Veronice Puchnerové, Michaele Janákové a Karolíně Svobodové.":"Anatomical drawings were kindly provided by authors of a successful textbook <a href=\"http://anatomy.memorix.cz/\">Memorix Anatomy</a>. \nThe medical precision is a work and responsibility of: Dr. <strong>Linda Kašičková</strong> (coordinator, resident at Univeristy Hospital Ostrava), Dr. <strong>Marek Čierny</strong> (resident at Medical College of Wisconsin Affil. hospitals), Dr. <strong>Ondřej Volný</strong>  (anatomist, physician at St. Anne's Univeristy Hospital Brno).  The content of Practice Anatomy would not be made possible without the contribution of the following medical students of Medical Faculty of Masaryk University in Brno:  <strong>David Dufek, Lýdia Nováková, Adriana Slaníková, Albert Štěrba, a Magda Šubrtová.</strong> Thank you!\nWe would like to thank also to our previous collaborators: Veronika Puchnerová, Michaela Janáková and Karolína Svobodová.","Anatomické obrázky a schémata jsou autorsky chráněna, a jejich kopírování, stahování, nebo dokonce distribuce jsou zakázány. V případě, že byste je chtěli využít jakkoli jinak než k prostému užití, jak nabízí aplikace, je nutné mít písemné svolení držitele autorskách práv (Radovan Hudák).\n    Podrobné <a href=\"/terms-of-use-cs\" rel=\"nofollow\">právní podmínky užití Anatoma najdete tady</a>.":"All pictures and drawings and other content are protected by the authors. Copying, downloading, or distribution is prohibited. Please see our <a href=\"/terms-of-use-en\" rel=\"nofollow\">terms of use</a> for details. In the case you would be interested in the use of the website content in a different way than simply using this online application, please contact the owner of the author's rights (most frequently Dr. Radovan Hudak).","Ano":"Yes","Atlas anatomie lidského těla":"Atlas of human body anatomy","Baví Tě anatomie? Chceš se zapojit do tvorby Anatoma? Hledáme dobrovolníky, kteří nám pomůžou popisovat anatomická schemata, přidávat anatomické a klinické souvislosti, a testovat nové funkce. Intenzita spolupráce záleží na Tvých možnostech, i třeba jen 2-4 hodiny měsíčně nám mohou pomoci posunout Anatoma dále. Napiš nám na <span class=\"email contact\">anatom{zavinac}memorix.cz</span> a domluvíme se.":"Do you enjoy anatomy? Would you like to contributo to PracticeAnatomy? He are looking for volunteers, who would help us translate our app to local languages, name anatomical structures on pictures, add anatomical and clinical correlations or test new features. The intensity of contribution depends on your capacity, even 2-4 hours per month may help improve the features of PracticeAnatomy. Please contact us at <span class=\"email contact\">anatom{zavinac}memorix.cz</span> and we'll find what fits you.","Bez kódu":"No code","Bez psaní":"No writing","Byl zadán neplatný slevový kód '{{discountCode}}'.":"Invalid discount code '{{discountCode}}'.","Částečně refundováno":"Partly refunded","Části těla":"Body parts","Cena":"Price","Cíle":"Mission","Co je zvýrazněno?":"What is highlighted?","Co uvidí na sdílené stránce ostatní?":"What can others see on the shared page?","Cvičením a opakováním rostou Tvoje znalosti anatomie. V \n      <a href=\"/overview/\">přehledu znalostí</a> vidíš,\n      co Ti jde dobře a co je potřeba ještě procvičovat.":"Practice makes perfect. See how your knowledge of anatomy grows, and identify the areas where you could improve in <a href=\"/overview/\">knowledge overview</a>.","Data o odpovědích jsou ukládána a jsou využívána pro výběr vhodných otázek a pro výzkumné účely. Všechna tato data jsou zpracovávána anonymně. Přihlašovací údaje (Facebook, Google) jsou použity pouze pro určení identity při opakovaných návštěvách, jinak se s nimi nepracuje. \n     Podrobné informace najdete v <a href=\"/privacy-policy-cs\" rel=\"nofollow\">Zásadách ochrany osobních údajú</a>.":"Data about your responses are being saved and used in order to improve user experience (select the most appropriate next question) and research purposes. All research analyses are performed on anonymized data. The data from registration (Facebook, Google) are used only for identification during recurrent visits. We will not provide user identification data to a third party.\nFor details, see <a href=\"/privacy-policy-en\" rel=\"nofollow\">Privacy Policy</a>.","Data od všech uživatelů":"As you learn, we learn with you","Délka sady":"Set length","Díky tomu, že má aplikace uložené odpovědi od všech uživatelů, kteří ji\n    použili před Tebou, může vyhodnotit, které struktury jsou obecně lehké a\n    které těžké. Díky tomu má aplikace již po několika Tvých odpovědích slušnou\n    představu jak dobré jsou Tvoje znalosti anatomie a adekvátně tomu volit další\n    otázky. Tvoje znalosti Ti umí aplikace ukázat na každém obrázku pomocí obarvení\n    jednotlivých částí barvami na škále od červené po zelenou.":"The application remember responses from all users who have ever used it, and therefore, it can evaluate which structures are generally easy and which hard. \nBased on your previous answers, we choose the next question that we think has the most appropriate difficulty for you. The application can show you your knowledge of anatomy in each image by coloring\neach part with a color from a color scale ranging from red to green.","Doporučit kamarádovi":"Recommend to a friend","E-mail":"E-mail","Extra jednoduché":"Extra easy","Extra těžké":"Extra hard","Faktura":"Invoice","Hledáme dobrovolníky":"We are looking for volunteers","Hledaný profil neexistuje.":"The profile does not exist.","Hodně zdaru při učení anatomie,<br>Honza, Linda, Marek a Víťa":"Good luck with practicing anatomy, <br>Honza, Linda, Marek a Víťa","Jak se počítá odhad znalostí?":"How is the estimate of knowledge calculated?","Jak to funguje?":"How does it work?","Jazyk terminologie":"Terminology language","Jednoduché":"Easy","Již máš odpovězených <b>{{userService.user.profile.number_of_answers}}</b>\n  odpovědí. Ulož si svůj postup, aby aplikace mohla dlouhodobě přizpůsobovat otázky Tvým znalostem.":"You have already answered <b>{{userService.user.profile.number_of_answers}}</b>\nquestions. Save your progress, so that the app can adapt the questions to your knowledge in long term.","Abychom vám pomohli strávit smysluplně volné chvíle při stávající situaci okolo pandemie způsobené virem SARS-CoV-2, rozhodli jsme se vám poskytnout měsíční předplatné zdarma.":"To help you spend meaningful moments in the current pandemic situation caused by SARS-CoV-2, we've decided to give you a free monthly subscription.","Jméno":"First name","Každá struktura na obrázku je obarvena podle toho jak dobře ji podle našeho prediktivního modelu umíš. U struktur, na které jsi ještě neodpovídal(a), se znalost počítá na základě správnosti tvých odpovědí na ostatních otázkách a toho jak úspěšně na danou strukturu odpovídali ostatní uživatelé. Každou správnou odpovědí pak vylepšuješ svůj odhad znalosti dané struktury.":"Each structure in the picture is colored according to how well you know it according to our predictive model. For structures you did not answer yet, the knowledge is calculated based on the correctness of your responses to other questions, and how successfully was the structure answered by other users. Each correct answer then improves your estimate of the knowledge of the structure.","Kdo stojí za obsahem":"Content","Kdo stojí za vývojem":"Development","Kód již využilo {{discountCodeUsage.usage}} uživatelů.\n        Zbývá <strong>{{discountCodeUsage.usage_left}}</strong> použití.":"The code has been used by {{discountCodeUsage.usage}} users.\nRemaining number of usages is <strong> {{discountCodeUsage.usage_left}} </ strong>.","Koupit teď":"Buy now","Kromě":"Except","Kvalitní obrázky":"High quality pictures","Lebka":"Skull","Lékařská fakulta Masarykovy univerzity":"Medical Faculty of Masaryk University","Memorix Anatomie":"Memorix Anatomy","Memorix anatomie":"Memorix Anatomy","Mezi další projekty naší skupiny patří:":"Other projects by our group include:","Moje předplatné":"My subscriptions","Mozek":"Brain","Mozková část hlavy":"Head - Brain","Můžeš si vybrat, co chceš procvičovat. Obrázky jsou setřízeny podle\n      orgánového systému a základního umístění na těle.":"You can choose what do you want to practice. Just choose the organ system or part of the body you want to practice.","Na obrázku: \"{{imageName}}\"\n{{url}}\nv otázce:\n{{question}}\nje tato chyba:":"In image: \"{{imageName}}\"\n{{url}}\nin question:\n{{question}}\nis this error:","Na vývoji aplikace anatom.cz a modelu, který Vám vybírá otázky na míru, se podílí především <strong>Vít Stanislav</strong>, <strong>Jan Papoušek</strong> a <strong>Jiří Řihák</strong> (PhD studenti FI MU).":"PracticeAnatomy.com and the software model is being developed mostly by <strong>Vít Stanislav</strong>, <strong>Jan Papoušek</strong> a <strong>Jiří Řihák</strong> (PhD students, Faculty of Informatics, Masaryk University).","Na základě odpovědí od všech uživatelů model ví, co je jak těžké. Na těžší pojmy se Tě raději zeptá víc krát, než usoudí, že je opravdu umíš, zato lehčími Tě možná vůbec otravovat nebude. Když ti půjdou ty těžší, tak prostě usoudí, že ty lehké umíš taky a zeptá se Tě na ně až po procvičení těch těšžích.":"Based on the answers from all users the model knows how difficult each term is. About the more difficult terms it prefers to ask multiple times before deciding that you know it, but with easier ones it might not even bother asking you. When you know the more difficult ones, it will conclude that you know the easier ones too, and will ask you about them only after practicing the more difficult ones.","Nahlásit chybu":"Report Error","Najdi a pojmenuj 2000 pojmů na více než 200 obrázcích.":"Recognize and name 2000 anatomical structures in more than 200 pictures.","Náměty a připomínky":"Feedback","Nastav si obtížnost procvičování, délku sady a typ otázek tak, jak ti vyhovuje.":"Adjust the difficulty of the practice, set length and type of questions as it suits you.","Nastavení":"Settings","Nastavení bylo uloženo.":"Settings were saved","Naučeno":"Learned","Ne":"No","Nemáš žádné předplatné. Podívej se jaké máš možnosti.":"You have no subscription at the moment. See your options.","Nenaučeno":"Unlearned","Nevím":"Don't know","O projektu":"About us","Obličejová část hlavy":"Facial pat of the head","Obtížnost otázek":"Questions' difficulty","Ochrana díla":"Content protection","Od našich uživatelů jsme nasbírali již\n                        <strong ng-bind=\"stats.number_of_answers | number\">\n                          {{stats.number_of_answers}}\n                        </strong>\n                        odpovědí, čehož si nesmírně vážíme. Aplikace opravdu\n                        pomáhá a my ji chceme dál rozvíjet. Vývoj a rozšiřování aplikace nás však stojí hodně úsilí, a proto\n                        budeme rádi, když nás finačně podpoříš. Poskytneme ti\n                        užitečný výukový obsah a možnost nastavit si \n                        procvičování podle osobních preferencí.":"Our users already practiced \n<strong ng-bind=\"stats.number_of_answers | number\">\n{{stats.number_of_answers}}\n</strong>\nanatomical questions. We are delighted that we are helping them to become great physicians. But we can still improve. Broadening the scope and it's clinical relevance is a \ndemanding job, and we are grateful for your contribution. We will give you access to premium content and advanced settings.","Odhad tvých znalostí":"Estimate of your knowledge","Odhad znalosti":"Knowledge estimate","Odpověď můžeš vybrat kliknutím na příslušnou část na obrázku.":"The answer can be selected by clicking on the relevant part of the picture.","Omlouváme se, ale požadovaná stránka nebyla bohužel nalezena.":"We are sorry, the requested page is not found, unfortunately.","Opakování lékařské anatomie":"Review medical anatomy","Orgánové systémy":"Organ systems","Otázky Tobě na míru":"Questions fitted to your knowledge","Otevřené otázky byly zakázány.":"Open questions were forbidden.","Platné do":"Valid until","Počet naučených pojmů počítá náš prediktivní model":"The number of learned terms is computed by our predictive model","Pochlub se svými znalostmi":"Show off your knowledge","Pojmy na obrázcích":"Terms in images","Pokračovat":"Continue","Pokračovat v procvičování":"Continue to practice","Pokročilé nastavení":"Advanced setting","Pokud problém přetrval zkuste to znovu později nebo":"If the problem persists try again later or","Pokud studujete na FI a máte zájem se zapojit do vývoje podobného typu systémů,\n    případně pokud máte zájem o výzkumnou spolupráci, kontaktujte <a href=\"http://www.muni.cz/people/4297\">Radka Pelánka</a>.":"If you are interested in research cooperation in the field of machine learning for educational applications, please contact <a href=\"http://www.muni.cz/people/4297\">Radek Pelanek</a>.","Pomáhá ti anatom.cz s učením? Podpoř další rozvoj projektu zakoupením předplatného a získej přístup k premium obsahu.":"Does PracticeAnatomy.com help you with learning? Support further development of the project by purchasing a subscription and get access to premium content.","Pomocí názvů dotázaných pojmů můžeš přepínat mezi obrázky k jednotlivým odpovědím.":"Using names of asked terms you can switch between images for individual answers.","Pospojuj si vědomosti o svalech - začátek a úpon, funkce a antagonista, inervace a cévní zásobení. Dalších 1000 otázek!":"Connect your knowledge of muscle anatomy. Practice additional 1000 questions on origin, insertion, function, antagonist, innervation, and blood supply!","Pospojuj si vědomosti o svalech - začátek a úpon, funkce a antagonisty, inervaci a cévní zásobení.":"Connect your knowledge of muscle anatomy. Practice origin, insertion, function, antagonist, innervation, and blood supply!","Potvrdit":"Confirm","Požadovaná stránka je dostupná jenom uživatlům s předplatným.":"Requested page is only available to subscribed users.","Pravděpodobně nastala jedna z následujících situací:":"Probably one of the following situations happened:","Předautorizováno":"Pre-authorized","Předplatné":"Subscription","Přehled znalostí":"Knowledge Overview","Přehledná anatomické schámata z úspěšné učebnice \n          <a href=\"http://memorix.cz/\">Memorix Anatomie</a>.\n          Obrázky byly vybrány tak, aby reprezentovaly základní znalosti, které\n          mohou být u studentů medicíny vyžadovány u zkoušky z anatomie.":"Concise anatomical pictures are from a successful textbook <a href=\"http://memorix.cz/\"> Memorix Anatomy </a>. The structures and pictures in this application represents an essential knowledge for medical students to successfully complete an anatomy exam.","Premium obsah":"Premium content","Přijde Ti aplikace užitečná? Co bys vylepšil?":"Is the application helpful for you? What would you improve?","Příjmení":"Surname","Primárním cílem projektu Anatom.cz je usnadnit studentům medicíny, antropologie a dalším zájemcům o anatomii procvičování svých znalostí. Opakováním přehledných schémat z Memorixu Anatomie si každý může pohodlně upevňovat své vědomosti. Sekundárním cílem je vyzkoušet přínos inovativního softwarového modelu, který se na základě Vašich předchozích odpovědí snaží vybrat Vám následující otázku adekvátní obtížnosti.":"Our mission is to help students of medicine, anthropology or just anyone interested in human anatomy to practice their knowledge. Reviewing and recognizing anatomical structures  and names (either in English or Latin) with pictures from Memorix Anatomy reinforces your knowledge. Our secondary goal is to examine the benefit of an innovative software model, which based on previous answers chooses the next question of the appropriate difficulty.","Připravujeme":"Coming soon","Přístup zamítnut":"Access denied","Pro vyřešení problému zkuste":"To resolve the problem try to","Procvičování anatomie člověka na míru tvým znalostem.":"Practice medical anatomy with personalized questions.","Procvičováno":"Practiced","Procvičovat":"Practice","Procvičovat kapitolu":"Practice chapter","Procvičovat obrázek":"Practice image","Procvičovat podkapitolu":"Practice subchapter","Procvičovat vše":"Practice all","Procvičovat vybrané":"Practice selected","Procvičuj":"Quiz","Procvičuj anatomické souvislosti":"Practice anatomical relations","Procvičuj si anatomii s námi":"Practice anatomy with us","Projekt Anatom.cz vznikl ve spolupráci skupiny Adaptive learning z FI MU a Memorix týmu zahrnující klinické lékaře a studenty LF MU v Brně.":"Practice Anatomy is a joint project of research group Adaptive Learning at Faculty of Informatics of Masaryk University, and team Memorix comprising clinicians and medical students at Medical Faculty of Masaryk University, Brno, Czech republic.","Rádi bychom vyslechli Tvoje náměty k rozvoji systému, připomínky a stížnosti k beta verzi. Když nám pošleš email na <span class=\"email contact\">anatom{zavinac}memorix.cz</span>, pomůžeš nám aplikaci zdokonalit pro sebe i ostatní uživatele.":"We would love to hear your experiences, criticism and suggestions for improvement of this beta version. Please feel free to send us your feedback at <span class=\"email contact\">anatom{at}memorix.cz</span> at any time - you’ll help us improve the Practice Anatomy app for you and everyone else.","Refundováno":"Refunded","Registrovat se":"Sign up","Sdílej referal odkaz, prodluž si své předplatné":"Share referral link, extend your subscription","Sdílet":"Share","Slevový kód:":"Discount code:","Soukromí":"Privacy ","Souvislosti":"Relations","Souvislosti svalů":"Muscle properties","Správná odpověď":"Correct answer","Srdce":"Hearth","Stránka nebyla nalezena":"Page not found","Systém sleduje, jak Ti anatomie jde, a podle toho vybírá další otázky. Pokud\n    hned zvládáš i těžké otázky, nemá smysl Tě dlouho zdržovat s jednoduchými. Když\n    ale máš problémy i s jednoduchými, aplikace se nebude pouštět hned do\n    těžkých. Obtížnost otázek se tak přizpůsobuje Tvým vědomostem.":"The system tracks what are you good at, and selects the next question accordingly. If you manage to answer the tough questions, we will not bother you with the simple ones. On the other hand, if you are just beginning to learn anatomy, we will not flood you with advanced questions. The difficulty of questions we ask you is personalized and adapts to your knowledge.","Tato otázka je bez obrázku.":"This question is without an image","Těžké":"Hard","Tip k ovládání":"Control tip","Toto nastavení mohou měnit jen uživatelé s předplatným.":"These settings can only be changed by users with subscription.","Typ otázek":"Question type","Typy předplatného":"Subscription types","Ukázka procvičování":"Sample practice","Ukázka znalostí":"Sample knowledge","Ukládání nastavení selhalo.":"Saving settings failed.","Ukládání změn...":"Saving changes...","Uložit":"Save","Umíš pojmenovat zvýrazněný sval? Umíš na obrázku najít zadanou strukturu?\n      Po odpovědi se okamžitě dozvíš správnou odpověď.":"Which muscle is highlighted? Can you find a given structure in the picture? You will see the correct answer immediately after you choose your answer.","Uplatnit":"Use","Úspěšnost":"Success rate","Uvedené ceny jsou po uplatnění slevového kódu '{{discountCode}}'.":"The prices are after applying the discount code '{{discountCode}}'.","V aplikaci bohužel nastala chyba.":"Unfortunately there has been an error in the app.","V čem je Anatom.cz výjimečný?":"What makes PracticeAnatomy.com special?","Všechny typy":"All types","Vyber":"Choose","Výběr kapitoly":"Chapter selection","Vyber si libovolnou kombinaci orgánových sytémů a částí těla (v pravém horním rohu každé dlaždice).":"Select any combination of organ systems and body parts (in the upper right corner of each tile).","Výběr z možností":"Multiple-choice","Vybírat otázky pro tebe nám pomáhá\n        <span class=\"badge badge-default\" ng-bind=\"stats.number_of_answers | number\">\n            {{stats.number_of_answers}}\n          </span>\n        odpovědí našich uživatelů.":"The app selects questions for you with the aid of\n<span class=\"badge badge-default\" ng-bind=\"stats.number_of_answers | number\">\n{{stats.number_of_answers}}\n</span>\nanswers of our users.","Vybrané části těla:":"Selected body parts","Vybrané orgánové systémy:":"Selected organ systems","Vybrané typy souvislostí:":"Selected types of muscle properties:","Vybráno":"Selected","Vybrat":"Select","Vybrat část těla":"Select a body part","Vybrat kapitolu":"Select a chapter","Vybrat orgánový systém":"Select an organ system","Vybrat předplatné":"Choose subscription","Vybrat souvislosti":"Select relations","Vybrat všechno":"Select everything","Výchozí":"Default","Vypršel časový limit na zaplacení":"Timeouted","Vytvořeno":"Created","Vyzkoušej demo":"Try demo","Vyzkoušet zdarma":"Try for free","Za použití dat o učení, které máme k dispozici, učiníme tvoje procvičování efektivní.":"Using data on learning that we have available, we will make your practice efficient.","Začít procvičovat":"Start practice","Začít procvičovat vše":"Start practicing all","Začni psát odpověď...":"Start typing the answer...","Zadaný slevový kód byl již použit maximálním počtem uživatelů.":"The specified discount code has already been used the maximum number of users.","Zadaný slevový kód nemůžež použít podruhé.":"You cannot use the given discount code again.","Zaplaceno":"Paid","Zaplatit":"Pay","Zavřít":"Close","Zdarma":"Free","Zdroj":"Source","Získej přístup k tomuto obsahu zakoupením předplatného.":"Get access to this content by purchasing a subscription.","Zjistit více":"Learn more","Zjistit více o předplatném":"Learn more about subscription","Znovu povolit":"Allow again","Zrušeno":"Canceled","Zrušit výběr":"Cancel selection","anatomie.memorix.cz":"memorix.cz","byla špatně napsána www adresa (překlep, zastaralá oblíbená položka atp.),":"badly written web address (typo, outdated bookmark, etc.)","interní odkaz v rámci aktuálního webu byl neplatný,":"internal link in the current site was invalid,","nám napiště":"write to us","obnovit stránku":"refresh the page","odkaz z jiného webu byl zastaralý nebo neplatný.":"link from another site was outdated or invalid.","odkaz z výsledků vyhledávače byl zastaralý,":"link from the search results was outdated,","str.":"p."});
/* jshint +W100 */
}]);
angular.module('proso.anatomy.templates', []).run(['$templateCache', function($templateCache) {
  $templateCache.put("static/tpl/404.html",
    "<br>\n" +
    "<div>\n" +
    "  <div class=\"col-sm-offset-2 col-sm-8\">\n" +
    "    <div class=\"panel panel-default\">\n" +
    "      <div class=\"panel-body\">\n" +
    "        <h1 class=\"text-center\" translate>Stránka nebyla nalezena</h1>\n" +
    "        <p class=\"alert alert-danger\" translate>\n" +
    "          Omlouváme se, ale požadovaná stránka nebyla bohužel nalezena.\n" +
    "        </p>\n" +
    "        <p translate>\n" +
    "          Pravděpodobně nastala jedna z následujících situací:\n" +
    "        </p>\n" +
    "        <ul>\n" +
    "          <li translate>byla špatně napsána www adresa (překlep, zastaralá oblíbená položka atp.),</li>\n" +
    "          <li translate>odkaz z výsledků vyhledávače byl zastaralý,</li>\n" +
    "          <li translate>interní odkaz v rámci aktuálního webu byl neplatný,</li>\n" +
    "          <li translate>odkaz z jiného webu byl zastaralý nebo neplatný.</li>\n" +
    "        </ul>\n" +
    "\n" +
    "\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
  $templateCache.put("static/tpl/about.html",
    "<br>\n" +
    "<div class=\"row\">\n" +
    "  <div class=\"col-sm-offset-2 col-sm-8\">\n" +
    "    <div class=\"panel panel-default\">\n" +
    "      <div class=\"panel-heading\">\n" +
    "        <h1 translate>O projektu</h1>\n" +
    "      </div>\n" +
    "      <div class=\"panel-body\">\n" +
    "    <p translate>\n" +
    "    Projekt Anatom.cz vznikl ve spolupráci skupiny Adaptive learning z FI MU a Memorix týmu zahrnující klinické lékaře a studenty LF MU v Brně. \n" +
    "    </p>\n" +
    "    <h3 translate>Cíle</h3>\n" +
    "    <p translate>\n" +
    "    Primárním cílem projektu Anatom.cz je usnadnit studentům medicíny, antropologie a dalším zájemcům o anatomii procvičování svých znalostí. Opakováním přehledných schémat z Memorixu Anatomie si každý může pohodlně upevňovat své vědomosti. Sekundárním cílem je vyzkoušet přínos inovativního softwarového modelu, který se na základě Vašich předchozích odpovědí snaží vybrat Vám následující otázku adekvátní obtížnosti.\n" +
    "    </p>\n" +
    "    <h3 translate>Kdo stojí za vývojem</h3>\n" +
    "\n" +
    "    <a href=\"http://www.fi.muni.cz/adaptivelearning/\" class=\"pull-right al-logo\">\n" +
    "      <img src=\"/static/img/al-logo.png\" alt=\"Adaptive Learning logo\"/>\n" +
    "    </a>\n" +
    "    <p translate>\n" +
    "    Anatom.cz je vyvíjen na <a href=\"http://www.fi.muni.cz/\">\n" +
    "    Fakultě informatiky Masarykovy univerzity</a>, \n" +
    "    konkrétně v rámci skupiny <a href=\"http://www.fi.muni.cz/adaptivelearning/\">Adaptive Learning</a>. \n" +
    "    </p>\n" +
    "    <p translate>\n" +
    "    Mezi další projekty naší skupiny patří:\n" +
    "    </p>\n" +
    "    <ul>\n" +
    "      <li>\n" +
    "        <a href=\"http://slepemapy.cz/\">Slepé mapy</a>,\n" +
    "      </li>\n" +
    "      <li>\n" +
    "        <a href=\"http://tutor.fi.muni.cz/\">Problem Solving Tutor</a>,\n" +
    "      </li>\n" +
    "      <li>\n" +
    "        <a href=\"http://umimecesky.cz/\">Umíme česky</a>,\n" +
    "      </li>\n" +
    "      <li>\n" +
    "        <a href=\"http://matmat.cz/\">MatMat</a>,\n" +
    "      </li>\n" +
    "      <li>\n" +
    "        <a href=\"http://autoskolachytre.cz/\">Autoškola chytře</a>.\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "\n" +
    "    <p translate>\n" +
    "    Na vývoji aplikace anatom.cz a modelu, který Vám vybírá otázky na míru, se podílí především <strong>Vít Stanislav</strong>, <strong>Jan Papoušek</strong> a <strong>Jiří Řihák</strong> (PhD studenti FI MU).\n" +
    "    </p>\n" +
    "\n" +
    "    <p translate>\n" +
    "    Pokud studujete na FI a máte zájem se zapojit do vývoje podobného typu systémů,\n" +
    "    případně pokud máte zájem o výzkumnou spolupráci, kontaktujte <a href=\"http://www.muni.cz/people/4297\">Radka Pelánka</a>.\n" +
    "    </p>\n" +
    "    <h3 translate>Náměty a připomínky</h3>\n" +
    "    <p translate>\n" +
    "    Rádi bychom vyslechli Tvoje náměty k rozvoji systému, připomínky a stížnosti k beta verzi. Když nám pošleš email na <span class=\"email contact\">anatom{zavinac}memorix.cz</span>, pomůžeš nám aplikaci zdokonalit pro sebe i ostatní uživatele. \n" +
    "    </p>\n" +
    "    <h3 translate>Kdo stojí za obsahem</h3>\n" +
    "\n" +
    "\n" +
    "    <p translate>\n" +
    "    Anatomická schémata laskavě poskytli autoři úspěšné učebnice <a\n" +
    "    href=\"http://anatomie.memorix.cz/\">Memorix Anatomie</a>. Za zpracování obrázků a\n" +
    "    medicínskou správnost zodpovídá: MUDr. <strong>Linda\n" +
    "    Kašičková</strong> (koordinátorka, lékařka FN Ostrava), MUDr. <strong>Marek\n" +
    "    Čierny</strong> (lékař Medical College of Wisconsin), MUDr. <strong>Ondřej Volný</strong>\n" +
    "    (anatom, lékař NK FN u Sv. Anny). Na tvorbě obsahu Anatoma se významně podílejí následující studenti léařství LF MU v Brně: \n" +
    "      <strong>Samuel Bakoš, Mirka Marková, Markéta Setničková, Magda Šubrtová, Šárka Tomková, a Lýdia Nováková.</strong>           \n" +
    "    Děkujeme studentům a studentkám, kteří s tvorbou Anatoma pomáhali v minulosti: Davidu Dufkovi, Adrianě Slaníkové, Albertovi Štěrbovi, Veronice Puchnerové, Michaele Janákové a Karolíně Svobodové.\n" +
    "    </p>\n" +
    "    <br>\n" +
    "    <a href=\"http://www.med.muni.cz/\" class=\"pull-right\">\n" +
    "      <img src=\"/static/img/med-muni-logo.png\"\n" +
    "        alt=\"{{'Lékařská fakulta Masarykovy univerzity' | translate }}\"/>\n" +
    "    </a>\n" +
    "\n" +
    "    <p translate>\n" +
    "    Baví Tě anatomie? Chceš se zapojit do tvorby Anatoma? Hledáme dobrovolníky, kteří nám pomůžou popisovat anatomická schemata, přidávat anatomické a klinické souvislosti, a testovat nové funkce. Intenzita spolupráce záleží na Tvých možnostech, i třeba jen 2-4 hodiny měsíčně nám mohou pomoci posunout Anatoma dále. Napiš nám na <span class=\"email contact\">anatom{zavinac}memorix.cz</span> a domluvíme se.\n" +
    "  </p>\n" +
    "    <h3 translate>Soukromí</h3>\n" +
    "    <p translate>\n" +
    "    Data o odpovědích jsou ukládána a jsou využívána pro výběr vhodných otázek a pro výzkumné účely. Všechna tato data jsou zpracovávána anonymně. Přihlašovací údaje (Facebook, Google) jsou použity pouze pro určení identity při opakovaných návštěvách, jinak se s nimi nepracuje. \n" +
    "     Podrobné informace najdete v <a href=\"/privacy-policy-cs\" rel=\"nofollow\">Zásadách ochrany osobních údajú</a>.\n" +
    "    </p>\n" +
    "    <h3 translate>Ochrana díla</h3>\n" +
    "    <a href=\"http://anatomie.memorix.cz/\" class=\"pull-right\">\n" +
    "      <img ng-src=\"/static/img/memorix-logo-black-{{LANGUAGE_CODE}}.png\" alt=\"Memorix\"/>\n" +
    "    </a>\n" +
    "\n" +
    "    <p translate>\n" +
    "    Anatomické obrázky a schémata jsou autorsky chráněna, a jejich kopírování, stahování, nebo dokonce distribuce jsou zakázány. V případě, že byste je chtěli využít jakkoli jinak než k prostému užití, jak nabízí aplikace, je nutné mít písemné svolení držitele autorskách práv (Radovan Hudák).\n" +
    "    Podrobné <a href=\"/terms-of-use-cs\" rel=\"nofollow\">právní podmínky užití Anatoma najdete tady</a>.\n" +
    "    </p>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div class=\"clearfix\"></div>\n" +
    "<br>\n" +
    "\n" +
    "");
  $templateCache.put("static/tpl/color_scale_legend.html",
    "<div class=\"legend\">\n" +
    "  <div class=\"text-center\" >\n" +
    "    {{'Odhad tvých znalostí' | translate }}\n" +
    "   <i class=\"glyphicon glyphicon-question-sign help-icon\"\n" +
    "      popover-trigger=\"mouseenter\"\n" +
    "      popover-placement=\"bottom\"\n" +
    "      popover-append-to-body=\"true\"\n" +
    "      popover-title=\"{{'Jak se počítá odhad znalostí?' | translate}}\"\n" +
    "      popover=\"{{'Každá struktura na obrázku je obarvena podle toho jak dobře ji podle našeho prediktivního modelu umíš. U struktur, na které jsi ještě neodpovídal(a), se znalost počítá na základě správnosti tvých odpovědí na ostatních otázkách a toho jak úspěšně na danou strukturu odpovídali ostatní uživatelé. Každou správnou odpovědí pak vylepšuješ svůj odhad znalosti dané struktury.' | translate}}\"\n" +
    "      track-hover=\"image legend explanation\">\n" +
    "   </i>\n" +
    "  </div>\n" +
    "  <span translate>Nenaučeno</span>\n" +
    "  <span ng-repeat=\"value in values\"\n" +
    "      class=\"color-indicator\" \n" +
    "      style=\"background-color: {{(value/10) | probColor}}\">\n" +
    "  </span>\n" +
    "  <span translate>Naučeno</span>\n" +
    "</div>\n" +
    "");
  $templateCache.put("static/tpl/confirm_modal.html",
    "<div class=\"modal-body\">\n" +
    "  <button type=\"button\" class=\"close\" ng-click=\"cancel()\">\n" +
    "    <span aria-hidden=\"true\">&times;</span>\n" +
    "  </button>\n" +
    "  <h3 class=\"modal-title\"> {{ question }} </h3>\n" +
    "</div>\n" +
    "<div class=\"modal-footer\" >\n" +
    "        <a class=\"btn btn-lg btn-default\" ng-click=\"cancel()\">\n" +
    "          {{ \"Ne\" | translate }}\n" +
    "        </a>\n" +
    "        <a class=\"btn btn-lg btn-danger\" ng-click=\"confirm();cancel()\">\n" +
    "          {{ \"Ano\" | translate }}\n" +
    "        </a>\n" +
    "</div>\n" +
    "\n" +
    "");
  $templateCache.put("static/tpl/covid_banner.html",
    "<div class=\"beta-alert text-center alert alert-info\"\n" +
    "    ng-if=\"show\">\n" +
    "  <button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-label=\"Close\"\n" +
    "      track-click=\"close covid banner\">\n" +
    "    <span aria-hidden=\"true\">&times;</span>\n" +
    "    <span class=\"sr-only\" translate>Zavřít</span>\n" +
    "  </button>\n" +
    "  <span track-show=\"covid banner\" translate>\n" +
    "    Abychom vám pomohli strávit smysluplně volné chvíle při stávající situaci okolo pandemie způsobené virem SARS-CoV-2, rozhodli jsme se vám poskytnout měsíční předplatné zdarma.\n" +
    "  </span>\n" +
    "  <a class=\"btn btn-default\"\n" +
    "     track-click=\"covid banner\"\n" +
    "     ng-click=\"goto('/premium/?discount_code=staysafe2020')\"\n" +
    "     translate\n" +
    "    >Zjistit více</a>\n" +
    "</div>\n" +
    "");
  $templateCache.put("static/tpl/homepage.html",
    "<!--[if lte IE 8]>\n" +
    "  <div class=\"alert alert-danger old-browser\">\n" +
    "    Používáte <b>zastaralou verzi prohlížeče</b>, ve které aplikace\n" +
    "    <b>nemusí fungovat správně</b>. \n" +
    "    Pro optimální fungování aplikace doporučujeme nainstalovat \n" +
    "    aktuální verzi některého z běžně používaných prohlížečů. \n" +
    "    Například:\n" +
    "    <a href=\"https://www.google.com/intl/cs/chrome/browser/\">Google Chrome</a>,\n" +
    "    <a href=\"http://www.mozilla.org/cs/firefox/new/\">Firefox</a>,\n" +
    "    <a href=\"http://windows.microsoft.com/cs-CZ/internet-explorer/download-ie\">\n" +
    "        Internet explorer\n" +
    "    </a>\n" +
    "  </div>\n" +
    "  <![endif]-->\n" +
    "  <!--\n" +
    "  {% load i18n %}\n" +
    "    -->\n" +
    "  <div class=\"welcome-page jumbotron\">\n" +
    "      <div class=\"flatblock block-welcome_page col-lg-offset-2 col-lg-8\">\n" +
    "        <div class=\"flatblock-content\" >\n" +
    "          <span class=\"thumb category-02\">{{'Lebka' | translate}}</span>\n" +
    "          <span class=\"thumb category-09\">{{'Srdce' | translate}}</span>\n" +
    "          <span class=\"thumb category-12\">{{'Mozek' | translate}}</span>\n" +
    "        </div>\n" +
    "      <h1 >{{ \"Anatom.cz\"|translate }}</h1>\n" +
    "        <div class=\"flatblock-content\">{{ \"Procvičování anatomie člověka na míru tvým znalostem.\" | translate }}\n" +
    "        </div>\n" +
    "        <div class=\"flatblock-content\">\n" +
    "          <a href=\"/practice/\" \n" +
    "            class=\"btn btn-default btn-lg btn-huge\" \n" +
    "            track-click=\"homepage practice\" >\n" +
    "            {{\"Začít procvičovat vše\" | translate }}\n" +
    "          </a>\n" +
    "          <a href=\"/overview/?tab=system\" \n" +
    "            class=\"btn btn-default btn-lg btn-huge\" \n" +
    "            track-click=\"homepage choose system\" >\n" +
    "            {{\"Vybrat orgánový systém\" | translate }}\n" +
    "          </a>\n" +
    "          <a href=\"/overview/tab/location\" \n" +
    "            class=\"btn btn-default btn-lg btn-huge\" \n" +
    "            track-click=\"homepage choose bodypart\" >\n" +
    "            {{\"Vybrat část těla\" | translate }}\n" +
    "          </a>\n" +
    "          <a href=\"/relationsoverview/?tab=relation\" \n" +
    "            class=\"btn btn-default btn-lg btn-huge\" \n" +
    "            track-click=\"homepage choose relation\" >\n" +
    "            {{\"Vybrat souvislosti\" | translate }}\n" +
    "          </a>\n" +
    "        </div>\n" +
    "        <div class=\"flatblock-content\" >\n" +
    "        <span translate>\n" +
    "        Vybírat otázky pro tebe nám pomáhá\n" +
    "        <span class=\"badge badge-default\"\n" +
    "          ng-bind=\"stats.number_of_answers | number\" >\n" +
    "            {{stats.number_of_answers}}\n" +
    "          </span>\n" +
    "        odpovědí našich uživatelů.\n" +
    "        </span>\n" +
    "        <a href=\"\"\n" +
    "          track-click=\"homepage data explanation\"\n" +
    "          track-hover=\"homepage data explanation\"\n" +
    "          tooltip=\"{{'Zjistit více' | translate}}\"\n" +
    "          tooltip-placement=\"bottom\"\n" +
    "          scroll-to=\"data-explanation\">\n" +
    "          <i class=\"glyphicon glyphicon-question-sign help-icon\"></i>\n" +
    "        </a>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "  </div>\n" +
    "\n" +
    "<div class=\"how-it-works container-fluid\">\n" +
    "<h2>{{\"Jak to funguje?\" | translate }}</h2>\n" +
    "\n" +
    "  <div class=\"row works-div\">\n" +
    "    <div class=\"col-sm-offset-1 col-sm-10 col-lg-offset-3 col-lg-6\">\n" +
    "      <h3>{{\"1. Vybereš si orgánový systém nebo část těla\" | translate }}</h3>\n" +
    "      <p translate>\n" +
    "      Můžeš si vybrat, co chceš procvičovat. Obrázky jsou setřízeny podle\n" +
    "      orgánového systému a základního umístění na těle.\n" +
    "      </p>\n" +
    "      <a href=\"/overview/\">\n" +
    "        <img ng-src=\"/static/img/thumb/select-{{LANGUAGE_CODE}}.png\"\n" +
    "            alt=\"{{'Výběr kapitoly' | translate}}\"/>\n" +
    "      </a>\n" +
    "    </div>\n" +
    "    <div class=\"clearfix\"></div>\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"row works-div\">\n" +
    "    <div class=\"col-sm-offset-1 col-sm-10 col-lg-offset-3 col-lg-6\">\n" +
    "      <h3>{{\"2. Poznáváš anatomické struktury a názvy\" | translate }}</h3>\n" +
    "      <p translate>\n" +
    "      Umíš pojmenovat zvýrazněný sval? Umíš na obrázku najít zadanou strukturu?\n" +
    "      Po odpovědi se okamžitě dozvíš správnou odpověď.\n" +
    "      </p>\n" +
    "      <a href=\"/practice/\">\n" +
    "        <img ng-src=\"/static/img/thumb/practice-{{LANGUAGE_CODE}}.png\"\n" +
    "            alt=\"{{'Ukázka procvičování' | translate}}\"/>\n" +
    "      </a>\n" +
    "    </div>\n" +
    "    <div class=\"clearfix\"></div>\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"row works-div\">\n" +
    "      <div class=\"col-sm-offset-1 col-sm-10 col-lg-offset-3 col-lg-6\">\n" +
    "      <h3>{{\"3. Sleduješ, jak ti rostou znalosti\" | translate }}</h3>\n" +
    "      <p translate>\n" +
    "      Cvičením a opakováním rostou Tvoje znalosti anatomie. V \n" +
    "      <a href=\"/overview/\">přehledu znalostí</a> vidíš,\n" +
    "      co Ti jde dobře a co je potřeba ještě procvičovat. \n" +
    "      </p>\n" +
    "      <a href=\"/overview/\">\n" +
    "        <img ng-src=\"/static/img/thumb/knowledge-{{LANGUAGE_CODE}}.png\"\n" +
    "            alt=\"{{'Přehled znalostí' | translate}}\"/>\n" +
    "      </a>\n" +
    "    </div>\n" +
    "    <div class=\"clearfix\"></div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "\n" +
    "\n" +
    "<div class=\"how-it-works container-fluid exceptional\">\n" +
    "<h2>{{\"V čem je Anatom.cz výjimečný?\" | translate }}</h2>\n" +
    "\n" +
    "<div class=\"row works-div\">\n" +
    "  <div class=\"col-sm-offset-1 col-sm-10 col-lg-offset-3 col-lg-6\">\n" +
    "    <div class=\"row\">\n" +
    "      <div class=\"col-sm-7\" >\n" +
    "        <h3>{{\"Kvalitní obrázky\" | translate }}</h3>\n" +
    "        <p translate>\n" +
    "          Přehledná anatomické schámata z úspěšné učebnice \n" +
    "          <a href=\"http://memorix.cz/\">Memorix Anatomie</a>.\n" +
    "          Obrázky byly vybrány tak, aby reprezentovaly základní znalosti, které\n" +
    "          mohou být u studentů medicíny vyžadovány u zkoušky z anatomie.\n" +
    "        </p>\n" +
    "      </div>\n" +
    "      <div class=\"col-sm-4 col-sm-offset-1\" >\n" +
    "        <a href=\"http://{{'anatomie.memorix.cz' | translate}}\">\n" +
    "          <img ng-src=\"/static/img/book-{{LANGUAGE_CODE}}.png\"\n" +
    "            alt=\"{{'Memorix Anatomie' | translate}}\"/>\n" +
    "        </a>\n" +
    "      </div>\n" +
    "      <div class=\"clearfix\"></div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"clearfix\"></div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row works-div\" id=\"data-explanation\">\n" +
    "  <div class=\"col-sm-offset-1 col-sm-10 col-lg-offset-3 col-lg-6\">\n" +
    "    <h3>{{\"Data od všech uživatelů\" | translate }}</h3>\n" +
    "    <div translate>\n" +
    "    Díky tomu, že má aplikace uložené odpovědi od všech uživatelů, kteří ji\n" +
    "    použili před Tebou, může vyhodnotit, které struktury jsou obecně lehké a\n" +
    "    které těžké. Díky tomu má aplikace již po několika Tvých odpovědích slušnou\n" +
    "    představu jak dobré jsou Tvoje znalosti anatomie a adekvátně tomu volit další\n" +
    "    otázky. Tvoje znalosti Ti umí aplikace ukázat na každém obrázku pomocí obarvení\n" +
    "    jednotlivých částí barvami na škále od červené po zelenou.\n" +
    "    </div>\n" +
    "    <a href=\"/view/04/?context=svaly-krkusvg\">\n" +
    "      <img ng-src=\"/static/img/thumb/view-image-{{LANGUAGE_CODE}}.png\"\n" +
    "          alt=\"{{'Ukázka znalostí' | translate}}\"/>\n" +
    "    </a>\n" +
    "  </div>\n" +
    "  <div class=\"clearfix\"></div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row works-div\">\n" +
    "  <div class=\"col-sm-offset-1 col-sm-10 col-lg-offset-3 col-lg-6\">\n" +
    "    <h3>{{\"Otázky Tobě na míru\" | translate }}</h3>\n" +
    "    <div translate>\n" +
    "    Systém sleduje, jak Ti anatomie jde, a podle toho vybírá další otázky. Pokud\n" +
    "    hned zvládáš i těžké otázky, nemá smysl Tě dlouho zdržovat s jednoduchými. Když\n" +
    "    ale máš problémy i s jednoduchými, aplikace se nebude pouštět hned do\n" +
    "    těžkých. Obtížnost otázek se tak přizpůsobuje Tvým vědomostem.\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"clearfix\"></div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row works-div welcome-page-bottom\">\n" +
    "  <div class=\"col-sm-offset-1 col-sm-10 col-lg-offset-3 col-lg-6\">\n" +
    "    <div class=\"text-center\">\n" +
    "      <a href=\"/practice/\" \n" +
    "        class=\"btn btn-default btn-lg btn-huge\" \n" +
    "        track-click=\"homepage-bottom practice\" >\n" +
    "        {{\"Začít procvičovat\" | translate }}\n" +
    "      </a>\n" +
    "      <a href=\"/overview/?tab=system\" \n" +
    "        class=\"btn btn-default btn-lg btn-huge\" \n" +
    "        track-click=\"homepage-bottom choose system\" >\n" +
    "        {{\"Vybrat orgánový systém\" | translate }}\n" +
    "      </a>\n" +
    "      <a href=\"/overview/tab/location\" \n" +
    "        class=\"btn btn-default btn-lg btn-huge\" \n" +
    "        track-click=\"homepage-bottom choose bodypart\" >\n" +
    "        {{\"Vybrat část těla\" | translate }}\n" +
    "      </a>\n" +
    "      <a href=\"/relationsoverview/?tab=relation\" \n" +
    "        class=\"btn btn-default btn-lg btn-huge\" \n" +
    "        track-click=\"homepage-bottom choose relation\" >\n" +
    "        {{\"Vybrat souvislosti\" | translate }}\n" +
    "      </a>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"clearfix\"></div>\n" +
    "</div>\n" +
    "\n" +
    "\n" +
    "</div>\n" +
    "");
  $templateCache.put("static/tpl/image_click_help.html",
    "<div class=\"alert alert-info click-help\"\n" +
    "   ng-if=\"question.question_type == 't2d' &&\n" +
    "     userService.user.profile.number_of_answers <= 20 && \n" +
    "     timeouted &&\n" +
    "     !cookieSet\">\n" +
    "  <button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-label=\"Close\"\n" +
    "      set-cookie-on-click=\"imageHelpClosed\"\n" +
    "      track-click=\"close image click help banner\">\n" +
    "    <span aria-hidden=\"true\">&times;</span>\n" +
    "    <span class=\"sr-only\" translate>Zavřít</span>\n" +
    "  </button>\n" +
    "  <span translate>Odpověď můžeš vybrat kliknutím na příslušnou část na obrázku.</span>\n" +
    " </div>\n" +
    "\n" +
    "");
  $templateCache.put("static/tpl/image_generator.html",
    "<br>\n" +
    "<div class=\"container\">\n" +
    "  <div class=\"row\">\n" +
    "    <div class=\"col-sm-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2\">\n" +
    "      <div class=\"panel panel-default\">\n" +
    "        <div class=\"panel panel-body\">\n" +
    "          <div ng-repeat=\"context in contexts\">\n" +
    "            <span anatomy-image code=\"{{context.identifier}}\" ng-if=\"context.content\" ></span>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
  $templateCache.put("static/tpl/image_modal.html",
    "<div> \n" +
    "  <div image-view context-id=\"contextId\" stats=\"context.stats\" category=\"category\"></div> \n" +
    "  <div class=\"modal-footer\" ng-if=\"contexts.length\">\n" +
    "    <a href=\"/practice/{{category.identifier}}/?context={{context.identifier}}\"\n" +
    "        ng-click=\"close()\"\n" +
    "        track-click=\"image modal single practice\"\n" +
    "        class=\"btn btn-primary pull-left\"> \n" +
    "      <i class=\"glyphicon glyphicon-play\"></i>\n" +
    "      <span translate>Procvičovat obrázek</span>\n" +
    "    </a>\n" +
    "    <a ng-click=\"setNextContext(-1)\" class=\"btn btn-default\">\n" +
    "      <i class=\"glyphicon glyphicon-arrow-left\"></i>\n" +
    "      <span class=\"hidden-xs\">\n" +
    "        {{contexts[contexts.indexOf(context) - 1].name}}\n" +
    "      </span>\n" +
    "    </a>\n" +
    "    {{contexts.indexOf(context) + 1}} / {{contexts.length}}\n" +
    "    <a ng-click=\"setNextContext(+1)\" class=\"btn btn-default\">\n" +
    "      <span class=\"hidden-xs\">\n" +
    "        {{contexts[contexts.indexOf(context) + 1].name}}\n" +
    "      </span>\n" +
    "      <i class=\"glyphicon glyphicon-arrow-right\"></i>\n" +
    "    </a>\n" +
    "    <a ng-click=\"close()\" class=\"btn btn-default\"> \n" +
    "      <i class=\"glyphicon glyphicon-remove\"></i>\n" +
    "    </a>\n" +
    "  </div>\n" +
    "</div>\n" +
    "\n" +
    "");
  $templateCache.put("static/tpl/image_view.html",
    "<div class=\"panel panel-default\">\n" +
    "  <div class=\"panel-heading\">\n" +
    "    <div class=\"row\">\n" +
    "      <div class=\"col-sm-7\">\n" +
    "        <a class=\"pull-left\"\n" +
    "          href=\"/view/{{category.identifier}}/image/{{context.identifier}}\">\n" +
    "        </a>\n" +
    "        <h4>\n" +
    "          <a ng-if=\"userService.user.staff\"\n" +
    "            class=\"pull-right\"\n" +
    "            href=\"http://znackuj.anatom.cz/image/{{context.identifier}}\">\n" +
    "            <i class=\"glyphicon glyphicon-edit\" ></i>\n" +
    "          </a>\n" +
    "          <a ng-if=\"userService.user.staff\"\n" +
    "            class=\"pull-right\"\n" +
    "            href=\"/practice/{{category.identifier}}/?context={{context.identifier}}\">\n" +
    "            <i class=\"glyphicon glyphicon-check\" ></i>\n" +
    "          </a>\n" +
    "          {{context.name}}\n" +
    "        </h4>\n" +
    "      </div>\n" +
    "      <div class=\"col-sm-5 image-open\"\n" +
    "        track-click=\"view image\"\n" +
    "        ng-click=\"activateContext(context)\" >\n" +
    "        <div category-progress skills=\"context.stats\"\n" +
    "          hide-labels=\"hideLabels\"></div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"clearfix\"></div>\n" +
    "  </div>\n" +
    "  <div class=\"panel-body image-view-container\">\n" +
    "    <div ng-hide=\"context\" class=\"loading-indicator white-bg\">\n" +
    "    </div>\n" +
    "    <div ng-if=\"context\">\n" +
    "      <span>\n" +
    "        <div ng-if=\"context.content.paths\" color-scale-legend ></div>\n" +
    "        <div ng-hide=\"context.flashcards && context.content\"\n" +
    "            class=\"loading-indicator white-bg\">\n" +
    "        </div>\n" +
    "        <span page-number=\"{{context.content.meta['textbook-page']}}\"></span>\n" +
    "        <span anatomy-image code=\"context.identifier\" ></span>\n" +
    "      </span>\n" +
    "      <span ng-hide=\"loading\" class=\"terms-container\">\n" +
    "        <span class=\"label label-default\"\n" +
    "          ng-repeat=\"flashcard in context.flashcards | orderBy : 'term.name'\"\n" +
    "          ng-class=\"{'btn-info' : flashcard.term == activeTerm}\"\n" +
    "          ng-click=\"imageController.clearHighlights();imageController.highlightItem(flashcard.description, 'no-change', true)\"\n" +
    "          ng-mouseenter=\"imageController.hoverIn(flashcard.description)\"\n" +
    "          ng-mouseleave=\"imageController.hoverOut(flashcard.description)\"\n" +
    "          term-label\n" +
    "          ng-bind=\"flashcard.term.name | stripAlternatives\" >\n" +
    "        </span>\n" +
    "      </span>\n" +
    "      <div class=\"clearfix\"></div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
  $templateCache.put("static/tpl/image_view_page.html",
    "<br>\n" +
    "<div class=\"container\">\n" +
    "  <div class=\"row\">\n" +
    "    <div class=\"col-sm-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2\">\n" +
    "      <div image-view\n" +
    "        context-id=\"contextId\"></div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div class=\"clearfix\"></div>\n" +
    "<br>\n" +
    "\n" +
    "");
  $templateCache.put("static/tpl/my_subscriptions_tpl.html",
    "<h2 class=\"text-center\" translate>Moje předplatné</h2>\n" +
    "<div ng-repeat=\"subscription in subscriptions\">\n" +
    "  <div class=\"subscription panel panel-default\">\n" +
    "    <div class=\"panel-heading\">\n" +
    "      <h3 ng-bind=\"subscription.plan_description.name\"></h3>\n" +
    "    </div>\n" +
    "    <div class=\"panel-body\">\n" +
    "      <span ng-if=\"subscription.payment\"\n" +
    "        payment-state=\"subscription.payment.status.state\"></span>\n" +
    "      <span class=\"pull-right\">\n" +
    "        <a href=\"{{subscription.payment.status.gw_url}}\"\n" +
    "          ng-if=\"subscription.payment.status.state == 'CREATED'\"\n" +
    "          class=\"btn btn-primary\"\n" +
    "          translate>Zaplatit</a>\n" +
    "        <a href=\"\"\n" +
    "          ng-click=\"\"\n" +
    "          share-button\n" +
    "          share-url=\"{{referalLink}}\"\n" +
    "          share-demo-title=\"\"\n" +
    "          share-title=\"{{'Sdílej referal odkaz, prodluž si své předplatné' | translate}}\"\n" +
    "          ng-if=\"subscription.payment.status.state == 'PAID'\"\n" +
    "          class=\"btn btn-default\"\n" +
    "          translate>Doporučit kamarádovi</a>\n" +
    "        <a href=\"/invoice/{{subscription.id}}\"\n" +
    "          ng-if=\"subscription.payment.status.state == 'PAID'\"\n" +
    "          class=\"btn btn-default\"\n" +
    "          target=\"_self\"\n" +
    "          translate>Faktura</a>\n" +
    "        <a href=\"/relationsoverview/\"\n" +
    "          ng-if=\"subscription.payment.status.state == 'PAID' || !subscription.payment\"\n" +
    "          class=\"btn btn-primary\"\n" +
    "          translate>Premium obsah</a>\n" +
    "      </span>\n" +
    "      <dl>\n" +
    "        <dt translate>Cena</dt>\n" +
    "        <dd>{{subscription.payment ?\n" +
    "          (subscription.payment.status.amount / 100 |\n" +
    "            currency : subscription.payment.status.currency) :\n" +
    "          0}}</dd>\n" +
    "      </dl>\n" +
    "      <dl>\n" +
    "        <dt translate>Vytvořeno</dt>\n" +
    "        <dd>{{subscription.created | date:'longDate'}}</dd>\n" +
    "      </dl>\n" +
    "      <dl>\n" +
    "        <dt translate>Platné do</dt>\n" +
    "        <dd>{{subscription.expiration | date:'longDate'}}</dd>\n" +
    "      </dl>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div ng-hide=\"subscriptions.length\" class=\"alert alert-info\">\n" +
    "  <span translate>Nemáš žádné předplatné. Podívej se jaké máš možnosti.</span>\n" +
    "  <a href=\"/premium/\"\n" +
    "     class=\"btn btn-primary\"\n" +
    "     track-click=\"premium banner\"\n" +
    "     translate\n" +
    "    >Zjistit více</a>\n" +
    "</div>\n" +
    "<div ng-show=\"error\" error-message ></div>\n" +
    "");
  $templateCache.put("static/tpl/offer.html",
    "<div class=\"how-it-works container-fluid about\">\n" +
    "<div class=\"row works-div\">\n" +
    "  <div class=\"col-md-offset-1 col-md-10 col-lg-offset-3 col-lg-6\">\n" +
    "  <h2 translate>Hledáme dobrovolníky </h2>\n" +
    "    <p translate>\n" +
    "    Baví Tě anatomie? Chceš se zapojit do tvorby Anatoma? Hledáme dobrovolníky, kteří nám pomůžou popisovat anatomická schemata, přidávat anatomické a klinické souvislosti, a testovat nové funkce. Intenzita spolupráce záleží na Tvých možnostech, i třeba jen 2-4 hodiny měsíčně nám mohou pomoci posunout Anatoma dále. Napiš nám na <span class=\"email contact\">anatom{zavinac}memorix.cz</span> a domluvíme se.\n" +
    "    </p>\n" +
    "  </div>\n" +
    "  <div class=\"clearfix\"></div>\n" +
    "</div>\n" +
    "</div>\n" +
    "");
  $templateCache.put("static/tpl/open_answer_tpl.html",
    "<div class=\"form-group\"\n" +
    "  ng-class=\"{\n" +
    "    'has-success' : question.isCorrect,\n" +
    "    'has-error' : question.isIncorrect,\n" +
    "    'has-feedback' : question.answered_code,\n" +
    "  }\">\n" +
    "  <input type=\"text\"\n" +
    "      ng-model=\"answer\"\n" +
    "      placeholder=\"{{'Začni psát odpověď...' | translate}}\"\n" +
    "      typeahead=\"qa as qa.answer for qa in questionsAndAnswers |\n" +
    "               filter:{answer: ($viewValue | stripAlternatives)} |\n" +
    "               limitTo:($viewValue.length > 2 ? $viewValue.length * 2 : 6)\"\n" +
    "      typeahead-loading=\"loadingLocations\"\n" +
    "      typeahead-no-results=\"noResults\"\n" +
    "      ng-disabled=\"question.answered_code\"\n" +
    "      ng-keypress=\"inputKeypress($event)\"\n" +
    "      class=\"form-control\">\n" +
    "      <span class=\"glyphicon form-control-feedback\"\n" +
    "        ng-class=\"{\n" +
    "          'glyphicon-ok' : question.isCorrect,\n" +
    "          'glyphicon-remove' : question.isIncorrect,\n" +
    "        }\"\n" +
    "        ng-show=\"!question.slideOut\"\n" +
    "        aria-hidden=\"true\"></span>\n" +
    "   <button class=\"btn btn-primary btn-lg\"\n" +
    "      ng-click=\"checkAnswer()\"\n" +
    "      ng-disabled=\"!canAnswer()\" >\n" +
    "    {{'Potvrdit' | translate }}\n" +
    "    <span shortcut=\"Enter\"></span>\n" +
    "   </button>\n" +
    " </div>\n" +
    "");
  $templateCache.put("static/tpl/open_questions_alert_tpl.html",
    "<div class=\"alert alert-info\"\n" +
    "  ng-if=\"openQuestionsDisabled\">\n" +
    " <span translate>Otevřené otázky byly zakázány.</span>\n" +
    " <a class=\"btn btn-link\"\n" +
    "  ng-click=\"allowOpenQuestions()\"\n" +
    "  translate>\n" +
    "  Znovu povolit\n" +
    " </a>\n" +
    "</div>\n" +
    "");
  $templateCache.put("static/tpl/option_buttons_tpl.html",
    "<button ng-repeat=\"option in question.options\"\n" +
    "  class=\"btn btn-lg btn-default btn-option\"\n" +
    "  ng-click=\"controller.checkAnswer(option)\"\n" +
    "  ng-class=\"{'btn-success': option.correct, 'btn-danger':\n" +
    "  option.selected && !option.correct }\"\n" +
    "  ng-mouseenter=\"(question|isFindOnMapType) && imageController.hoverIn(option.description)\"\n" +
    "  ng-mouseleave=\"(question|isFindOnMapType) && imageController.hoverOut(option.description)\"\n" +
    "  style=\"color: {{(question|isFindOnMapType) && option.color}};\n" +
    "    background-color: {{(question|isFindOnMapType) && option.bgcolor}};\"\n" +
    "  ng-disabled=\"option.disabled\">&nbsp;\n" +
    "   <span ng-show=\"!(question|isFindOnMapType) ||\n" +
    "     option.selected || option.correct\">\n" +
    "     {{question.question_type != 't2ts' ? option.term.name : option.term_secondary.name | stripAlternatives}}\n" +
    "   </span>&nbsp;\n" +
    "    <span shortcut=\"{{$index + 1}}\"></span>\n" +
    "</button>\n" +
    "<div class=\"clearfix\"></div>\n" +
    "<div open-answer\n" +
    "   ng-if=\"question.term && !(question|isFindOnMapType) && !question.options.length\"\n" +
    "   question=\"question\"\n" +
    "   controller=\"controller\"\n" +
    "   can-next=\"canNext\"\n" +
    "   image-controller=\"imageController\">\n" +
    "</div>\n" +
    "\n" +
    "");
  $templateCache.put("static/tpl/overview_tpl.html",
    "<!--\n" +
    "  {% load i18n %}\n" +
    "    -->\n" +
    "<div class=\"container-fluid\">\n" +
    "  <div class=\"row header\">\n" +
    "    <div class=\"col-sm-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2\">\n" +
    "        <h1>\n" +
    "          <span ng-bind=\"user ? user + ' - ' : ''\"></span>\n" +
    "          <span>{{headline}}</span>\n" +
    "        </h1>\n" +
    "        <div>\n" +
    "          <button class=\"btn btn-default btn-lg pull-right btn-share show hidden-xs\"\n" +
    "            track-click=\"share overview\"\n" +
    "            ng-disabled=\"disabled\"\n" +
    "            share-url=\"{{absUrl}}{{userService.user.username}}\"\n" +
    "            share-title=\"{{'Pochlub se svými znalostmi' | translate}}\"\n" +
    "            share-demo-title=\"{{'Co uvidí na sdílené stránce ostatní?' | translate}}\"\n" +
    "            share-button>\n" +
    "              <i class=\"glyphicon glyphicon-share\"></i>\n" +
    "              {{'Sdílet' | translate}}\n" +
    "          </button>\n" +
    "          <div class=\"clearfix\"></div>\n" +
    "        </div>\n" +
    "      <div class=\"row\">\n" +
    "        <div class=\"col-sm-6\" ng-if=\"!user\">\n" +
    "          <button class=\"btn btn-default btn-lg pull-right btn-share show visible-xs-block\"\n" +
    "            track-click=\"share overview\"\n" +
    "            ng-disabled=\"disabled\"\n" +
    "            share-url=\"{{absUrl}}{{userService.user.username}}\"\n" +
    "            share-title=\"{{'Pochlub se svými znalostmi' | translate}}\"\n" +
    "            share-demo-title=\"{{'Co uvidí na sdílené stránce ostatní?' | translate}}\"\n" +
    "            share-button>\n" +
    "              <i class=\"glyphicon glyphicon-share\"></i>\n" +
    "              {{'Sdílet' | translate}}\n" +
    "          </button>\n" +
    "          <a href=\"/practice/{{allCategory}}/\" \n" +
    "            class=\"btn btn-default btn-lg\" \n" +
    "            ng-disabled=\"disabled\"\n" +
    "            track-click=\"overview practice\" >\n" +
    "            <i class=\"glyphicon glyphicon-play\"></i>\n" +
    "            {{'Procvičovat vše' | translate}}\n" +
    "          </a>\n" +
    "          <span ng-include=\"'static/tpl/selected_practice_button.html'\">\n" +
    "            <a disabled class=\"btn btn-default btn-lg\" >\n" +
    "                {{'Procvičovat vybrané' | translate}}\n" +
    "                (0, 0)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;\n" +
    "            </a>\n" +
    "          </span>\n" +
    "          <br>\n" +
    "          <br>\n" +
    "        </div>\n" +
    "        <div class=\"col-sm-6\" ng-class=\"{'col-sm-offset-3' : user}\">\n" +
    "          <div category-progress skills=\"stats\">\n" +
    "            <div class=\"progress overview-progress\"> </div>\n" +
    "          </div>\n" +
    "          <br>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"col-sm-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2\">\n" +
    "      <ul class=\"nav nav-tabs nav-justified\">\n" +
    "        <li role=\"presentation\"\n" +
    "          ng-repeat=\"categoryType in categoriesByType\" \n" +
    "          ng-class=\"{'active' : categoryType.isActive}\">\n" +
    "          <a href=\"\" ng-click=\"activateCatType(categoryType)\" >\n" +
    "            <h2>{{categoryType.name}}<h2>\n" +
    "          </a>\n" +
    "            <div class=\"clearfix\"></div>\n" +
    "        </li>\n" +
    "      </ul>\n" +
    "    </div>\n" +
    "    <div class=\"clearfix\"></div>\n" +
    "  </div>\n" +
    "  <div class=\"overview\">\n" +
    "    <div ng-hide=\"categoriesByType || error\" class=\"loading-indicator\"></div>\n" +
    "    <div class=\"row ng-cloak\">\n" +
    "      <div class=\"col-sm-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2\">\n" +
    "        <div ng-show=\"error\" error-message ></div>\n" +
    "        <div ng-repeat=\"categoryType in categoriesByType\"\n" +
    "            ng-if=\"categoryType.isActive\">\n" +
    "        <div class=\"alert alert-info text-center ng-cloak\" ng-if=\"disabled\">\n" +
    "          <p translate>Získej přístup k tomuto obsahu zakoupením předplatného.</p>\n" +
    "          <br>\n" +
    "          <a href=\"/practice/relations/demo/?config=intro\"\n" +
    "            class=\"btn btn-primary btn-lg\" translate>Vyzkoušet zdarma</a>\n" +
    "          <a href=\"/premium/\" class=\"btn btn-default btn-lg\" translate>\n" +
    "            Zjistit více o předplatném</a>\n" +
    "        </div>\n" +
    "        <span tile\n" +
    "          ng-repeat=\"category in categoryType.categories | orderBy : 'display_priority'\"\n" +
    "          category=\"category\"\n" +
    "          index=\"$index\"\n" +
    "          view-path=\"viewPath\"\n" +
    "          disabled=\"disabled\"\n" +
    "          thumbnail-path=\"'/static/img/category/'\"\n" +
    "          practice-path=\"practicePath\">\n" +
    "        </span>\n" +
    "        <div class=\"clearfix\"></div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"clearfix\"></div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
  $templateCache.put("static/tpl/payment_state_tpl.html",
    "<span class=\"label label-{{getLabelClass()}}\">\n" +
    "  {{paymentStates[paymentState]}}\n" +
    "</span>\n" +
    "");
  $templateCache.put("static/tpl/practice_action_buttons_tpl.html",
    "<div class=\"button-block\"\n" +
    "    ng-if=\"question && question.context\">\n" +
    "  <button class=\"btn btn-lg btn-default next {{!canNext || 'btn-primary'}}\" \n" +
    "        ng-click=\"controller.next()\" \n" +
    "        ng-disabled=\"!canNext || error\" >\n" +
    "    <i class=\"glyphicon glyphicon-arrow-right\"></i> {{'Pokračovat' | translate }}\n" +
    "    <span shortcut=\"Enter\"></span>\n" +
    "  </button>\n" +
    "  <button class=\"btn btn-lg btn-default dont-know\" \n" +
    "        ng-click=\"controller.checkAnswer()\" \n" +
    "        track-click=\"dont-know\"\n" +
    "        ng-disabled=\"canNext\" >\n" +
    "    <i class=\"glyphicon glyphicon-question-sign\"></i> {{'Nevím' | translate }}\n" +
    "    <span shortcut=\"Esc\"></span>\n" +
    "  </button>\n" +
    "  <a feedback-comment\n" +
    "    class=\"btn btn-lg btn-link report-error\"\n" +
    "    email=\"{{userService.user.email}}\"\n" +
    "    text=\"{{question | reportText : categoryId}}\"\n" +
    "    href=\"\">\n" +
    "    <i class=\"glyphicon glyphicon-new-window\"></i>\n" +
    "  {{'Nahlásit chybu' | translate }}\n" +
    "  </a>\n" +
    "</div>\n" +
    "");
  $templateCache.put("static/tpl/practice_header_tpl.html",
    "<div class=\"row header header-practice\">\n" +
    "  <div class=\"col-sm-12 \">\n" +
    "    <h1>\n" +
    "      {{question.context.name}}\n" +
    "      <a ng-if=\"userService.user.staff && contextId\"\n" +
    "        href=\"/image/{{contextId}}\">\n" +
    "        <i class=\"glyphicon glyphicon-picture\" ></i>\n" +
    "      </a>\n" +
    "      <a ng-if=\"userService.user.staff && contextId\"\n" +
    "        href=\"http://znackuj.anatom.cz/image/{{contextId}}\">\n" +
    "        <i class=\"glyphicon glyphicon-edit\" ></i>\n" +
    "      </a>\n" +
    "      &nbsp;\n" +
    "    </h1>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
  $templateCache.put("static/tpl/practice_setting_tpl.html",
    "<span class=\"btn-group\" role=\"group\">\n" +
    "  <button type=\"button\"\n" +
    "    class=\"btn btn-default btn-sm dropdown-toggle btn-settings\"\n" +
    "    data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"\n" +
    "    track-click=\"change terms lang\">\n" +
    "    <i class=\"glyphicon glyphicon-cog\"></i>\n" +
    "  </button>\n" +
    "  <ul class=\"dropdown-menu\">\n" +
    "    <li class=\"dropdown-header\" translate>Jazyk terminologie</li>\n" +
    "    <li ng-repeat=\"lang in possibleLangs\">\n" +
    "     <a href=\"/refreshpractice/{{categoryId}}/{{category2Id}}\"\n" +
    "        track-click=\"change terms lang {{lang.code}}\"\n" +
    "        ng-click=\"setTermsLang(lang.code)\"\n" +
    "        style=\"{{lang.code == getTermsLang() ? 'font-weight: bold;' : ''}}\">\n" +
    "        {{lang.name}}\n" +
    "      </a>\n" +
    "    </li>\n" +
    "    <!--\n" +
    "    <li role=\"separator\" class=\"divider\"></li>\n" +
    "    <li class=\"dropdown-header\">Otázky s psaním odpovědi</li>\n" +
    "    <li ng-repeat=\"lang in possibleLangs\">\n" +
    "      <a href=\"\" ng-click=\"setTermsLang(lang.code)\"\n" +
    "        style=\"{{lang.code == getTermsLang() ? 'font-weight: bold;' : ''}}\">\n" +
    "        {{lang.name}} {{lang.code == getTermsLang()}} \n" +
    "      </a>\n" +
    "    </li>\n" +
    "    -->\n" +
    "  </ul>\n" +
    "</span>\n" +
    "");
  $templateCache.put("static/tpl/practice_tpl.html",
    "<div class=\"container-fluid\">\n" +
    "  <div practice-header\n" +
    "       question=\"activeQuestion\"\n" +
    "       category-id=\"categoryId\">\n" +
    "   </div>\n" +
    "</div>\n" +
    "<div>\n" +
    "  <div ng-repeat=\"question in questions\"\n" +
    "      ng-show=\"question.description == activeQuestion.description &&\n" +
    "        question.startTime == activeQuestion.startTime\">\n" +
    "    <span page-number=\"{{question.context.content.meta['textbook-page']}}\"></span>\n" +
    "    <div image-click-help question=\"question\"></div>\n" +
    "    <div anatomy-image code=\"question.context.identifier\" practice=\"true\">\n" +
    "      <div class=\"loading-indicator white-bg\"> </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div class=\"practice-with-progress\">\n" +
    "  <div class=\"progress quesions-progress\">\n" +
    "    <div class=\"progress-bar\" style=\"width: {{progress}}%;\"></div>\n" +
    "  </div>\n" +
    "  <div id=\"container\" class=\"practice-container\">\n" +
    "    <div ng-hide=\"question || showSummary || error\" class=\"loading-indicator\">\n" +
    "    </div>\n" +
    "    <div ng-show=\"error\" error-message ></div>\n" +
    "    <div class=\"practice\">\n" +
    "      <div ng-repeat=\"question in questions\"\n" +
    "          ng-if=\"question\"\n" +
    "          ng-class=\"{'slide-out': question.slideOut}\"\n" +
    "          class=\"inner-practice row\">\n" +
    "        <div class=\"question col-sm-12\"\n" +
    "          question-and-answer \n" +
    "          category-id=\"categoryId\"\n" +
    "          category2-id=\"category2Id\" \n" +
    "          question=\"question\">\n" +
    "        </div>\n" +
    "        <div class=\"button-block\"\n" +
    "             option-buttons\n" +
    "             question=\"question\"\n" +
    "             controller=\"controller\"\n" +
    "             can-next=\"canNext\"\n" +
    "             image-controller=\"imageController\">\n" +
    "        </div>\n" +
    "        <div class=\"button-block\"\n" +
    "             practice-action-buttons\n" +
    "             question=\"question\"\n" +
    "             can-next=\"canNext\"\n" +
    "             controller=\"controller\">\n" +
    "        </div>\n" +
    "        <div open-questions-alert> </div>\n" +
    "      </div>\n" +
    "      <div ng-show=\"loadingNextQuestion\" class=\"overlay\">\n" +
    "        <div class=\"loading-indicator\"> </div>\n" +
    "      </div>\n" +
    "      <div ng-if=\"showSummary\"\n" +
    "        summary\n" +
    "        controller=\"controller\"\n" +
    "        category-id=\"categoryId\"\n" +
    "        category2-id=\"category2Id\" >\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"clearfix\"></div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
  $templateCache.put("static/tpl/premium.html",
    "<!--\n" +
    "{% load i18n %}\n" +
    "  -->\n" +
    "<div class=\"premium-page jumbotron\">\n" +
    "    <div class=\"flatblock block-premium_page\">\n" +
    "      <div class=\"col-lg-offset-2 col-lg-8\">\n" +
    "        <h1>{{\"Procvičuj si anatomii s námi\" | translate }}</h1>\n" +
    "        <div class=\"flatblock-content\">\n" +
    "            <strong>{{\"Za použití dat o učení, které máme k dispozici, učiníme tvoje procvičování efektivní.\" | translate }}</strong>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-lg-7\">\n" +
    "                <table class=\"subscription-table\">\n" +
    "                    <tr>\n" +
    "                        <th></th>\n" +
    "                        <th>{{\"Zdarma\" | translate }}</th>\n" +
    "                        <th>{{\"Předplatné\" | translate }}</th>\n" +
    "                    </tr>\n" +
    "                    <tr>\n" +
    "                        <td>\n" +
    "                            <h4> <a href=\"/overview/\" translate>Pojmy na obrázcích</a></h4>\n" +
    "                            <div translate>Najdi a pojmenuj 2000 pojmů na více než 200 obrázcích.</div>\n" +
    "                        </td>\n" +
    "                        <td><i class=\"glyphicon glyphicon-ok\"></i></td>\n" +
    "                        <td><i class=\"glyphicon glyphicon-ok\"></i></td>\n" +
    "                    </tr>\n" +
    "                    <tr>\n" +
    "                        <td>\n" +
    "                            <h4><a href=\"/relationsoverview/\" translate>Souvislosti svalů</a></h4>\n" +
    "                            <div translate>Pospojuj si vědomosti o svalech - začátek a úpon, funkce a antagonista, inervace a cévní zásobení. Dalších 1000 otázek!</div>\n" +
    "                            <a href=\"/practice/relations/demo?config=intro\" translate>Vyzkoušej demo</a>\n" +
    "                        </td>\n" +
    "                        <td><i class=\"glyphicon glyphicon-remove\"></i>\n" +
    "                        </td>\n" +
    "                        <td><i class=\"glyphicon glyphicon-ok\"></i></td>\n" +
    "                    </tr>\n" +
    "                    <tr>\n" +
    "                        <td>\n" +
    "                            <h4><a href=\"/settings/\" translate>Pokročilé nastavení</a></h4>\n" +
    "                            <div translate>Nastav si obtížnost procvičování, délku sady a typ otázek tak, jak ti vyhovuje.</div>\n" +
    "                        </td>\n" +
    "                        <td><i class=\"glyphicon glyphicon-remove\"></i></td>\n" +
    "                        <td><i class=\"glyphicon glyphicon-ok\"></i></td>\n" +
    "                    </tr>\n" +
    "                </table>\n" +
    "            </div>\n" +
    "            <div class=\"col-lg-5 text-center\">\n" +
    "                <div class=\"panel panel-default\" style=\"font-size: initial\">\n" +
    "                    <div class=\"panel-body text-left\">\n" +
    "                        <div translate>\n" +
    "                        Od našich uživatelů jsme nasbírali již\n" +
    "                        <strong ng-bind=\"stats.number_of_answers | number\" >\n" +
    "                          {{stats.number_of_answers}}\n" +
    "                        </strong>\n" +
    "                        odpovědí, čehož si nesmírně vážíme. Aplikace opravdu\n" +
    "                        pomáhá a my ji chceme dál rozvíjet. Vývoj a rozšiřování aplikace nás však stojí hodně úsilí, a proto\n" +
    "                        budeme rádi, když nás finačně podpoříš. Poskytneme ti\n" +
    "                        užitečný výukový obsah a možnost nastavit si \n" +
    "                        procvičování podle osobních preferencí.\n" +
    "                        </div>\n" +
    "                        <div class=\"text-right\" style=\"margin-top: 15px\" translate>Hodně zdaru při učení anatomie,<br>Honza, Linda, Marek a Víťa</div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <a class=\"btn btn-primary btn-lg\" scroll-to=\"plans\"\n" +
    "                  track-click=\"choose subscription\"\n" +
    "                  translate>Vybrat předplatné</a>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"clearfix\"></div>\n" +
    "</div>\n" +
    "<div ng-include=\"'static/tpl/subscription_plans.html'\"></div>\n" +
    "");
  $templateCache.put("static/tpl/premium_banner.html",
    "<div class=\"beta-alert text-center alert alert-info {{class}}\"\n" +
    "    ng-if=\"show\">\n" +
    "  <button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-label=\"Close\"\n" +
    "      track-click=\"close premium banner\">\n" +
    "    <span aria-hidden=\"true\">&times;</span>\n" +
    "    <span class=\"sr-only\" translate>Zavřít</span>\n" +
    "  </button>\n" +
    "  <span track-show=\"premium banner\" translate>\n" +
    "  Pomáhá ti anatom.cz s učením? Podpoř další rozvoj projektu zakoupením předplatného a získej přístup k premium obsahu.\n" +
    "  </span>\n" +
    "  <a class=\"btn btn-default\"\n" +
    "     track-click=\"premium banner\"\n" +
    "     ng-click=\"goto('/premium/')\"\n" +
    "     translate\n" +
    "    >Zjistit více</a>\n" +
    "  <a class=\"btn btn-primary\"\n" +
    "     track-click=\"premium banner demo\"\n" +
    "     ng-click=\"goto('/practice/relations/demo?config=intro')\"\n" +
    "     translate\n" +
    "    >Vyzkoušet zdarma</a>\n" +
    "</div>\n" +
    "\n" +
    "");
  $templateCache.put("static/tpl/privacy_policy_cs.html",
    "<br>\n" +
    "<div class=\"privacy-policy row\">\n" +
    "  <div class=\"col-sm-offset-2 col-sm-8\">\n" +
    "    <div class=\"panel panel-default\">\n" +
    "      <div class=\"panel-heading\">\n" +
    "        <h1>Zásady ochrany osobních údajů služby Anatom.cz</h1>\n" +
    "      </div>\n" +
    "      <div class=\"panel-body\">\n" +
    "        <p>Platné od 22.10.2016</p>\n" +
    "        <p>\n" +
    "        Dobrý den, vítejte v našich zásadách ochrany osobních údajů. Tyto\n" +
    "        zásady ochrany osobních údajů vám pomohou provést informovaná\n" +
    "        rozhodnutí týkající se vašich vztahů s naší společností, proto si je\n" +
    "        pozorně přečtěte.\n" +
    "        </p>\n" +
    "        <h2>1 Úvod</h2>\n" +
    "        <p>\n" +
    "          Děkujeme, že jste si vybrali službu Anatom. Tento dokument popisuje\n" +
    "          naše zásady ochrany osobních údajů. Před tím, než vám sdělíme\n" +
    "          podrobnosti, bychom rádi zdůraznili některé klíčové zásady. Tyto\n" +
    "          zásady jsou pro nás důležité, protože víme, že jsou důležité i pro\n" +
    "          vás. Tyto zásady ochrany osobních údajů slouží třem účelům:\n" +
    "        </p>\n" +
    "        <ol>\n" +
    "          <li>Vysvětlení toho, jak používáme informace, které s námi sdílíte, k vytvoření skvělého produktu a zajištění vašeho skvělého zážitku z tohoto produktu.</li>\n" +
    "          <li>Zajištění vašeho pochopení, jaké informace s vaším souhlasem shromažďujeme a co s nimi děláme – a neděláme.</li>\n" +
    "          <li>Zajištění naší odpovědnosti za ochranu vašich práv a vašeho soukromí v souladu s těmito zásadami.</li>\n" +
    "          <li>Všechny informace, které shromažďujeme, souvisí s poskytováním služby a jejích funkcí.</li>\n" +
    "        </ol>\n" +
    "        <p>\n" +
    "          Obecně existují dvě kategorie informací, které shromažďujeme: 1)\n" +
    "          informace, které musíme mít, abyste mohli službu používat a 2)\n" +
    "          informace, které můžeme využívat, abychom vám mohli poskytovat další\n" +
    "          funkce a vylepšené procvičování, pokud se rozhodnete tyto informace s\n" +
    "          námi sdílet.\n" +
    "        </p>\n" +
    "        <p>První kategorie zahrnuje:</p>\n" +
    "        <ul>\n" +
    "          <li>Registrační údaje, včetně vašeho jména, data narození, adresy a jiných informací, které nám poskytnete při registraci do služby.</li>\n" +
    "          <li>Obecné, nekonkrétní údaje o vaší poloze, které odvodíme z vaší IP adresy.</li>\n" +
    "          <li>nformace obsahu, který procvičujete a vašich interakcích se službou. To nám umožňuje personalizovat procvičování a nabízet relevantní obsah. Můžete se rozhodnout, zda tyto informace budete sdílet se svými přáteli, přívrženci nebo veřejností.</li>\n" +
    "          <li>Technické informace a informace z čidel nezbytné pro provoz služby. Zahrnují informace o tom, jaký typ prohlížeče a zařízení používáte, údaje z dotykové obrazovky a informace z akcelerometru a gyroskopických čidel vašeho zařízení.</li>\n" +
    "        </ul>\n" +
    "        <p>\n" +
    "          Druhá kategorie zahrnuje informace, které nám umožňují nabídnout vám\n" +
    "          další funkce. Žádné z následujících údajů nezískáme, pokud se\n" +
    "          výslovně nerozhodnete je s námi sdílet. Je to až tak jednoduché. Zde\n" +
    "          jsou příklady:\n" +
    "        </p>\n" +
    "        <ul>\n" +
    "          <li>Vaše fotografie: Budeme mít přístup pouze k obrázkům, které konkrétně vyberete, a nikdy nebudeme prohlížet nebo importovat vaši fotogalerii nebo kolekci fotografií z fotoaparátu. Tyto informace nám umožňují vybrat konkrétní obrázky pro změnu vašeho profilového obrázku. Sdílení fotografií můžete kdykoliv ukončit a náš přístup k nim zrušit.</li>\n" +
    "          <li>Vaše kontakty: Pokud nás o to nepožádáte, nebudeme nikdy prohlížet nebo importovat vaše kontakty. Pokud nám k tomu dáte souhlas, použijeme údaje z vašich kontaktů pouze k tomu, abychom vám pomohli nalézt přátele nebo kontakty užívající naši službu.</li>\n" +
    "        </ul>\n" +
    "        <p>\n" +
    "          Rozdíl mezi těmito dvěma kategoriemi je důležitý. Informace v první\n" +
    "          kategorii nám musíte poskytnout, abyste mohli naši službu používat.\n" +
    "          Svým souhlasem s našimi zásadami ochrany osobních údajů nám dáváte\n" +
    "          oprávnění ke shromažďování těchto informací a jejich používání pro\n" +
    "          popsané účely. Informace v druhé kategorii budeme shromažďovat, pouze\n" +
    "          pokud nám k tomu v budoucnosti dáte výslovný souhlas. Před naším prvním\n" +
    "          přístupem k informacím spadajícím do druhé kategorie vás požádáme o\n" +
    "          souhlas a popíšeme vám, jak tyto informace budeme používat, pokud nám k\n" +
    "          tomu dáte souhlas. Dále je budeme používat pouze pro námi popsaný účel\n" +
    "          a vy budete mít vždy možnost své rozhodnutí změnit a souhlas odvolat.\n" +
    "          Přijetí našich zásad ochrany osobních údajů neznamená, že jste nám dali\n" +
    "          souhlas k přístupu k informacím druhé kategorie nebo k jejich\n" +
    "          používání. Pouze vám vysvětlujeme, že jednoho dne vás o tento souhlas\n" +
    "          můžeme požádat.\n" +
    "        </p>\n" +
    "        <p><strong>Jasně vám vysvětlíme, jak a kdy můžeme sdílet informace.</strong></p>\n" +
    "        <p>\n" +
    "          V některých situacích budeme určité informace sdílet. Stejně jako u\n" +
    "          většiny služeb zde platí, že pokud se registrujete do Služby\n" +
    "          prostřednictvím třetí strany, např. prostřednictvím služby Facebook\n" +
    "          nebo Google, budeme s ní sdílet určité informace a ona bude určité\n" +
    "          informace sdílet s námi pro účely aktivace vašeho účtu. Také budeme\n" +
    "          sdílet informace zbavené identifikačních znaků s našimi vědeckými\n" +
    "          partnery, abychom jim pomohli pochopit princip učení, s našimi\n" +
    "          marketingovými partnery, kteří nám pomáhají s propagací, a s inzerenty.\n" +
    "          Možná také někdy budete sami chtít, abychom vaše informace sdíleli.\n" +
    "          Například když budete chtít svým známým ukázat, jak se vám v naší\n" +
    "          službě daří…\n" +
    "        </p>\n" +
    "        <p>\n" +
    "          Doufáme, že vám toto vysvětlení pomůže pochopit naše závazky týkající\n" +
    "          se ochrany vašich osobních údajů. Podrobnosti na vás čekají níže.\n" +
    "          Pamatujte si však, že tento úvod je součástí našich zásad ochrany\n" +
    "          osobních údajů – je to náš slib, který vám dáváme. Pokud budete mít\n" +
    "          jakékoliv dotazy nebo obavy, dejte nám vědět na adresu\n" +
    "          anatom@memorix.cz\n" +
    "        </p>\n" +
    "        <p>\n" +
    "          V těchto zásadách ochrany osobních údajů se zmiňujeme o službě Anatom\n" +
    "          nebo Službě. Tyto termíny jsou definovány v <a href=\"/terms-of-use-{{LANGUAGE_CODE}}\" scroll-top>Podmínkách\n" +
    "          použití</a> („Podmínky použití”).\n" +
    "        </p>\n" +
    "        <h2>2 Klíčové body, se kterými souhlasíte</h2>\n" +
    "        <p>\n" +
    "          Použitím Služby nebo interakcí s ní souhlasíte s následujícími položkami:\n" +
    "        </p>\n" +
    "        <ol>\n" +
    "          <li>použití souborů cookie a jiných technologií,</li>\n" +
    "          <li>přenos vašich informací mimo zemi, ve které žijete,</li>\n" +
    "          <li>shromažďování, používání, sdílení a další zpracování vašich informací včetně zpracování pro účely související s reklamou (toto je dále popsáno ve zbývající části těchto zásad ochrany osobních údajů, pokračujte ve čtení!), a</li>\n" +
    "          <li>veřejná dostupnost vašich informací a kontrolní prvky týkající se těchto informací, jak je to popsáno v části Sdílení informací.</li>\n" +
    "        </ol>\n" +
    "        <p>\n" +
    "          V každém případě souhlasíte se zpracováním údajů subjekty popsanými v\n" +
    "          těchto zásadách ochrany osobních údajů, včetně subjektu Anatom, který\n" +
    "          plní úlohu subjektu řídicího údaje a je uvedený na konci tohoto\n" +
    "          dokumentu (kolektivně označován jako „služba Anatom“, „my“, „naše\n" +
    "          společnost“). V části Vaše předvolby popisujeme kontrolní prvky a\n" +
    "          relevantní nastavení týkající se vašeho účtu služby Anatom. Pokud\n" +
    "          nesouhlasíte s podmínkami těchto zásad ochrany osobních údajů,\n" +
    "          nepoužívejte Službu.\n" +
    "        </p>\n" +
    "        <h2>Můžeme shromažďovat a uchovávat následující informace:</h2>\n" +
    "        <p>Můžeme shromažďovat a uchovávat následující informace:</p>\n" +
    "        <h3>3.1 Údaje o registraci</h3>\n" +
    "        <p>\n" +
    "          Při registraci do Služby vás můžeme požádat o různé informace,\n" +
    "          například uživatelské jméno, heslo, e-mailová adresa, vzdělání, datum\n" +
    "          narození, pohlaví, adresa, PSČ a země. Pokud se připojíte ke Službě\n" +
    "          pomocí přihlašovacích údajů aplikace třetí strany (jak je to definováno\n" +
    "          v části <a href=\"/terms-of-use-{{LANGUAGE_CODE}}\" scroll-top>Podmínky\n" +
    "          použití</a>) (např. pomocí služby Facebook), poskytujete\n" +
    "          nám povolení shromažďovat vaše ověřovací informace, například\n" +
    "          uživatelské jméno a zašifrované přihlašovací údaje. Také můžeme\n" +
    "          shromažďovat další informace dostupné na účtu aplikace třetí strany\n" +
    "          nebo jeho prostřednictvím, včetně například vašeho jména, profilového\n" +
    "          obrázku, země, města, e-mailové adresy, data narození, pohlaví, jmen a\n" +
    "          profilových obrázků přátel a propojení.\n" +
    "        </p>\n" +
    "        <p>\n" +
    "          Také můžete dobrovolně přidat do svého profilu další informace,\n" +
    "          například mobilní telefonní číslo a poskytovatele mobilních služeb.\n" +
    "        </p>\n" +
    "        <h3>3.2 Použití, údaje protokolu a soubory cookie</h3>\n" +
    "        <p>\n" +
    "          Když používáte Službu nebo s ní interagujete, můžeme použít různé\n" +
    "          technologie, které sbírají informace o přístupu ke Službě nebo jejím\n" +
    "          používání. Tyto informace mohou zahrnovat:\n" +
    "        </p>\n" +
    "        <ol>\n" +
    "          <li>informace o druhu vašeho předplatného a interakcích se Službou,</li>\n" +
    "          <li>uživatelský obsah (jak je definován v části Podmínky použití), který odesíláte do Služby, včetně zpráv, které odesíláte a přijímáte prostřednictvím Služby,</li>\n" +
    "          <li>technické údaje, které mohou zahrnovat informace o adresách URL, údaje souborů cookie, vaši adresu IP, informace o typech zařízení, pomocí kterých přistupujete nebo se připojujete ke službě Anatom, jedinečném ID zařízení, vlastnostech zařízení, typu připojení k síti (např. Wi-Fi, 3G, LTE) a poskytovateli služeb, výkonnosti sítě a zařízení, typu prohlížeče, jazyku, informacích umožňujících spravování digitálních práv, operačním systému a jazykové verzi aplikace Anatom,</li>\n" +
    "          <li>údaje založené na pohybu nebo orientaci čidla na mobilním zařízení (např. akcelerometru nebo gyroskopu).</li>\n" +
    "        </ol>\n" +
    "        <p>\n" +
    "          Svůj účet Služby můžete integrovat s aplikacemi třetích stran. V\n" +
    "          takovém případě můžeme získat podobné informace týkající se vaší\n" +
    "          interakce se Službou v aplikacích třetích stran i informace týkající se\n" +
    "          vaší veřejně dostupné aktivity v aplikaci třetí strany. To například\n" +
    "          zahrnuje vaše označení „Líbí se mi“ a příspěvky ve službě Facebook. Ke\n" +
    "          shromažďování těchto informací můžeme používat soubory cookie a jiné\n" +
    "          technologie – další informace o tomto použití naleznete v části\n" +
    "          Informace o souborech cookie a dalších technologiích těchto zásad\n" +
    "          ochrany osobních údajů.\n" +
    "        </p>\n" +
    "        <h3>3.3 Vaše mobilní zařízení</h3>\n" +
    "        <p>\n" +
    "          Můžeme vám poskytnout funkce, které jsou založeny na použití dalších\n" +
    "          informací z vašeho mobilního zařízení nebo vyžadují přístup k určitým\n" +
    "          službám na vašem mobilním zařízení. Tyto funkce vylepší váš zážitek ze\n" +
    "          Služby, nejsou však pro používání Služby vyžadovány. (Jinými slovy,\n" +
    "          informace, které spadají do druhé z kategorií popsaných v úvodu k těmto\n" +
    "          zásadám.) Například vám můžeme umožnit nahrávat fotografie do vašeho\n" +
    "          profilu nebo spojit se s přáteli. Pokud nám povolíte přístup k těmto\n" +
    "          informacím, neznamená to, že nám k nim dáváte neomezený přístup nebo že\n" +
    "          budeme mít přístup ke konkrétním informacím bez vašeho svolení. Naopak,\n" +
    "          u každého typu informací, které jsou vyjmenovány v této části, budeme\n" +
    "          před naším přístupem k těmto informacím nebo funkcím na vašem mobilním\n" +
    "          zařízení žádat o váš souhlas. Pokud nám tento souhlas dáte, shromáždíme\n" +
    "          tyto informace pro konkrétní účel, který vám objasníme v čase naší\n" +
    "          žádosti o váš souhlas. Tento souhlas není nutný pro to, abyste mohli\n" +
    "          Službu používat. Přijetí těchto zásad ochrany osobních údajů neznamená,\n" +
    "          že jste nám dali souhlas s přístupem k těmto informacím.\n" +
    "        </p>\n" +
    "        <h3>3.4 Údaje o platbě</h3>\n" +
    "        <p>\n" +
    "          Pokud se zaregistrujete pro získání zkušební verze (v souladu s\n" +
    "          definicí v části <a href=\"/terms-of-use-{{LANGUAGE_CODE}}\" scroll-top>Podmínky použití</a>), zakoupíte si některý z programů\n" +
    "          placeného odběru (v souladu s definicí v části Podmínky použití), nebo\n" +
    "          provedete jiné nákupy prostřednictvím Služby, mohou být získána a\n" +
    "          uložena naší společností nebo společnostmi zpracovávajícími platby, se\n" +
    "          kterými spolupracujeme, údaje o vaší kreditní nebo debetní kartě\n" +
    "          (například typ karty a informace o vypršení platnosti) a další finanční\n" +
    "          údaje, které potřebujeme ke zpracování vaší platby. Také můžeme\n" +
    "          shromažďovat některé omezené informace, například informace o vašem\n" +
    "          kódu PSČ, mobilním čísle a podrobnostech týkajících se historie\n" +
    "          transakcí, které jsou nezbytné k poskytování Služby. Společnosti\n" +
    "          zabývající se zpracováním platby nám navíc obyčejně poskytují některé\n" +
    "          omezené informace o vaší osobě, například jedinečný žeton, který vám\n" +
    "          umožňuje provádět další nákupy pomocí již uložených informací, nebo\n" +
    "          informace o typu a datu vypršení platnosti vaší karty, stejně jako\n" +
    "          některé číslice z čísla vaší karty.\n" +
    "        </p>\n" +
    "        <p>\n" +
    "          Pokud se rozhodnete platit pomocí faktury, může naše společnost\n" +
    "          shromažďovat a ukládat dodatečné informace, například vaše jméno,\n" +
    "          datum narození a telefonní číslo, které může poskytovat společnostem\n" +
    "          zabývajícím se zpracováním plateb, se kterými spolupracujeme, za\n" +
    "          účelem vydání faktur, umožnění kontroly kreditu a odeslání faktur.\n" +
    "        </p>\n" +
    "        <p>\n" +
    "          PŘIJETÍM TĚCHTO ZÁSAD OCHRANY OSOBNÍCH ÚDAJŮ UDĚLUJETE NAŠÍ\n" +
    "          SPOLEČNOSTI VÝSLOVNÉ UDĚLENÍ POUŽÍT A SDÍLET S JINÝMI DŮVĚRYHODNÝMI\n" +
    "          OBCHODNÍMI PARTNERY A POSKYTOVATELI SLUŽEB (KTEŘÍ SE MOHOU NACHÁZET ZA\n" +
    "          HRANICEMI VAŠÍ ZEMĚ, VČETNĚ ZEMÍ, KTERÉ NEPOSKYTUJÍ STEJNOU ÚROVEŇ\n" +
    "          OCHRANY OSOBNÍCH ÚDAJŮ JAKO VAŠE ZEMĚ) INFORMACE, KTERÉ JSTE POSKYTLI\n" +
    "          NAŠÍ SPOLEČNOSTI. TO PLATÍ I V PŘÍPADĚ, ŽE SE TĚCHTO POSKYTNUTÝCH\n" +
    "          INFORMACÍ TÝKAJÍ MÍSTNÍ ZÁKONY O BANKOVNÍM TAJEMSTVÍ. POTVRZUJETE A\n" +
    "          SOUHLASÍTE, ŽE SI UVĚDOMUJETE DŮLEŽITOST SDÍLENÍ TĚCHTO INFORMACÍ ZA\n" +
    "          ÚČELEM POSKYTOVÁNÍ SLUŽBY A PŘIJETÍM TĚCHTO ZÁSAD OCHRANY OSOBNÍCH\n" +
    "          ÚDAJŮ TAKÉ SOUHLASÍTE, POKUD JE TO NUTNÉ A V ROZSAHU POVOLENÉM MÍSTNÍMI\n" +
    "          ZÁKONY, ŽE SE VÝSLOVNĚ ZŘÍKÁTE VŠECH PRÁV, KTERÉ VÁM VYPLÝVAJÍ Z\n" +
    "          MÍSTNÍCH ZÁKONŮ O BANKOVNÍM TAJEMSTVÍ, VE VZTAHU K NAŠÍ SPOLEČNOSTI,\n" +
    "          VŠEM DŮVĚRYHODNÝM OBCHODNÍM PARTNERŮM A POSKYTOVATELŮM SLUŽEB, KTEŘÍ SE\n" +
    "          MOHOU NACHÁZET ZA HRANICEMI VAŠÍ ZEMĚ. TENTO SOUHLAS JE UDĚLEN NA DOBU\n" +
    "          CELÉHO TRVÁNÍ VAŠEHO VZTAHU S NAŠÍ SPOLEČNOSTÍ.\n" +
    "        </p>\n" +
    "        <h3>3.5 Poskytovatelé služeb a partneři naší společnosti</h3>\n" +
    "        <p>\n" +
    "          Také můžeme získat informace o vaší osobě od našich poskytovatelů\n" +
    "          služeb a partnerů. Tyto informace používáme k přizpůsobení vašeho\n" +
    "          zážitku se Službou, měření kvality a reakce na reklamy a zobrazování\n" +
    "          reklam, které pro vás mohou být relevantnější. Tyto informace také\n" +
    "          používáme způsobem, který je popsaný v části Způsob použití\n" +
    "          shromážděných informací níže.\n" +
    "        </p>\n" +
    "        <h2>4 Způsob použití shromážděných informací</h2>\n" +
    "        <p>\n" +
    "          Na základě vašeho souhlasu se shromažďováním informací můžeme\n" +
    "          shromážděné informace včetně vašich osobních informací použít\n" +
    "          následujícím způsobem:\n" +
    "        </p>\n" +
    "        <ol>\n" +
    "          <li>k poskytování, přizpůsobení a vylepšení vašeho zážitku se Službou a produkty, službami a reklamou (včetně reklamy na produkty a služby třetích stran), které poskytujeme ve Službě nebo mimo ní (včetně jiných webů, které navštívíte), například poskytováním přizpůsobeného nebo lokalizovaného obsahu, doporučení, funkcí a reklamy ve Službě nebo mimo ní,</li>\n" +
    "          <li>k zajištění technických funkcí Služby, vývoji nových produktů a služeb a analýze vašeho používání Služby, včetně vaší interakce s aplikacemi, reklamou, produkty a službami, které jsou dostupné, odkazované nebo nabízené prostřednictvím Služby,</li>\n" +
    "          <li>ke komunikaci s vaší osobou za účely souvisejícími se Službou nebo výzkumem, včetně komunikace prostřednictvím e-mailu, upozornění, zpráv SMS nebo jiných zpráv, se zasíláním kterých budete souhlasit,</li>\n" +
    "          <li>k umožnění a propagaci Služby a jiných služeb nebo produktů, ať už v rámci Služby nebo mimo ní, včetně funkcí a obsahu Služby a produktů a služeb dostupných prostřednictvím Služby,</li>\n" +
    "          <li>ke zpracování vaší platby nebo zabránění či rozpoznání podvodů,</li>\n" +
    "          <li>k vymáhání těchto zásad ochrany osobních údajů, <a href=\"/terms-of-use-{{LANGUAGE_CODE}}\" scroll-top>Podmínek použití</a>, a jakýchkoli dalších podmínek, se kterými jste souhlasili, včetně ochrany práv, vlastnictví nebo bezpečnosti naší společnosti, uživatelů služby nebo jakékoli jiné osoby nebo obsahu Služby chráněného autorskými právy,</li>\n" +
    "          <li>k poskytování funkcí, informací, reklamy nebo jiného obsahu, který je ovlivněný vaší polohou a vaší polohou vzhledem k jiným uživatelům Služby, a</li>\n" +
    "          <li>k jiným účelům uvedeným v těchto zásadách ochrany osobních údajů.</li>\n" +
    "        </ol>\n" +
    "        <h2>5 Sdílení informací</h2>\n" +
    "        <p>\n" +
    "          Tato část popisuje způsob, jakým můžete nebo můžete sdílet\n" +
    "          informace, ke shromažďování nebo generování dochází v důsledku vašeho\n" +
    "          používaní Služby.\n" +
    "        </p>\n" +
    "        <h3>5.1 Sdílení vámi</h3>\n" +
    "        <h4>5.1.1 Obecné</h4>\n" +
    "        <p>\n" +
    "          Vaše jméno nebo uživatelské jméno, profilový obrázek a uživatelský\n" +
    "          profil Služby budou vždy veřejně dostupné informace.\n" +
    "        </p>\n" +
    "        <p>\n" +
    "          Vaše aktivita ve Službě, úspěšnost v procvičování a další informace\n" +
    "          týkající se vaší znalosti v procvičovaném tématu jsou veřejně dostzupné\n" +
    "          informace ve výchozím nastavení. Toto lze změnit v nastavení vašeho\n" +
    "          uživatelského profilu.\n" +
    "        </p>\n" +
    "        <p>\n" +
    "          Nezapomeňte, že některé informace budou vždy veřejně dostupné – to\n" +
    "          znamená, že k nim lze přistupovat pomocí aplikací třetích stran\n" +
    "          prostřednictvím našeho rozhraní API a nástrojů pro vývojáře. Na základě\n" +
    "          vašich povolení lze sdílet s aplikacemi třetích stran a s jinými\n" +
    "          uživateli prostřednictvím těchto aplikací některé dodatečné informace.\n" +
    "          Pomocí svých nastavení například můžete určit, zda bude vaše aktivita\n" +
    "          ve Službě odesílána do služby Facebook.\n" +
    "        </p>\n" +
    "        <p>\n" +
    "          Můžeme použít vaše veřejně dostupné informace k propagaci Služby a k\n" +
    "          tomu, abychom pomohli jiným uživatelům najít a sledovat vaši osobu nebo\n" +
    "          váš obsah ve Službě, včetně takové aktivity prostřednictvím služby\n" +
    "          Facebook. Vaše informace můžeme použít k upozornění jiných osob, včetně\n" +
    "          takového upozornění v rámci Služby, prostřednictvím e-mailu nebo služby\n" +
    "          Facebook či aplikací třetích stran, na vaše používání Služby (např. na\n" +
    "          to, že jste se přidali do Služby, nebo na aktivitu týkající se profilu\n" +
    "          ve Službě, jako je procvičování nového obsahu).\n" +
    "        </p>\n" +
    "        <h4>5.1.2 Aplikace třetích stran</h4>\n" +
    "        <p>\n" +
    "          Pokud připojíte svůj účet Služby k aplikaci třetí strany, může Služba\n" +
    "          automaticky sdílet vaši aktivitu a zprávy týkající se aktivity s\n" +
    "          příslušnou službou, včetně informací o obsahu, který používáte.\n" +
    "          Rozumíte a souhlasíte, že tyto informace lze přiřadit k vašemu účtu v\n" +
    "          příslušné aplikaci třetí strany a zveřejnit je v příslušné službě. I\n" +
    "          když tyto informace mohou být ve výchozím nastavení automaticky\n" +
    "          sdíleny, v nastavení uživatelského profilu můžete sdílení těchto\n" +
    "          informací omezit. Aplikace třetí strany může poskytovat podobné\n" +
    "          kontrolní prvky.\n" +
    "        </p>\n" +
    "        <p>\n" +
    "          Rozumíte a souhlasíte, že použití informací, které od vás získá\n" +
    "          aplikace třetí strany (s vaším souhlasem) se řídí zásadami ochrany\n" +
    "          osobních údajů aplikace třetí strany a vašimi nastaveními v příslušné\n" +
    "          službě, a použití takových údajů ve Službě se řídí těmito zásadami\n" +
    "          ochrany osobních údajů a vašimi nastaveními účtu služby Anatom.\n" +
    "        </p>\n" +
    "        <h3>5.2 Sdílení službou Anatom</h3>\n" +
    "        <h4>5.2.1 Marketing a reklama</h4>\n" +
    "        <p>\n" +
    "          Můžeme sdílet informace s reklamními partnery za účelem odesílání\n" +
    "          propagačních zpráv týkajících se Služby nebo zobrazovaní většího\n" +
    "          množství přizpůsobeného obsahu, včetně relevantní reklamy týkající se\n" +
    "          produktů a služeb, které by vás mohly zajímat, nebo za účelem získání\n" +
    "          informací týkajících se interakce uživatelů s reklamou. Sdílené\n" +
    "          informace jsou ve formátu zbaveném identifikačních znaků, pomocí\n" +
    "          kterého vás nelze osobně identifikovat.\n" +
    "        </p>\n" +
    "        <p>\n" +
    "          V části Informace o souborech cookie, dalších technologiích a\n" +
    "          shromažďování dat o třetích stranách níže naleznete informace týkající\n" +
    "          se souborů cookie a dalších technologií, které naše společnost a třetí\n" +
    "          strany používají k zobrazování relevantnějších reklam, a svých\n" +
    "          možností.\n" +
    "        </p>\n" +
    "        <h4>5.2.2 Poskytovatelé služeb a jiné strany</h4>\n" +
    "        <p>\n" +
    "          Z času na čas můžeme sdílet vaše informace s poskytovateli služeb za\n" +
    "          účelem poskytování funkcí a zpracování uživatelských údajů nebo za\n" +
    "          účelem poskytování našich služeb v souladu s těmito zásadami ochrany\n" +
    "          osobních údajů. Například spolupracujeme s poskytovateli analýz při\n" +
    "          analyzování učení či atraktivity obsahu. Pokud pro nás třetí strana\n" +
    "          zpracovává údaje, vztahují se na ni povinnosti týkající se zabezpečení\n" +
    "          a důvěrnosti, které jsou v souladu s těmito zásadami ochrany osobních\n" +
    "          údajů a příslušnými zákony. Pokud třetí strana zpracovává uživatelské\n" +
    "          údaje ve vlastním zájmu, toto zpracování se řídí jejími vlastními\n" +
    "          zásadami ochrany osobních údajů a příslušným zákonem.\n" +
    "        </p>\n" +
    "        <h4>5.2.3 Držitelé práv</h4>\n" +
    "        <p>\n" +
    "          Služba Anatom vám umožňuje prohlížet plně licencovaný obsah. Naše\n" +
    "          společnost sdílí informace s držiteli práv, kteří tento obsah poskytují\n" +
    "          na základě licence ve Službě. Údaje, které naše společnost sdílí, jsou\n" +
    "          ve formátu zbaveném identifikačních znaků, pomocí kterého vás nelze\n" +
    "          přímo identifikovat, pokud se nerozhodnete sdílet svoje osobní\n" +
    "          informace.\n" +
    "        </p>\n" +
    "        <h4>5.2.4 Jiné sdílení</h4>\n" +
    "        <p>Kromě výše uvedených případů můžeme sdílet vaše informace s třetími stranami za následujícími omezenými účely:</p>\n" +
    "        <ol>\n" +
    "          <li>k umožnění sloučení, získání nebo prodeje všech našich aktiv nebo jejich části,</li>\n" +
    "          <li>v reakci na soudní konání (např. soudní příkaz nebo obsílku), pokud se v dobré víře domníváme, že je to nezbytné; abychom dodrželi požadavky příslušné zákonné povinnosti; abychom chránili bezpečnost jakékoli osoby; abychom chránili práva a majetek naší společnosti, včetně vynucování <a href=\"/terms-of-use-{{LANGUAGE_CODE}}\" scroll-top>Podmínek použití</a> a jakýchkoli dalších podmínek, se kterými jste souhlasili; a k řešení podvodu nebo bezpečnostních či technických potíží,</li>\n" +
    "          <li>s akademickými výzkumníky za účely zahrnujícími statistickou analýzu nebo akademické studie,</li>\n" +
    "          <li>ke zveřejnění souhrnných informací nebo informací zbavených identifikačních znaků týkajících se použití Služby.</li>\n" +
    "        </ol>\n" +
    "        <h2>6 Vaše předvolby</h2>\n" +
    "        <p>\n" +
    "          Poskytujeme vám nastavení, pomocí kterých si můžete vybrat, jakou\n" +
    "          komunikaci od nás budete přijímat, spravovat svoje veřejně dostupné\n" +
    "          informace a nastavovat svoje předvolby sdílení. Některé informace mohou\n" +
    "          být vždy veřejně dostupné pro jiné uživatele a jiné informace jsou\n" +
    "          veřejně dostupné pro jiné uživatele ve výchozím nastavení. Také platí,\n" +
    "          že pokud budete sdílet informace v aplikaci třetí strany, bude tyto\n" +
    "          informace možné zobrazit ve službě bez ohledu na vaše nastavení ochrany\n" +
    "          osobních údajů.\n" +
    "        </p>\n" +
    "        <p>\n" +
    "          Pomocí úpravy nastavení svého účtu můžete změnit, zda budou některé informace veřejně dostupné.\n" +
    "        </p>\n" +
    "        <p>\n" +
    "          Informace, které jsou veřejně dostupné, mohou být použity, znovu\n" +
    "          sdíleny nebo odeslány pomocí odkazu jiným osobám ve službě nebo na\n" +
    "          internetu, proto používejte službu s rozvahou a dbejte na svá\n" +
    "          nastavení. Také nezapomínejte, že informace přidané na váš profil mohou\n" +
    "          zahrnovat osobní informace, například uživatelské jméno, které mohou\n" +
    "          umožnit jiným osobám vyhledat vás v rámci služby nebo jiných služeb.\n" +
    "        </p>\n" +
    "        <h2>7 Přenos do jiných zemí</h2>\n" +
    "        <p>\n" +
    "          Naše společnost přenáší, zpracovává a ukládá informace o uživatelích\n" +
    "          na serverech v ČR. Společnost také může smluvně uložit zpracování\n" +
    "          vašich informací třetím stranám nacházejícím se v jiných zemích, než je\n" +
    "          vaše domovská země, nebo vaše informace sdílet s takovými třetími\n" +
    "          stranami. Na vaše osobní informace se proto mohou vztahovat zákony na\n" +
    "          ochranu osobních údajů, které se liší od místních zákonů ve vaší zemi.\n" +
    "          Informace shromážděné v rámci evropského ekonomického prostoru (EEA) a\n" +
    "          Švýcarska mohou být například přeneseny třetím stranám uvedeným výše a\n" +
    "          zpracovány těmito třetími stranami v zemi mimo EEA a Švýcarska, kde\n" +
    "          můžete mít ze zákona méně práv týkajících se vašich informací. Naše\n" +
    "          společnost bude zpracovávat vaše informace způsobem, který je popsán v\n" +
    "          těchto zásadách ochrany osobních údajů.\n" +
    "        </p>\n" +
    "        <h2>8 Odkazy</h2>\n" +
    "        <p>\n" +
    "          Můžeme zobrazovat reklamy třetích stran a jiný obsah, který odkazuje\n" +
    "          na weby třetích stran. Nemáme žádnou kontrolu nad postupy týkajícími se\n" +
    "          ochrany osobních údajů a obsahem těchto třetích stran a nemůžeme za ně\n" +
    "          nést odpovědnost. Pokud chcete zjistit, jakým způsobem shromažďují a\n" +
    "          zpracovávají vaše osobní informace, přečtěte si zásady ochrany osobních\n" +
    "          údajů příslušných stran.\n" +
    "        </p>\n" +
    "        <h2>9 Zabezpečení</h2>\n" +
    "        <p>\n" +
    "          Jsme odhodláni chránit informace našich uživatelů. Vaše heslo chrání\n" +
    "          váš uživatelský účet, proto byste si měli vybrat jedinečné a dostatečně\n" +
    "          silné heslo, omezit přístup ke svému počítači a prohlížeči a odhlásit\n" +
    "          se, až skončíte s používáním Služby. I když používáme opatření na\n" +
    "          ochranu údajů, žádná bezpečnostní opatření nejsou dokonale bezpečná,\n" +
    "          proto nezaručujeme bezpečnost uživatelských informací.\n" +
    "        </p>\n" +
    "        <h2>10 Přístup k uživatelským informacím a jejich aktualizace</h2>\n" +
    "        <p>\n" +
    "          Většinu informací, které o vás uchováváme, si můžete zobrazit a\n" +
    "          upravit prostřednictvím stránek svého profilu a účtu. Pokud máte\n" +
    "          jakékoli otázky týkající se ochrany vašich osobních údajů ve Službě,\n" +
    "          těchto zásad ochrany osobních údajů nebo informací, které o vás máme,\n" +
    "          kontaktujte nás na adrese anatom@memorix.cz.\n" +
    "        </p>\n" +
    "        <h2>11 Změny zásad ochrany osobních údajů</h2>\n" +
    "        <p>\n" +
    "          Příležitostně můžeme podle svého uvážení provést změny těchto Dohod.\n" +
    "          Pokud provedeme zásadní změny Dohod, okamžitě vás upozorníme způsobem\n" +
    "          přiměřeným okolnostem, například zobrazením výrazného upozornění ve\n" +
    "          Službě nebo odesláním e-mailu s upozorněním. V některých případech vás\n" +
    "          upozorníme předem. V takovém případě bude vaše další používání Služby i\n" +
    "          po provedení změn představovat váš souhlas se změnami. Proto si pozorně\n" +
    "          přečtěte jakékoli takové upozornění. Pokud nechcete pokračovat v\n" +
    "          používání Služby na základě nové verze Dohod, můžete tyto Dohody\n" +
    "          odmítnout kontaktováním naší společnosti.\n" +
    "        </p>\n" +
    "        <h2>12 Informace o souborech cookie, dalších technologiích a shromažďování dat o třetích stranách</h2>\n" +
    "        <p>\n" +
    "          Tato část popisuje použití souborů cookie a dalších technologií.\n" +
    "          Další informace o způsobu, jakým může naše společnost sdílet informace,\n" +
    "          naleznete v části Sdílení službou Anatom.\n" +
    "        </p>\n" +
    "        <h3>12.1 Co jsou soubory cookie a další technologie?</h3>\n" +
    "        <p>\n" +
    "          Soubor cookie je malý textový soubor, který je umístěný na váš\n" +
    "          počítač, mobilní telefon nebo jiné zařízení, když navštívíte web.\n" +
    "          Soubor cookie pomůže poskytovatelům webu rozpoznat vaše zařízení při\n" +
    "          další návštěvě webu. K dispozici jsou další podobné technologie,\n" +
    "          například pixelové značky (průhledné grafické obrázky umístěné na\n" +
    "          webovou stránku nebo do e-mailu, které označují zobrazení stránky nebo\n" +
    "          e-mailu), webové štěnice (podobné, jako pixelové značky), a webová\n" +
    "          úložiště, která se používají v softwaru pro stolní počítače nebo v\n" +
    "          mobilních zařízeních.\n" +
    "        </p>\n" +
    "        <p>\n" +
    "          Také existují technologie, jako jsou identifikátory mobilních\n" +
    "          zařízení a integrace SDK, které pomáhají společnostem rozpoznat vaše\n" +
    "          zařízení při dalším použití aplikace nebo jiném použití služby.\n" +
    "        </p>\n" +
    "        <h3>12.2 Způsob použití souborů cookie a dalších technologií</h3>\n" +
    "        <p>\n" +
    "          Používáme soubory cookie týkající se relace (platnost kterých vyprší\n" +
    "          po ukončení webového prohlížeče) i trvalé soubory cookie (které\n" +
    "          zůstávají na vašem zařízení po určitý čas, nebo dokud je neodstraníte).\n" +
    "        </p>\n" +
    "        <h3>12.3 Správa vašich souborů cookie a dalších předvoleb</h3>\n" +
    "        <p>\n" +
    "          Mnoho webových prohlížečů umožňuje správu vašich předvoleb. Můžete\n" +
    "          nastavit prohlížeč tak, aby odmítal soubory cookie, nebo aby některé\n" +
    "          soubory cookie mazal. Pomocí předvoleb webového prohlížeče můžete také\n" +
    "          spravovat jiné technologie stejným způsobem, jako soubory cookie.\n" +
    "        </p>\n" +
    "        <p>\n" +
    "          Upozorňujeme, že pokud se rozhodnete blokovat soubory cookie, může\n" +
    "          dojít k omezení Služby nebo ztrátě funkčnosti některých prvků Služby.\n" +
    "        </p>\n" +
    "        <p>\n" +
    "          Ve službě Anatom zobrazujeme reklamy ve spolupráci s reklamními\n" +
    "          partnery. Jednou ze služeb, které používáme ke sledování aktivity\n" +
    "          související se Službou, např. pomocí umístění souborů cookie, je služba\n" +
    "          Google Analytics od společnosti Google (Google, Inc. a company\n" +
    "          headquartered at 1600 Amphitheatre Parkway, Mountain View, CA 94043,\n" +
    "          USA). Můžeme používat dodavatele včetně společnosti Google, kteří\n" +
    "          používají proprietární soubory cookie (například soubor cookie služby\n" +
    "          Google Analytics) a soubory třetích stran současně k získávání\n" +
    "          informací, optimalizaci a zobrazování reklam na základě vašich\n" +
    "          předchozích návštěv našich webů, včetně služby Google Analytics pro\n" +
    "          zobrazování reklam. Společnost Google poskytuje nástroje ke správě\n" +
    "          shromažďování a použití různých informací službou Google Analytics na\n" +
    "          adrese <a href=\"https://tools.google.com/dlpage/gaoptout\">tools.google.com/dlpage/gaoptout</a> a službou Google Analytics pro\n" +
    "          zobrazování reklam nebo zobrazovací sítě Google pomocí použití\n" +
    "          nastavení reklam Google na adrese <a\n" +
    "          href=\"https://google.com/settings/ads\">google.com/settings/ads</a>.\n" +
    "        </p>\n" +
    "        <p>\n" +
    "          Tímto souhlasíte s použitím souborů cookie a dalších technologií popsaných výše.\n" +
    "        </p>\n" +
    "        <h3>12.4 Další informace</h3>\n" +
    "        <p>\n" +
    "          Další informace o použití souborů cookie a způsobech blokování těchto\n" +
    "          souborů naleznete na stránkách <a href=\"http://allaboutcookies.org\">allaboutcookies.org</a>,\n" +
    "          <a href=\"http://youronlinechoices.eu\">youronlinechoices.eu</a> (Evropa) nebo <a href=\"http://aboutads.info/choices\">aboutads.info/choices</a> (USA). Pokud\n" +
    "        máte jakékoli otázky nebo připomínky týkající se našeho použití souborů\n" +
    "        cookie, kontaktujte nás na adrese anatom@memorix.cz.\n" +
    "        </p>\n" +
    "        <p>Společnost kontrolující údaje:</p>\n" +
    "        <p>\n" +
    "          MUDr. Marek Čierny<br>\n" +
    "          Konečného 2170/4,<br>\n" +
    "          Brno, 61500, ČR<br>\n" +
    "          IČ: 74284854<br>\n" +
    "          DIČ: neplátce DPH\n" +
    "        </p>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div class=\"clearfix\"></div>\n" +
    "");
  $templateCache.put("static/tpl/privacy_policy_en.html",
    "<br>\n" +
    "<div class=\"privacy-policy row\">\n" +
    "  <div class=\"col-sm-offset-2 col-sm-8\">\n" +
    "    <div class=\"panel panel-default\">\n" +
    "      <div class=\"panel-heading\">\n" +
    "        <h1>Practice Anatomy Privacy Policy</h1>\n" +
    "      </div>\n" +
    "      <div class=\"panel-body\">\n" +
    "        <p>Effective as of October 22, 2015</p>\n" +
    "        <p>\n" +
    "          Hello, and welcome to our Privacy Policy. This Privacy Policy helps\n" +
    "          you to make informed decisions about your relationship with us, so\n" +
    "          please read it carefully.\n" +
    "        </p>\n" +
    "        <h2>1 Introduction</h2>\n" +
    "        <p>\n" +
    "          Thanks for choosing PracticeAnatomy.com (“Practice Anatomy”,\n" +
    "          “PracticeAnatomy”). This is our Privacy Policy. Before getting into the\n" +
    "          details, we’d like to highlight some of the key principles behind it.\n" +
    "          These principles are important to us because we know they’re important\n" +
    "          to you.\n" +
    "        </p>\n" +
    "        <p>The Privacy Policy is here to do three things:</p>\n" +
    "        <ol>\n" +
    "          <li>Explain the way we use information that you share with us in order to build a great product and give you a great experience with it;</li>\n" +
    "          <li>Ensure that you understand what information we collect with your permission, and what we do — and do not do — with it;</li>\n" +
    "          <li>Hold us accountable for protecting your rights and your privacy under this policy.</li>\n" +
    "        </ol>\n" +
    "        <p>\n" +
    "          All the information we collect is related to providing the Practice\n" +
    "          Anatomy service and its features.\n" +
    "        </p>\n" +
    "        <p>\n" +
    "          Broadly speaking, there are two categories of information we collect:\n" +
    "          1) information that we must have in order for you to use Practice\n" +
    "          Anatomy; and 2) information that we can use to provide additional\n" +
    "          features and improved learning experience if you choose to share that\n" +
    "          information.\n" +
    "        </p>\n" +
    "        <p>The first category includes:</p>\n" +
    "        <ul>\n" +
    "          <li>Registration information, including your name, birth date, address, and other information you provide when you sign up for Practice Anatomy.</li>\n" +
    "          <li>Broad, non-specific location, which we derive from your IP address.</li>\n" +
    "          <li>The content you are practicing and your interactions with the Service. This allows us to personalize the educational content and suggest relevant content. You can choose whether or not to share this information with your friends, followers, or the public.</li>\n" +
    "          <li>Technical and sensor information necessary to operate Practice Anatomy. This includes the type of browser and device you use, data from the touchscreen, and information from your device’s accelerometer and gyroscope sensors.</li>\n" +
    "        </ul>\n" +
    "        <p>\n" +
    "          The second category includes information that enables us to offer you\n" +
    "          additional features. We never receive any of the following information\n" +
    "          unless you expressly choose to share it with us. It’s as simple as\n" +
    "          that. Here are some examples:\n" +
    "        </p>\n" +
    "        <ul>\n" +
    "          <li>Your photos: We will only access images that you specifically choose, and we will never scan or import your photo library or camera roll. This allows you to choose individual pictures to change your profile picture. You can stop sharing photos and revoke access at any time.</li>\n" +
    "          <li>Your contacts: We will never scan or import your contacts unless you ask us to. If you choose to do so, we will only use your contact information to help you find friends or contacts who use Practice Anatomy.</li>\n" +
    "        </ul>\n" +
    "        <p>\n" +
    "          The distinction between these two categories is important.\n" +
    "          Information in the first category is information you must provide in\n" +
    "          order to use Practice Anatomy. When you agree to our Privacy Policy,\n" +
    "          you give us the right to collect this information and use it for the\n" +
    "          purposes described. Information in the second category is information\n" +
    "          we will only collect if you explicitly give us permission to do so in\n" +
    "          the future. For this second category of information, we will ask for\n" +
    "          your permission before first accessing it, we will describe how we will\n" +
    "          use it if you give us permission, we will only use the information for\n" +
    "          the purpose we described, and you will always have the ability to\n" +
    "          change your mind and revoke that permission. Acceptance of our Privacy\n" +
    "          Policy does not mean you have granted us permission to access or use\n" +
    "          information in the second category; we’re just explaining to you that\n" +
    "          one day we might ask you for that permission.\n" +
    "        </p>\n" +
    "        <p><strong>We will be clear with you about how and when we might share information.</strong></p>\n" +
    "        <p>\n" +
    "          In some contexts, we will share certain information. For example,\n" +
    "          like most services, if you sign up for Practice Anatomy through a third\n" +
    "          party like Facebook or Google, we share some information with them and\n" +
    "          they share some information with us in order to enable your account.\n" +
    "          And we also share de-identified information with our research partners\n" +
    "          to help them better understand the process of learning, with marketing\n" +
    "          partners who help us with promotional efforts, and with advertisers.\n" +
    "          There also may be times when you want us to share information. For\n" +
    "          example, when you want to share with your friends how good anatomy\n" +
    "          knowledge you have...\n" +
    "        </p>\n" +
    "        <p>\n" +
    "          We hope this helps you to understand our privacy commitments to you.\n" +
    "          Now, the details await you below, but please remember that this\n" +
    "          Introduction is part of the Privacy Policy itself — it’s our promise to\n" +
    "          you. If you ever have any questions or concerns, then please let us\n" +
    "          know at anatom@googlegroups.com.\n" +
    "        </p>\n" +
    "        <p>\n" +
    "          Throughout this Privacy Policy we refer to the Practice Anatomy Service\n" +
    "          or the Service. These terms are defined in our <a href=\"/terms-of-use-{{LANGUAGE_CODE}}\" scroll-top>Terms and Conditions of\n" +
    "          Use</a> (the “Terms and Conditions of Use”).\n" +
    "        </p>\n" +
    "        <h2>2 Key highlights of what you’re consenting to</h2>\n" +
    "        <p>By using or interacting with the Service, you are consenting to:</p>\n" +
    "        <ol>\n" +
    "          <li>the use of cookies and other technologies;</li>\n" +
    "          <li>the transfer of your information outside of the country where you live;</li>\n" +
    "          <li>the collection, use, sharing, and other processing of your information, including for advertising-related purposes (as described in the rest of this Privacy Policy, so please keep on reading!); and</li>\n" +
    "          <li>the public availability of your information and the controls over such information as described in Sharing information.</li>\n" +
    "        </ol>\n" +
    "        <p>\n" +
    "          In each case, you consent to the processing of data by the entities\n" +
    "          described in this Privacy Policy, including the Practice Anatomy\n" +
    "          entity, as data controller, indicated at the bottom of this document\n" +
    "          (collectively, “Practice Anatomy”, “we”, “us”, “our”). In the Your\n" +
    "          Preferences section, we describe the controls and relevant settings\n" +
    "          associated with your Practice Anatomy account. If you don't agree with\n" +
    "          the terms of this Privacy Policy, then please don't use the Service.\n" +
    "        </p>\n" +
    "        <h2>3 The information we collect</h2>\n" +
    "        <p>We may collect and store the following information:</p>\n" +
    "        <h3>3.1 Registration data</h3>\n" +
    "        <p>\n" +
    "          When you sign up for the Service, we may ask you for information such\n" +
    "          as your username, password, email address, date of birth, gender,\n" +
    "          address, education, postal code, and country. If you connect to the\n" +
    "          Service using credentials from a Third Party Application (as defined in\n" +
    "          the <a href=\"/terms-of-use-{{LANGUAGE_CODE}}\" scroll-top>Terms and Conditions of Use</a>) (e.g., Facebook), you authorise us to\n" +
    "          collect your authentication information, such as your username and\n" +
    "          encrypted access credentials. We may also collect other information\n" +
    "          available on or through your Third Party Application account,\n" +
    "          including, for example, your name, profile picture, country, hometown,\n" +
    "          email address, date of birth, gender, friends’ names and profile\n" +
    "          pictures, and networks.\n" +
    "        </p>\n" +
    "        <p>\n" +
    "          You may also choose to voluntarily add other information to your\n" +
    "          profile, such as your mobile phone number and mobile service provider.\n" +
    "        </p>\n" +
    "        <h3>3.2 Usage, log data &amp; cookies</h3>\n" +
    "        <p>\n" +
    "          When you use or interact with the Service, we may use a variety of\n" +
    "          technologies that collect information about how the Service is accessed\n" +
    "          and used. This information may include:\n" +
    "        </p>\n" +
    "        <ol>\n" +
    "          <li>information about your type of subscription and your interactions with the Service, </li>\n" +
    "          <li>User Content (as defined in the <a href=\"/terms-of-use-{{LANGUAGE_CODE}}\" scroll-top>Terms and Conditions of Use</a>) you post to the Service including messages you send and/or receive via the Service;</li>\n" +
    "          <li>technical data, which may include URL information, cookie data, your IP address, the types of devices you are using to access or connect to the Practice Anatomy Service, unique device ID, device attributes, network connection type (e.g., WiFi, 3G, LTE) and provider, network and device performance, browser type, language, information enabling digital rights management, operating system, and Practice Anatomy application version.</li>\n" +
    "          <li>motion-generated or orientation-generated mobile sensor data (e.g., accelerometer or gyroscope).</li>\n" +
    "        </ol>\n" +
    "        <p>\n" +
    "          You may integrate your Practice Anatomy account with Third Party\n" +
    "          Applications. If you do, we may receive similar information related to\n" +
    "          your interactions with the Service on the Third Party Application, as\n" +
    "          well as information about your publicly available activity on the Third\n" +
    "          Party Application. This includes, for example, your “Like”s and posts\n" +
    "          on Facebook. We may use cookies and other technologies to collect this\n" +
    "          information; you can learn more about such use in the section\n" +
    "          Information about cookies and other technologies of this Privacy\n" +
    "          Policy.\n" +
    "        </p>\n" +
    "        <h3>3.3 Your mobile device</h3>\n" +
    "        <p>\n" +
    "          We may provide features that rely on the use of additional\n" +
    "          information on your mobile device or require access to certain services\n" +
    "          on your mobile device that will enhance your Practice Anatomy\n" +
    "          experience but are not required to use the Service. (In other words,\n" +
    "          information that falls in the second category described in the\n" +
    "          Introduction to this Policy.) For example, we might allow you to upload\n" +
    "          photos to your profile, connect with friends. Granting us access does\n" +
    "          not mean you are granting us unlimited access to that information or\n" +
    "          that we will access specific information without your permission. To\n" +
    "          the contrary, for each type of information listed in this section,\n" +
    "          before we access this information or these features of your mobile\n" +
    "          device, we will ask for your permission. If you provide such\n" +
    "          permission, we will collect the information for the specific purposes\n" +
    "          explained at the time we ask for your permission. You do not have to\n" +
    "          give us such permission in order to use Practice Anatomy, and\n" +
    "          acceptance of this Privacy Policy does not mean you have granted us\n" +
    "          permission to access this information.\n" +
    "        </p>\n" +
    "        <h3>3.4 Payment data</h3>\n" +
    "        <p>\n" +
    "          If you sign up for a Trial (as defined in the <a href=\"/terms-of-use-{{LANGUAGE_CODE}}\" scroll-top>Terms and Conditions of\n" +
    "          Use</a>), purchase any of our Paid Subscriptions (as defined in the <a href=\"/terms-of-use-{{LANGUAGE_CODE}}\" scroll-top>Terms\n" +
    "          and Conditions of Use</a>), or make other purchases through the Service,\n" +
    "          your credit or debit card information (such as card type and expiration\n" +
    "          date) and other financial data that we need to process your payment may\n" +
    "          be collected and stored by us and/or the payment processors with which\n" +
    "          we work. We may also collect some limited information, such as your\n" +
    "          postal code, mobile number, and details of your transaction history,\n" +
    "          all of which are necessary to provide the Service. In addition, the\n" +
    "          payment processors generally provide us with some limited information\n" +
    "          related to you, such as a unique token that enables you to make\n" +
    "          additional purchases using the information they’ve stored, and your\n" +
    "          card’s type, expiration date, and certain digits of your card number.\n" +
    "        </p>\n" +
    "        <p>\n" +
    "          If you choose to pay by invoice, Practice Anatomy may need to collect\n" +
    "          and store additional information, like your name, date of birth, and\n" +
    "          phone number, and provide it to payment processors we work with to\n" +
    "          issue invoices, to enable credit checks and to send you invoices.\n" +
    "        </p>\n" +
    "        <p>\n" +
    "          BY ACCEPTING THE PRIVACY POLICY, YOU EXPRESSLY AUTHORISE Practice\n" +
    "          Anatomy TO USE AND SHARE WITH CERTAIN TRUSTED BUSINESS PARTNERS AND\n" +
    "          SERVICE PROVIDERS, WHICH MAY BE LOCATED OUTSIDE OF THE COUNTRY OF YOUR\n" +
    "          RESIDENCE (INCLUDING COUNTRIES WHICH DO NOT PROVIDE THE SAME LEVEL OF\n" +
    "          PROTECTION FOR THE PROCESSING OF PERSONAL DATA AS THE COUNTRY OF YOUR\n" +
    "          RESIDENCE), THE INFORMATION PROVIDED BY YOU TO Practice Anatomy, EVEN\n" +
    "          IF SUCH INFORMATION IS COVERED BY LOCAL BANKING SECRECY LAWS. YOU\n" +
    "          ACKNOWLEDGE AND AGREE TO THE IMPORTANCE OF SHARING SUCH INFORMATION FOR\n" +
    "          THE PROVISION OF THE Practice Anatomy SERVICE AND ALSO AGREE THAT, BY\n" +
    "          ACCEPTING THIS PRIVACY POLICY, WHERE APPLICABLE AND TO THE EXTENT\n" +
    "          PERMITTED BY APPLICABLE LAW, YOU EXPRESSLY WAIVE YOUR RIGHTS UNDER SUCH\n" +
    "          BANK SECRECY LAWS WITH REGARD TO Practice Anatomy, AND ANY TRUSTED\n" +
    "          BUSINESS PARTNERS AND SERVICE PROVIDERS, WHICH MAY BE LOCATED OUTSIDE\n" +
    "          YOUR COUNTRY OF RESIDENCE. THIS CONSENT IS GIVEN FOR THE DURATION OF\n" +
    "          YOUR RELATIONSHIP WITH Practice Anatomy.\n" +
    "        </p>\n" +
    "        <h3>3.5 Practice Anatomy service providers and partners</h3>\n" +
    "        <p>\n" +
    "          We may also receive information about you from our service providers\n" +
    "          and partners, which we use to personalise your Practice Anatomy\n" +
    "          experience, to measure ad quality and responses to ads, and to display\n" +
    "          ads that are more likely to be relevant to you. We also use this\n" +
    "          information as explained in the section How we use the information we\n" +
    "          collect below\n" +
    "        </p>\n" +
    "        <h2>4 How we use the information we collect</h2>\n" +
    "        <p>\n" +
    "          Consistent with the permissions you give us to collect the\n" +
    "          information, we may use the information we collect, including your\n" +
    "          personal information:\n" +
    "        </p>\n" +
    "        <ol>\n" +
    "          <li>to provide, personalise, and improve your experience with the Service and products, services, and advertising (including for third party products and services) made available on or outside the Service (including on other sites that you visit), for example by providing customised, personalised, or localised content, recommendations, features, and advertising on or outside of the Service;</li>\n" +
    "          <li>to ensure technical functionality of the Service, develop new products and services, and analyse your use of the Service, including your interaction with applications, advertising, products, and services that are made available, linked to, or offered through the Service;</li>\n" +
    "          <li>to communicate with you for Service-related or research purposes including via emails, notifications, text messages, or other messages, which you agree to receive;</li>\n" +
    "          <li>to enable and promote the Service and other services or products, either within or outside the Service, including features and content of the Service and products and services made available through the Service;</li>\n" +
    "          <li>to process your payment or prevent or detect fraud;</li>\n" +
    "          <li>to enforce this Privacy Policy, the <a href=\"/terms-of-use-{{LANGUAGE_CODE}}\" scroll-top>Terms and Conditions of Use</a>, and any other terms that you have agreed to, including to protect the rights, property, or safety of Practice Anatomy, its users, or any other person, or the copyright-protected content of the Service;</li>\n" +
    "          <li>to provide you with features, information, advertising, or other content which is influenced by your location and your location in relation to other Practice Anatomy users; and</li>\n" +
    "          <li>as otherwise stated in this Privacy Policy.</li>\n" +
    "        </ol>\n" +
    "        <h2>5 Sharing information</h2>\n" +
    "        <p>\n" +
    "          This section describes how the information collected or generated\n" +
    "          through your use of the Practice Anatomy service may be shared by you\n" +
    "          or by us.\n" +
    "        </p>\n" +
    "        <h3>5.1 Sharing by you</h3>\n" +
    "        <h4>5.1.1 Generally</h4>\n" +
    "        <p>Your name and/or username, profile picture, and your Practice Anatomy user profile will always be publicly available.</p>\n" +
    "        <p>\n" +
    "          Your activity at Practice Anatomy, correct and incorrect answers to\n" +
    "          any questions and other information related to your knowledge level and\n" +
    "          achievements are publically available in the default mode. This can be\n" +
    "          changed in the Preferences of your account.\n" +
    "        </p>\n" +
    "        <p>\n" +
    "          Please remember that certain information is always publicly\n" +
    "          available, which means that it can be accessed by Third Party\n" +
    "          Applications through our APIs and developer tools. Based on your\n" +
    "          permissions, some additional information can be shared with Third Party\n" +
    "          Applications and with others through Third Party Applications. For\n" +
    "          example, you can use your settings to control whether your Practice\n" +
    "          Anatomy activity is posted to Facebook. Similarly, you may consent to\n" +
    "          provide Third Party Applications with access to your email address,\n" +
    "          subscription status, location, birthday, or similar information, upon\n" +
    "          their request.\n" +
    "        </p>\n" +
    "        <p>\n" +
    "          We may use your public information to promote the Service and to help\n" +
    "          others find and follow you and/or your Practice Anatomy content,\n" +
    "          including through Facebook and other Third Party Applications and on\n" +
    "          websites that embed Practice Anatomy widgets. Your information may be\n" +
    "          used to notify others, including within the Service, via email, and\n" +
    "          through Facebook and Third Party Applications, about your use of the\n" +
    "          Service (e.g., that you have joined Practice Anatomy or activity\n" +
    "          related to a Practice Anatomy profile, such as practicing a new\n" +
    "          content).\n" +
    "        </p>\n" +
    "        <h4>5.1.2 Third Party Applications</h4>\n" +
    "        <p>\n" +
    "          If you connect your Practice Anatomy account to a Third Party\n" +
    "          Application, Practice Anatomy may automatically share your activity and\n" +
    "          activity-related stories with that service, including the content you\n" +
    "          consume. You understand and agree that that such information may be\n" +
    "          attributed to your account on the Third Party Application and may be\n" +
    "          published on such service. Although this information may be\n" +
    "          automatically shared by default, we inform you of the controls that you\n" +
    "          can use to limit the sharing of this information in the section Your\n" +
    "          preferences below. The Third Party Application may also provide similar\n" +
    "          controls.\n" +
    "        </p>\n" +
    "        <p>\n" +
    "          You understand and agree that a Third Party Application’s use of\n" +
    "          information collected from you (or as authorised by you) is governed by\n" +
    "          the Third Party Application’s privacy policies and your settings on the\n" +
    "          relevant service, and PracticeAnatomy’s use of such information is\n" +
    "          governed by this Privacy Policy and your Practice Anatomy account\n" +
    "          settings.\n" +
    "        </p>\n" +
    "        <h3>5.2 Sharing by Practice Anatomy</h3>\n" +
    "        <h4>5.2.1 Marketing and advertising</h4>\n" +
    "        <p>\n" +
    "          We may share information with advertising partners in order to send\n" +
    "          you promotional communications about Practice Anatomy or to show you\n" +
    "          more tailored content, including relevant advertising for products and\n" +
    "          services that may be of interest to you, and to understand how users\n" +
    "          interact with advertisements. The information we share is in a\n" +
    "          de-identified format (for example, through the use of hashing) that\n" +
    "          does not personally identify you.\n" +
    "        </p>\n" +
    "        <p>\n" +
    "          Please see the section Information about cookies, other technologies,\n" +
    "          and third-party data collection below for information about the\n" +
    "          cookies and other technologies that we and third parties use to serve\n" +
    "          you more relevant ads and your options.\n" +
    "        </p>\n" +
    "        <h4>5.2.2 Service providers and others</h4>\n" +
    "        <p>\n" +
    "          We may from time to time share your information with service\n" +
    "          providers to perform functions and process user data and help provide\n" +
    "          our Services, consistent with this Privacy Policy. For example, we work\n" +
    "          with data specialists analyzing learning efficiency and attractivity of\n" +
    "          content and analytics providers to help us understand the use of our\n" +
    "          Services. Where a third party processes user data on our behalf (e.g.,\n" +
    "          a hosting service provider), it is subject to security and\n" +
    "          confidentiality obligations consistent with this Privacy Policy and\n" +
    "          applicable law. Where a third party processes user data on its own\n" +
    "          behalf, its processing is subject to its own Privacy Policy and\n" +
    "          applicable law.\n" +
    "        </p>\n" +
    "        <h4>5.2.3 Rights holders</h4>\n" +
    "        <p>\n" +
    "          The Practice Anatomy service allows you to view to fully-licensed\n" +
    "          streaming content. Practice Anatomy shares information with the\n" +
    "          rights holders that license this content to Practice Anatomy. The\n" +
    "          data that Practice Anatomy shares is in a de-identified format that\n" +
    "          does not identify you directly, unless you opt in to the sharing of\n" +
    "          your personal information.\n" +
    "        </p>\n" +
    "        <h4>5.2.4 Other sharing</h4>\n" +
    "        <p>\n" +
    "          In addition to the above, we may also share your information with\n" +
    "          third parties for these limited purposes:\n" +
    "        </p>\n" +
    "        <ul>\n" +
    "          <li>to allow a merger, acquisition, or sale of all or a portion of our assets;</li>\n" +
    "          <li>to respond to legal process (e.g., a court order or subpoena), if we believe in good faith that it is necessary to do so; to comply with requirements of mandatory applicable law; to protect the safety of any person; to protect the rights and property of Practice Anatomy, including to enforce the <a href=\"/terms-of-use-{{LANGUAGE_CODE}}\" scroll-top>Terms and Conditions of Use</a> and any other terms that you have agreed to; and to address fraud, security, or technical issues;</li>\n" +
    "          <li>to academic researchers for purposes including statistical analysis and academic study;</li>\n" +
    "          <li>to publish de-identified or aggregate information about the use of the Practice Anatomy Service.</li>\n" +
    "        </ul>\n" +
    "        <h2>6 Your preferences</h2>\n" +
    "        <p>\n" +
    "          We provide you with settings to allow you to choose which\n" +
    "          communications you receive from us, manage your public information, and\n" +
    "          set your sharing preferences. However, certain information may always\n" +
    "          be publicly available to others and other information is made publicly\n" +
    "          available to others by default. And if you share information to a Third\n" +
    "          Party Application, that information is viewable on Practice Anatomy,\n" +
    "          regardless of how you set your privacy settings.\n" +
    "        </p>\n" +
    "        <p>\n" +
    "          To change whether certain information is publicly available, you can\n" +
    "          adjust the settings in your account.\n" +
    "        </p>\n" +
    "        <p>\n" +
    "          Information that is publicly available, may be used, re-shared, or\n" +
    "          linked to by others on the Service or across the web, so please use\n" +
    "          Practice Anatomy carefully and be mindful of your settings. Also keep\n" +
    "          in mind that information added to your profile may include personal\n" +
    "          information, such as username, which could enable other persons to find\n" +
    "          you within the Practice Anatomy Service or other services.\n" +
    "        </p>\n" +
    "        <h2>7 Transfer to other countries</h2>\n" +
    "        <p>\n" +
    "          Practice Anatomy transfers, processes and stores information about\n" +
    "          our users on servers located in Czech republic. Practice Anatomy may\n" +
    "          also subcontract processing to, or share your information with, third\n" +
    "          parties located in countries other than your home country. Your\n" +
    "          personal information may therefore be subject to privacy laws that are\n" +
    "          different from those in your country of residence. Information\n" +
    "          collected within the European Economic Area (“EEA”) and Switzerland\n" +
    "          may, for example, be transferred to and processed by third parties\n" +
    "          identified above, located in a country outside of the EEA and\n" +
    "          Switzerland, where you may have fewer legal rights in relation to your\n" +
    "          information. We will process your information as described in this\n" +
    "          Privacy Policy.\n" +
    "        </p>\n" +
    "        <h2>8 Links</h2>\n" +
    "        <p>\n" +
    "          We may display advertisements from third parties and other content\n" +
    "          that links to third party websites. We cannot control or be held\n" +
    "          responsible for third parties’ privacy practices and content. Please\n" +
    "          read their privacy policies to find out how they collect and process\n" +
    "          your personal information.\n" +
    "        </p>\n" +
    "        <h2>9 Security</h2>\n" +
    "        <p>\n" +
    "          We are committed to protecting our users’ information. Your password\n" +
    "          protects your user account, so you should use a unique and strong\n" +
    "          password, limit access to your computer and browser, and log out after\n" +
    "          having used the Service. While we take data protection precautions, no\n" +
    "          security measures are completely secure, and we do not guarantee the\n" +
    "          security of user information.\n" +
    "        </p>\n" +
    "        <h2>10 Accessing and updating user information</h2>\n" +
    "        <p>\n" +
    "          You can view and amend much of the information we keep about you\n" +
    "          through your account and profile pages. If you have questions about\n" +
    "          your privacy on the Service, this privacy policy, or information we\n" +
    "          have about you, please contact us at anatom@googlegroups.com. We will\n" +
    "          respond to your request within a reasonable period of time upon\n" +
    "          verification of your identity in accordance with local laws. We\n" +
    "          recommend you include documents that prove your identity and a clear\n" +
    "          and precise description of the information which you request access to.\n" +
    "        </p>\n" +
    "        <h2>11 Changes to the Privacy Policy</h2>\n" +
    "        <p>\n" +
    "          Occasionally we may, in our discretion, make changes to the\n" +
    "          Agreements. When we make material changes to the Agreements, we’ll\n" +
    "          provide you with prominent notice as appropriate under the\n" +
    "          circumstances, e.g., by displaying a prominent notice within the\n" +
    "          Service or by sending you an email. In some cases, we will notify you\n" +
    "          in advance, and your continued use of the Service after the changes\n" +
    "          have been made will constitute your acceptance of the changes. Please\n" +
    "          therefore make sure you read any such notice carefully. If you do not\n" +
    "          wish to continue using the Service under the new version of the\n" +
    "          Agreements, you may terminate the Agreements by contacting us.\n" +
    "        </p>\n" +
    "        <h2>12 Information about cookies, other technologies and third-party data collection</h2>\n" +
    "        <p>\n" +
    "          This section describes use of cookies and other technologies. For\n" +
    "          further information about how information may be shared by Practice\n" +
    "          Anatomy, please see the section Sharing by Practice Anatomy.\n" +
    "        </p>\n" +
    "        <h3>12.1 What are cookies and other technologies?</h3>\n" +
    "        <p>\n" +
    "          A cookie is a small text file that is placed on your computer, mobile\n" +
    "          phone, or other device when you visit a website. The cookie will help\n" +
    "          website providers to recognise your device the next time you visit\n" +
    "          their website. There are other similar technologies such as pixel tags\n" +
    "          (transparent graphic images placed on a web page or in an email, which\n" +
    "          indicate that a page or email has been viewed), web bugs (similar to\n" +
    "          pixel tags), and web storage, which are used in desktop software or\n" +
    "          mobile devices.\n" +
    "        </p>\n" +
    "        <p>\n" +
    "          There are also technologies such as mobile device identifiers and SDK\n" +
    "          integrations to help companies recognise your device when you return to\n" +
    "          an app or otherwise use the a service.\n" +
    "        </p>\n" +
    "        <h3>12.2 How we use cookies and other technologies</h3>\n" +
    "        <p>\n" +
    "          We use both session cookies (which expire once you close your web\n" +
    "          browser) and persistent cookies (which stay on your device for a set\n" +
    "          period of time or until you delete them).\n" +
    "        </p>\n" +
    "        <h3>12.3 Manage your cookie and other preferences</h3>\n" +
    "        <p>\n" +
    "          Many web browsers allow you to manage your preferences. You can set\n" +
    "          your browser to refuse cookies or delete certain cookies. You may be\n" +
    "          able to manage other technologies in the same way that you manage\n" +
    "          cookies using your browser’s preferences.\n" +
    "        </p>\n" +
    "        <p>\n" +
    "          Please note that if you choose to block cookies, doing so may impair\n" +
    "          the Service or prevent certain elements of it from functioning.\n" +
    "        </p>\n" +
    "        <p>\n" +
    "          We work with advertising partners to serve advertisements on the\n" +
    "          Service. One of the services we use to track activity related to the\n" +
    "          Service, e.g., by placing cookies, is Google Analytics by Google\n" +
    "          (Google, Inc. a company headquartered at 1600 Amphitheatre Parkway,\n" +
    "          Mountain View, CA 94043, USA). We may use vendors, including Google,\n" +
    "          who use first-party cookies (such as the Google Analytics cookie) and\n" +
    "          third-party cookies (such as the DoubleClick cookie) together to\n" +
    "          inform, optimise, and serve ads based on your past visits to our\n" +
    "          websites, including Google Analytics for Display Advertising. Google\n" +
    "          provides tools to manage the collection and use of certain information\n" +
    "          by Google Analytics at <a herf=\"https://tools.google.com/dlpage/gaoptout\">tools.google.com/dlpage/gaoptout</a> and by Google\n" +
    "          Analytics for Display Advertising or the Google Display Network by\n" +
    "          using Google’s Ads Settings at <a href=\"https://google.com/settings/ads\">https://google.com/settings/ads</a>.\n" +
    "        </p>\n" +
    "        <p>\n" +
    "          You hereby consent to the use of the cookies and other technologies\n" +
    "          described above.\n" +
    "        </p>\n" +
    "        <h3>12.4 More information</h3>\n" +
    "        <p>\n" +
    "          For more information about the use of cookies and how to block them,\n" +
    "          visit <a href=\"http://allaboutcookies.org\">allaboutcookies.org</a>, <a href=\"http://youronlinechoices.eu\">youronlinechoices.eu</a> (Europe), or\n" +
    "          <a href=\"http://aboutads.info/choices\">aboutads.info/choices</a> (United States). If you have any questions or\n" +
    "          comments about our use of cookies, please contact us at\n" +
    "          anatom@googlegroups.com.\n" +
    "        </p>\n" +
    "        <p>Data controller:</p>\n" +
    "        <p>\n" +
    "          MUDr. Marek Čierny<br>\n" +
    "          Konečného 2170/4,<br>\n" +
    "          Brno, 61500, ČR<br>\n" +
    "          Business ID: 74284854\n" +
    "        </p>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div class=\"clearfix\"></div>\n" +
    "");
  $templateCache.put("static/tpl/progress_labels.html",
    "<div class=\"text-center\">\n" +
    "   <span class=\"badge badge-default\"\n" +
    "       tooltip=\"{{'Naučeno' | translate}}\"\n" +
    "       tooltip-enable=\"!hideLabels\">\n" +
    "     <i class=\"color-indicator learned\"></i>\n" +
    "     <span class=\"hidden-xs\" ng-hide=\"hideLabels\">\n" +
    "       <span translate>Naučeno</span>:\n" +
    "     </span>\n" +
    "     <span ng-if=\"skills.number_of_mastered_items !== undefined\"\n" +
    "       count-to=\"{{skills.number_of_mastered_items}}\"\n" +
    "       duration=\"0.6\"\n" +
    "       count-from=\"0\"></span>\n" +
    "     {{skills.number_of_mastered_items === undefined ? '...' : '/'}}\n" +
    "     {{skills.number_of_items || ''}}\n" +
    "     <i class=\"glyphicon glyphicon-question-sign help-icon\"\n" +
    "        ng-if=\"!hideLabels\"\n" +
    "        popover-trigger=\"mouseenter\"\n" +
    "        popover-placement=\"bottom\"\n" +
    "        popover-append-to-body=\"true\"\n" +
    "        popover-title=\"{{'Počet naučených pojmů počítá náš prediktivní model' | translate}}\"\n" +
    "        popover=\"{{'Na základě odpovědí od všech uživatelů model ví, co je jak těžké. Na těžší pojmy se Tě raději zeptá víc krát, než usoudí, že je opravdu umíš, zato lehčími Tě možná vůbec otravovat nebude. Když ti půjdou ty těžší, tak prostě usoudí, že ty lehké umíš taky a zeptá se Tě na ně až po procvičení těch těšžích.' | translate}}\"\n" +
    "        track-hover=\"learned explanation\">\n" +
    "     </i>\n" +
    "   </span>\n" +
    "   <span class=\"badge badge-default\"\n" +
    "       tooltip=\"{{'Procvičováno' | translate}}\"\n" +
    "       tooltip-enable=\"!hideLabels\">\n" +
    "     <i class=\"color-indicator practiced\"></i>\n" +
    "     <span class=\"hidden-xs\" ng-hide=\"hideLabels\">\n" +
    "       <span translate>Procvičováno</span>:\n" +
    "     </span>\n" +
    "     <span ng-if=\"skills.number_of_practiced_items !== undefined\"\n" +
    "       count-to=\"{{skills.number_of_practiced_items}}\"\n" +
    "       duration=\"0.6\"\n" +
    "       count-from=\"0\"></span>\n" +
    "     {{skills.number_of_practiced_items === undefined ? '...' : '/'}}\n" +
    "     {{skills.number_of_items || ''}}\n" +
    "   </span>\n" +
    "  </div>\n" +
    "\n" +
    "");
  $templateCache.put("static/tpl/progress_tpl.html",
    "<progress class=\"overview-progress\">\n" +
    "  <bar class=\"progress-bar-practiced\"\n" +
    "      value=\"100 * skills.number_of_practiced_items / skills.number_of_items\">\n" +
    "  </bar>\n" +
    "  <bar class=\"progress-bar-learned\"\n" +
    "      value=\"100 * skills.number_of_mastered_items / skills.number_of_items\"\n" +
    "      ng-show=\"skills.number_of_mastered_items\">\n" +
    "  </bar>\n" +
    "</progress>\n" +
    "<div skills=\"{{skills}}\" ng-if=\"!hideLabels\">\n" +
    "  <div progress-labels skills=\"skills\"></div>\n" +
    "</div>\n" +
    "");
  $templateCache.put("static/tpl/question_and_answer_tpl.html",
    "<span\n" +
    "  ng-if=\"question\"\n" +
    "  class=\"pull-right\"\n" +
    "  practice-setting\n" +
    "  category-id=\"categoryId\"\n" +
    "  category2-id=\"category2Id\" >\n" +
    "</span>\n" +
    "<span ng-bind-html=\"question | questionText\"></span>\n" +
    "<span ng-if=\"wrongAnswers.length\">\n" +
    "  <span>{{'Kromě' | translate }}</span>\n" +
    "  <span class=\"label label-default\" ng-repeat=\"wrongAnswer in wrongAnswers\">\n" +
    "     {{wrongAnswer[question.question_type == 't2ts' ?\n" +
    "       'term_secondary' : 'term'].name | stripAlternatives}}\n" +
    "  </span>\n" +
    "</span>\n" +
    "<span ng-show=\"(question|isFindOnMapType) ||\n" +
    "        (question.responseTime && \n" +
    "        !question.options.length &&\n" +
    "        !question.isCorrect)\">\n" +
    "  <span ng-show=\"question.responseTime && \n" +
    "        !question.options.length &&\n" +
    "        !question.isCorrect\">\n" +
    "    {{'Správná odpověď' | translate }}</span>\n" +
    "  <span class=\"label label-default\"\n" +
    "    tooltip-html-unsafe=\"{{question[question.question_type == 't2ts' ? 'term_secondary' : 'term'].name | alternativeNames}}\"\n" +
    "    tooltip-placement=\"bottom\">\n" +
    "  {{question[question.question_type == 't2ts' ? 'term_secondary' : 'term'].name | stripAlternatives}}\n" +
    "  </span>\n" +
    "</span>\n" +
    "<span ng-if=\"question.answered_code &&\n" +
    "    !question.options.length &&\n" +
    "    (question|isFindOnMapType) &&\n" +
    "    !question.isCorrect\">\n" +
    "  <span>{{'Vybráno' | translate }}</span>\n" +
    "  <span class=\"label label-default\">\n" +
    "     {{getFlashcardByDescription(question.answered_code).term.name  | stripAlternatives}}\n" +
    "  </span>\n" +
    "</span>\n" +
    "<div class=\"clearfix\"></div>\n" +
    "");
  $templateCache.put("static/tpl/relations.html",
    "<div class=\"container-fluid\">\n" +
    "    <div class=\"row header\">\n" +
    "        <div class=\"col-sm-12 col-md-10 col-md-offset-1\">\n" +
    "            <h1>\n" +
    "                <span>{{user ? user + ' - ' : ''}}</span>\n" +
    "                <span>{{category.name}}</span>\n" +
    "                <span>{{subcategory ? ' - ' + subcategory.name : ''}}</span>\n" +
    "            </h1>\n" +
    "            <div>\n" +
    "              <button class=\"btn btn-default btn-lg pull-right btn-share show hidden-xs\"\n" +
    "                track-click=\"share overview\"\n" +
    "                ng-disabled=\"disabled\"\n" +
    "                share-url=\"{{$location.absUrl() + userService.user.username}}\"\n" +
    "                share-title=\"{{'Pochlub se svými znalostmi' | translate}}\"\n" +
    "                share-demo-title=\"{{'Co uvidí na sdílené stránce ostatní?' | translate}}\"\n" +
    "                share-button>\n" +
    "                  <i class=\"glyphicon glyphicon-share\"></i>\n" +
    "                  <span translate>Sdílet</span>\n" +
    "              </button>\n" +
    "              <div class=\"clearfix\"></div>\n" +
    "            </div>\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"col-sm-6\" ng-if=\"!user\">\n" +
    "                  <button class=\"btn btn-default btn-lg pull-right btn-share show visible-xs-block\"\n" +
    "                      track-click=\"share overview\"\n" +
    "                      share-url=\"{{$location.absUrl() + userService.user.username}}\"\n" +
    "                      share-title=\"{{'Pochlub se svými znalostmi' | translate}}\"\n" +
    "                      share-demo-title=\"{{'Co uvidí na sdílené stránce ostatní?' | translate}}\"\n" +
    "                      share-button>\n" +
    "                      <i class=\"glyphicon glyphicon-share\"></i>\n" +
    "                      <span translate>Sdílet</span>\n" +
    "                  </button>\n" +
    "                    <a href=\"/practice/{{category.identifier}}/{{subcategory.identifier}}/\"\n" +
    "                        class=\"btn btn-default btn-lg\"\n" +
    "                        track-click=\"view practice\" >\n" +
    "                        <i class=\"glyphicon glyphicon-play\"></i>\n" +
    "                        <span translate>\n" +
    "                            Procvičovat kapitolu\n" +
    "                        </span>\n" +
    "                    </a>\n" +
    "                    <span class=\"dropdown\" style=\"display: inline-block\">\n" +
    "                        <button type=\"button\"\n" +
    "                            class=\"btn btn-default btn-lg dropdown-toggle practice-dropdown\"\n" +
    "                            data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"\n" +
    "                            ng-click=\"usePracticeDwopdown()\">\n" +
    "                            {{\"Procvičovat podkapitolu\" | translate}}\n" +
    "                            <span class=\"caret\"></span>\n" +
    "                        </button>\n" +
    "                        <ul class=\"dropdown-menu pull-right\">\n" +
    "                            <li ng-repeat=\"sc in subcategories\"\n" +
    "                            ng-if=\"sc.stats.number_of_items &gt; 9\">\n" +
    "                            <a href=\"/practice/{{subcategory.identifier}}/{{sc.identifier}}\"\n" +
    "                                track-click=\"view dropdown practice\" >\n" +
    "                                {{subcategory.name}} - {{sc.name}}\n" +
    "                            </a>\n" +
    "                            </li>\n" +
    "                        </ul>\n" +
    "                    </span>\n" +
    "                    <br>\n" +
    "                </div>\n" +
    "                <div class=\"col-sm-6\" ng-class=\"{'col-sm-offset-3' : user}\">\n" +
    "                    <div category-progress skills=\"stats\"></div>\n" +
    "                    <br>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"table table-striped col-sm-12 relations-table\" infinite-scroll=\"addRows()\" infinite-scroll-distance=\"3\">\n" +
    "    <br>\n" +
    "    <div class=\"row table-row fade-in-one-by-one {{activeRelation == relation && 'active'}}\" id=\"{{relation.primaryTerm.identifier}}\" ng-repeat=\"relation in relations | limitTo : rowsLimit\">\n" +
    "        <div class=\"col-md-5 col-md-offset-1 col-sm-6 table-open\" ng-click=\"activateRelation(relation)\">\n" +
    "            <h3 class=\"relation-list-title\">\n" +
    "                <i ng-if=\"activeRelation!=relation && !user\" class=\"glyphicon glyphicon-chevron-down\" ></i>\n" +
    "                <i ng-if=\"activeRelation==relation && !user\" class=\"glyphicon glyphicon-chevron-up\" ></i>\n" +
    "                {{relation.primaryTerm.name}}\n" +
    "            </h3>\n" +
    "        </div>\n" +
    "        <div class=\"col-md-5 col-sm-6 table-open\" ng-click=\"activateRelation(relation)\" >\n" +
    "            <div category-progress skills=\"relation.stats\" hide-labels=\"activeRelation != relation\"></div>\n" +
    "        </div>\n" +
    "        <div class=\"clearfix\"></div>\n" +
    "        <div ng-if=\"activeRelation==relation\" class=\"table relations-table-zoom\">\n" +
    "            <div class=\"relation-row\" ng-repeat=\"c in subcategories\"\n" +
    "                  ng-if=\"relation[c.identifier]\">\n" +
    "                <div class=\"col-md-2 col-md-offset-1 col-sm-3\">\n" +
    "                    <strong ng-bind=\"c.name\" />\n" +
    "                </div>\n" +
    "                <div class=\"col-md-8 col-sm-9\">\n" +
    "                    <div term-label\n" +
    "                        ng-repeat=\"flashcard in relation[c.identifier]\"\n" +
    "                        ng-bind=\"flashcard.term.name | stripAlternatives\" >\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div ng-hide=\"(relations) || error\" class=\"loading-indicator\"></div>\n" +
    "</div>\n" +
    "");
  $templateCache.put("static/tpl/relations_modal.html",
    "<div class=\"modal-header text-center\" track-show=\"relations modal\">\n" +
    "  <button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n" +
    "  <h3 class=\"modal-title\">{{ \"Procvičuj anatomické souvislosti\" | translate }}</h3>\n" +
    "  <div class=\"text-center\">\n" +
    "  {{\"Pospojuj si vědomosti o svalech - začátek a úpon, funkce a antagonisty, inervaci a cévní zásobení.\" | translate }}\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div class=\"modal-body\">\n" +
    "  <a href=\"/practice/relations/demo/?config=intro\"\n" +
    "    track-click=\"relations modal image\"\n" +
    "    ng-click=\"$close()\">\n" +
    "    <img src=\"/static/img/thumb/premium-{{LANGUAGE_CODE}}.png\" />\n" +
    "  </a>\n" +
    "</div>\n" +
    "<div class=\"modal-footer\">\n" +
    "  <a href=\"/practice/relations/demo/?config=intro\"\n" +
    "    ng-click=\"$close()\"\n" +
    "    track-click=\"relations modal practice\"\n" +
    "    class=\"btn btn-primary btn-lg\" translate>Vyzkoušet zdarma</a>\n" +
    "  <a href=\"/premium/\" class=\"btn btn-default btn-lg\"\n" +
    "    track-click=\"relations modal premium\"\n" +
    "    ng-click=\"$close()\" translate>\n" +
    "    Zjistit více o předplatném</a>\n" +
    "</div>\n" +
    "\n" +
    "");
  $templateCache.put("static/tpl/selected_practice_button.html",
    "<div class=\"btn-group\" role=\"group\">\n" +
    "  <span style=\"display: inline-block\"\n" +
    "    tooltip-placement=\"bottom\"\n" +
    "    tooltip-html-unsafe=\"{{categories | getSelectedCategoriesText}}\">\n" +
    "    <a href=\"/practice/{{categories | getSelectedIdentifiers : defaultTab}}/{{categories | getSelectedIdentifiers : secondTab}}\" \n" +
    "      class=\"btn btn-default btn-lg\" \n" +
    "      ng-class=\"{'btn-primary' : (categories | getSelectedCategories).length != 0}\"\n" +
    "      ng-disabled=\"(categories | getSelectedCategories).length == 0\"\n" +
    "      ng-click=\"saveSelectedCategoriesToCookie()\"\n" +
    "      track-click=\"overview practice\" >\n" +
    "      <span translate>\n" +
    "        Procvičovat vybrané\n" +
    "      </span>\n" +
    "      <span class=\"ng-cloak\">\n" +
    "        ({{(categories | getSelectedCategories : defaultTab).length}},\n" +
    "         {{(categories | getSelectedCategories : secondTab).length}})\n" +
    "      </span>\n" +
    "    </a>\n" +
    "  </span>\n" +
    "  <div style=\"display: inline-block\" class=\"dropdown\">\n" +
    "    <button type=\"button\"\n" +
    "      ng-disabled=\"disabled\"\n" +
    "      ng-class=\"{'btn-primary' : (categories | getSelectedCategories).length != 0}\"\n" +
    "      class=\"btn btn-default btn-lg dropdown-toggle practice-dropdown\"\n" +
    "      data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"\n" +
    "      >\n" +
    "      <span class=\"caret\"></span>\n" +
    "    </button>\n" +
    "    <ul class=\"dropdown-menu pull-right\">\n" +
    "      <li>\n" +
    "        <a href=\"\" translate\n" +
    "          ng-click=\"toggleSelectedCategories(true)\"\n" +
    "          >Vybrat všechno</a>\n" +
    "      </li>\n" +
    "      <li>\n" +
    "        <a href=\"\" translate\n" +
    "          ng-click=\"toggleSelectedCategories(false)\"\n" +
    "          >Zrušit výběr</a>\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "  </div>\n" +
    "</div>\n" +
    "\n" +
    "");
  $templateCache.put("static/tpl/settings.html",
    "<div>\n" +
    "  <br>\n" +
    "  <div class=\"col-sm-offset-2 col-sm-8\">\n" +
    "    <div class=\"panel panel-default\">\n" +
    "      <div class=\"panel-heading\">\n" +
    "        <h1 class=\"text-center\" translate>Nastavení</h1>\n" +
    "      </div>\n" +
    "      <div class=\"panel-body\">\n" +
    "        <form ng-submit=\"save()\">\n" +
    "          <div class=\"alert alert-danger\" ng-if=\"!user.profile.subscribed\">\n" +
    "            <span translate>Toto nastavení mohou měnit jen uživatelé s předplatným.</span>\n" +
    "            <a class=\"btn btn-default\" href=\"/premium/\" translate>Zjistit více</a>\n" +
    "          </div>\n" +
    "          <div class=\"form-group\">\n" +
    "            <label for=\"targetDifficulty\"\n" +
    "              class=\" control-label\" translate>Obtížnost otázek</label>\n" +
    "            <div class=\"\">\n" +
    "              <label class=\"radio-inline\">\n" +
    "                <input type=\"radio\" name=\"targetDifficulty\"\n" +
    "                  ng-disabled=\"!user.profile.subscribed\"\n" +
    "                  ng-value=\"95\" ng-model=\"form.targetDifficulty\">\n" +
    "                <span translate>Extra jednoduché</span>\n" +
    "              </label>\n" +
    "              <label class=\"radio-inline\">\n" +
    "                <input type=\"radio\" name=\"targetDifficulty\"\n" +
    "                  ng-disabled=\"!user.profile.subscribed\"\n" +
    "                  ng-value=\"80\" ng-model=\"form.targetDifficulty\">\n" +
    "                <span translate>Jednoduché</span>\n" +
    "              </label>\n" +
    "              <label class=\"radio-inline\">\n" +
    "                <input type=\"radio\" name=\"targetDifficulty\"\n" +
    "                  ng-disabled=\"!user.profile.subscribed\"\n" +
    "                  ng-value=\"65\" ng-model=\"form.targetDifficulty\">\n" +
    "                <span translate>Výchozí</span>\n" +
    "              </label>\n" +
    "              <label class=\"radio-inline\">\n" +
    "                <input type=\"radio\" name=\"targetDifficulty\"\n" +
    "                  ng-disabled=\"!user.profile.subscribed\"\n" +
    "                  ng-value=\"50\" ng-model=\"form.targetDifficulty\">\n" +
    "                <span translate>Těžké</span>\n" +
    "              </label>\n" +
    "              <label class=\"radio-inline\">\n" +
    "                <input type=\"radio\" name=\"targetDifficulty\"\n" +
    "                  ng-disabled=\"!user.profile.subscribed\"\n" +
    "                  ng-value=\"35\" ng-model=\"form.targetDifficulty\">\n" +
    "                <span translate>Extra těžké</span>\n" +
    "              </label>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "          <div class=\"form-group\">\n" +
    "            <label for=\"questionType\"\n" +
    "              class=\"control-label\" translate>Typ otázek</label>\n" +
    "            <div class=\"\">\n" +
    "              <label class=\"radio-inline\">\n" +
    "                <input type=\"radio\" name=\"questionType\" ng-disabled=\"!user.profile.subscribed\"\n" +
    "                  value=\"all\" ng-model=\"form.questionType\">\n" +
    "                <span translate>Všechny typy</span>\n" +
    "              </label>\n" +
    "              <label class=\"radio-inline\">\n" +
    "                <input type=\"radio\" name=\"questionType\" ng-disabled=\"!user.profile.subscribed\"\n" +
    "                  value=\"no-write\" ng-model=\"form.questionType\">\n" +
    "                <span translate>Bez psaní</span>\n" +
    "              </label>\n" +
    "              <label class=\"radio-inline\">\n" +
    "                <input type=\"radio\" name=\"questionType\" ng-disabled=\"!user.profile.subscribed\"\n" +
    "                  value=\"options-only\" ng-model=\"form.questionType\">\n" +
    "                <span translate>Výběr z možností</span>\n" +
    "              </label>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "          <div class=\"form-group\">\n" +
    "            <label for=\"setLength\"\n" +
    "              class=\" control-label\" translate>Délka sady</label>\n" +
    "            <div class=\"\">\n" +
    "              <label class=\"radio-inline\">\n" +
    "                <input type=\"radio\" name=\"setLength\" ng-value=\"5\"\n" +
    "                  ng-disabled=\"!user.profile.subscribed\"\n" +
    "                  ng-model=\"form.setLength\"> 5\n" +
    "              </label>\n" +
    "              <label class=\"radio-inline\">\n" +
    "                <input type=\"radio\" name=\"setLength\" ng-value=\"10\"\n" +
    "                  ng-disabled=\"!user.profile.subscribed\"\n" +
    "                  ng-model=\"form.setLength\"> 10\n" +
    "              </label>\n" +
    "              <label class=\"radio-inline\">\n" +
    "                <input type=\"radio\" name=\"setLength\" ng-value=\"20\"\n" +
    "                  ng-disabled=\"!user.profile.subscribed\"\n" +
    "                  ng-model=\"form.setLength\"> 20\n" +
    "              </label>\n" +
    "              <label class=\"radio-inline\">\n" +
    "                <input type=\"radio\" name=\"setLength\" ng-value=\"30\"\n" +
    "                  ng-disabled=\"!user.profile.subscribed\"\n" +
    "                  ng-model=\"form.setLength\"> 30\n" +
    "              </label>\n" +
    "              <label class=\"radio-inline\">\n" +
    "                <input type=\"radio\" name=\"setLength\" ng-value=\"50\"\n" +
    "                  ng-disabled=\"!user.profile.subscribed\"\n" +
    "                  ng-model=\"form.setLength\"> 50\n" +
    "              </label>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "          <div class=\"alert alert-{{messageType}}\" ng-if=\"message\" ng-bind=\"message\">\n" +
    "          </div>\n" +
    "          <div class=\"form-group\">\n" +
    "            <div class=\"pull-right\">\n" +
    "              <button type=\"submit\" class=\"btn btn-default\"\n" +
    "                ng-disabled=\"!user.profile.subscribed\"\n" +
    "                translate>Uložit</button>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div class=\"clearfix\"></div>\n" +
    "");
  $templateCache.put("static/tpl/share-modal.html",
    "<div class=\"modal-header text-center\">\n" +
    "  <button type=\"button\" class=\"close\" ng-click=\"cancel()\">\n" +
    "      <span aria-hidden=\"true\">&times;</span>\n" +
    "  </button>\n" +
    "  <h3 class=\"modal-title\" ng-bind=\"title\"></h3>\n" +
    "</div>\n" +
    "<div class=\"modal-body\">\n" +
    "  <div class=\"text-center\">\n" +
    "    <button\n" +
    "        track-click=\"share facebook\"\n" +
    "        ng-click=\"openSharePage('facebook')\"\n" +
    "        class=\"btn btn-lg btn-primary\"\n" +
    "       ><i class=\"social-facebook\"></i> Facebook</button>\n" +
    "    <button\n" +
    "        track-click=\"share twitter\"\n" +
    "        ng-click=\"openSharePage('twitter')\"\n" +
    "        class=\"btn btn-lg btn-info\"\n" +
    "      ><i class=\"social-twitter\"></i> Twitter</button>\n" +
    "    <button\n" +
    "        track-click=\"share google\"\n" +
    "        ng-click=\"openSharePage('google')\"\n" +
    "        class=\"btn btn-lg btn-danger\"\n" +
    "      ><i class=\"social-google\"></i> Google+</button>\n" +
    "    <input class=\"form-control share-input\" value=\"{{url}}\"/>\n" +
    "    <a track-click=\"share demo\"\n" +
    "        ng-click=\"openSharePage('demo')\"\n" +
    "        class=\"btn btn-lg btn-link\" translate\n" +
    "        ng-bind=\"demoTitle\"></a>\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div class=\"modal-footer\" >\n" +
    "\n" +
    "</div>\n" +
    "");
  $templateCache.put("static/tpl/sign_in_banner.html",
    "<div class=\"beta-alert text-center alert alert-info\"\n" +
    "  ng-if=\"!userService.status.logged && !userService.status.loading && userService.user.profile.number_of_answers >= 20\">\n" +
    "  <button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-label=\"Close\"\n" +
    "      variation=\"0\"\n" +
    "      track-click=\"close login banner\">\n" +
    "    <span aria-hidden=\"true\">&times;</span>\n" +
    "    <span class=\"sr-only\" translate>Zavřít</span>\n" +
    "  </button>\n" +
    "  <span translate>\n" +
    "  Již máš odpovězených <b>{{userService.user.profile.number_of_answers}}</b>\n" +
    "  odpovědí. Ulož si svůj postup, aby aplikace mohla dlouhodobě přizpůsobovat otázky Tvým znalostem.\n" +
    "  </span>\n" +
    "  <a href=\"\"\n" +
    "     class=\"btn btn-primary\"\n" +
    "     track-click=\"login banner\"\n" +
    "     translate\n" +
    "     ng-click=\"openSignupModal()\"\n" +
    "    >Registrovat se</a>\n" +
    "</div>\n" +
    "");
  $templateCache.put("static/tpl/subscription_plans.html",
    "<div id='plans' class=\"flatblock block-welcome_page col-lg-offset-2 col-lg-8 col-sm-12\">\n" +
    "    <h2 class=\"text-center\" translate>Typy předplatného</h2>\n" +
    "    <form ng-if=\"!discountCode || error\" class=\"form-inline text-center\">\n" +
    "        <label translate>Slevový kód: </label>\n" +
    "        <div class=\"input-group\">\n" +
    "          <input class=\"form-control\" ng-model=\"discountCodeInput\">\n" +
    "          <span class=\"input-group-btn\">\n" +
    "            <a class=\"btn btn-default\"\n" +
    "                href=\"/premium/?discount_code={{discountCodeInput}}\"\n" +
    "                translate>Uplatnit</a>\n" +
    "            <a class=\"btn btn-default\"\n" +
    "                ng-if=\"discountCode\"\n" +
    "                href=\"/premium/\"\n" +
    "                translate>Bez kódu</a>\n" +
    "          </span>\n" +
    "        </div>\n" +
    "        <br>\n" +
    "        <br>\n" +
    "    </form>\n" +
    "    <div class=\"alert alert-info col-sm-12\" ng-if=\"discountCode && !error\">\n" +
    "      <span translate>\n" +
    "        Uvedené ceny jsou po uplatnění slevového kódu '{{discountCode}}'.\n" +
    "      </span>\n" +
    "      <span ng-if=\"discountCodeUsage\" translate>\n" +
    "        Kód již využilo {{discountCodeUsage.usage}} uživatelů.\n" +
    "        Zbývá <strong>{{discountCodeUsage.usage_left}}</strong> použití.\n" +
    "      </span>\n" +
    "    </div>\n" +
    "    <div class=\"alert alert-danger col-sm-12\" ng-if=\"error\"\n" +
    "      ng-bind=\"error\">\n" +
    "    </div>\n" +
    "    <div class=\"clearfix\"></div>\n" +
    "    <div class=\"flatblock-content row\">\n" +
    "        <div ng-hide=\"plans.length || error\" class=\"loading-indicator\"></div>\n" +
    "        <div class=\"col-sm-4\" ng-repeat=\"plan in plans\">\n" +
    "            <div ng-class=\"{featured: plan.featured}\" class=\"panel panel-default\">\n" +
    "                <div class=\"panel-heading\">\n" +
    "                    <h3 class=\"text-center\">{{plan.description.name}}</h3>\n" +
    "                </div>\n" +
    "                <div class=\"panel-body\">\n" +
    "                    <h3 ng-class=\"{'discount': plan.description.price_after_discount !== undefined}\">\n" +
    "                        <span class=\"price\" >\n" +
    "                            {{plan.description.price / 100 | number}}</span>\n" +
    "                        {{plan.description.currency | currencySymbol}}\n" +
    "                    </h3>\n" +
    "                    <h3 ng-if=\"plan.description.price_after_discount !== undefined\">\n" +
    "                        <span class=\"price\" >\n" +
    "                            {{plan.description.price_after_discount / 100 | number}}\n" +
    "                        </span>\n" +
    "                        {{plan.description.currency | currencySymbol}}\n" +
    "                    </h3>\n" +
    "                    <p class=\"plan-description\">{{plan.description.description}}</p>\n" +
    "                    <a class=\"btn btn-lg pull-right\"\n" +
    "                        ng-click=\"buyPlan(plan)\"\n" +
    "                        track-click=\"{{isSubscribed() ? 'buy' : 'login'}} plan\"\n" +
    "                        track-label=\"{{plan.description.name}}\"\n" +
    "                        track-value=\"{{isSubscribed() ?\n" +
    "                          (plan.description.price_after_discount ||\n" +
    "                            plan.description.price) / 100 :\n" +
    "                          1}}\"\n" +
    "                        ng-class=\"plan.featured ? 'btn-primary' : 'btn-default'\"\n" +
    "                        translate>\n" +
    "                        Koupit teď\n" +
    "                    </a>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"col-sm-12\">\n" +
    "            <div class=\"panel panel-default text-center\">\n" +
    "                <div class=\"panel-body payment-icons\">\n" +
    "                    <img src=\"/static/img/gopay/gopay_bannery-barevne.png\"/>\n" +
    "                    <img src=\"/static/img/gopay/verified-by-visa.png\"/>\n" +
    "                    <img src=\"/static/img/gopay/master-card-secude-code.png\"/>\n" +
    "                    <img src=\"/static/img/gopay/visa.png\"/>\n" +
    "                    <img src=\"/static/img/gopay/visa-electron.png\"/>\n" +
    "                    <img src=\"/static/img/gopay/master-card.png\"/>\n" +
    "                    <img src=\"/static/img/gopay/master-card-electronic.png\"/>\n" +
    "                    <img src=\"/static/img/gopay/maestro.png\"/>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <br>\n" +
    "        <br>\n" +
    "        <br>\n" +
    "        <br>\n" +
    "        <br>\n" +
    "    </div>\n" +
    "\n" +
    "");
  $templateCache.put("static/tpl/summary_tpl.html",
    "<div class=\"inner-practice summary row\">\n" +
    "  <div class=\"col-sm-12\">\n" +
    "    <div class=\"summary-progress progress\" ng-show=\"summary != undefined\">\n" +
    "      <div class=\"progress-bar progress-bar-learned\" \n" +
    "           style=\"width: {{summary.correctlyAnsweredRatio | percent }};\">\n" +
    "        <span>{{'Úspěšnost' | translate}}: {{summary.correctlyAnsweredRatio | percent }}</span>\n" +
    "      </div>\n" +
    "      <div class=\"progress-bar progress-bar-unlearned\" \n" +
    "           style=\"width: {{(1 - summary.correctlyAnsweredRatio) | percent }};\">\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <span ng-repeat=\"q in summary.questions\" \n" +
    "          track-click=\"practice summary change image\"\n" +
    "          ng-click=\"controller.highlightFlashcard(q.payload)\"\n" +
    "          class=\"label label-clickable \n" +
    "            {{q.payload.isCorrect ? 'label-learned' : 'label-unlearned' }} \">\n" +
    "       {{q.payload.term.name | stripAlternatives}}\n" +
    "    </span>\n" +
    "     <i class=\"glyphicon glyphicon-question-sign help-icon\"\n" +
    "        popover-trigger=\"mouseenter\"\n" +
    "        popover-placement=\"bottom\"\n" +
    "        popover-append-to-body=\"true\"\n" +
    "        popover-title=\"{{'Tip k ovládání' | translate}}\"\n" +
    "        popover=\"{{'Pomocí názvů dotázaných pojmů můžeš přepínat mezi obrázky k jednotlivým odpovědím.' | translate}}\"\n" +
    "        track-hover=\"summary labels explanation\">\n" +
    "     </i>\n" +
    "  </div>\n" +
    "  <h2 class=\"clearfix\" ng-show=\"errorMessage != undefined\" ng-bind=\"errorMessage\"></h2>\n" +
    "  <br>\n" +
    "  <div class=\"col-sm-12\" ng-if=\"intro\">\n" +
    "    <br>\n" +
    "    <a class=\"btn-continue btn btn-lg btn-primary\" \n" +
    "       href=\"/premium/\"\n" +
    "       track-click=\"demo set premium\" >\n" +
    "      <i class=\"glyphicon glyphicon-arrow-right\"></i> {{'Vybrat předplatné' | translate }}\n" +
    "    </a>\n" +
    "  </div>\n" +
    "  <div class=\"col-sm-12\" ng-if=\"!intro\">\n" +
    "    <br>\n" +
    "    <a class=\"btn-continue btn btn-lg btn-primary\" \n" +
    "       href=\"/refreshpractice/{{categoryId}}/{{category2Id}}\"\n" +
    "       track-click=\"repeat practice\" >\n" +
    "      <i class=\"glyphicon glyphicon-arrow-right\"></i> {{'Pokračovat v procvičování' | translate }}\n" +
    "    </a>\n" +
    "    <a class=\"btn btn-lg btn-default\" \n" +
    "       ng-if=\"categoryId && categoryId.indexOf('-') == -1\"\n" +
    "       href=\"/view/{{categoryId}}/\" >\n" +
    "      <i class=\"glyphicon glyphicon-picture\"></i> {{'Přehled znalostí' | translate }}\n" +
    "    </a>\n" +
    "    <a class=\"btn btn-lg btn-default\" \n" +
    "       href=\"/overview/\" >\n" +
    "      <i class=\"glyphicon glyphicon-th\"></i> {{'Vybrat kapitolu' | translate }}\n" +
    "    </a>\n" +
    "    <a feedback-comment class=\"btn btn-lg btn-default report-error\" email=\"{{userService.user.email}}\"\n" +
    "        href=\"\">\n" +
    "        <i class=\"glyphicon glyphicon-new-window\"></i>\n" +
    "      {{'Přijde Ti aplikace užitečná? Co bys vylepšil?' | translate }}\n" +
    "    </a>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
  $templateCache.put("static/tpl/terms_of_use_cs.html",
    "<br>\n" +
    "<div class=\"terms-of-use row\">\n" +
    "  <div class=\"col-sm-offset-2 col-sm-8\">\n" +
    "    <div class=\"panel panel-default\">\n" +
    "      <div class=\"panel-heading\">\n" +
    "        <h1>Podmínky použití služby Anatom.cz</h1>\n" +
    "      </div>\n" +
    "      <div class=\"panel-body\">\n" +
    "<p>Platné od 22.10.2016</p>\n" +
    "\n" +
    "<p>Dobrý den, vítejte v našich podmínkách použití. Tyto podmínky jsou důležité a mají vliv na vaše zákonná práva, proto si je pozorně přečtěte spolu se Zásadami ochrany osobních údajů a dalšími podmínkami, na které tento dokument odkazuje.</p>\n" +
    "\n" +
    "<h2>1 Úvod</h2>\n" +
    "<p>Děkujeme, že jste si vybrali službu Anatom.cz (PracticeAnatomy.com), dále v textu označovanou slovy „Anatom“, „Practice Anatomy“, „my“, „nás“, „naše“. Registrací nebo jiným použitím služby nebo přístupem k jakémukoli obsahu nebo materiálu, který je k dispozici prostřednictvím služby (dále „Obsah“) uzavíráte závaznou smlouvu se subjektem Marek Čierny uvedeným na konci tohoto dokumentu (dále jen “naše společnost”).</p>\n" +
    "\n" +
    "<p>Vaše dohoda s naší společností zahrnuje tyto Podmínky použití (dále „Podmínky“) a naše Zásady ochrany osobních údajů. (Podmínky, zásady ochrany osobních údajů a jakékoli dodatečné podmínky, se kterými budete souhlasit, jsou souhrnně označovány jako „Dohody“, jak je to popsáno v části Celá dohoda.) Pokud si chcete přečíst podmínky Dohod, platnou verzi Dohod naleznete na webu služby Anatom. Potvrzujete, že jste si přečetli Dohody, rozumíte jim, přijímáte je a zavazujete se k jejich dodržování. Pokud nesouhlasíte s Dohodami nebo je nemůžete dodržet, nesmíte používat službu Anatom ani používat žádný Obsah.</p>\n" +
    "\n" +
    "<p>Dohody si pozorně přečtěte. Obsahují důležité informace o službě Anatom, která vám bude poskytována, a všech poplatcích, daních a platbách, které vám budeme účtovat. Dohody zahrnují informace o budoucích změnách Dohod (2), automatických obnoveních (3.3), omezení zodpovědnosti (13) a informacích o ochraně osobních údajů.</p>\n" +
    "\n" +
    "<p>Pokud chcete používat službu Anatom a přistupovat k Obsahu, musíte (1) být starší 18 let nebo získat souhlas rodiče nebo poručníka s Dohodami, (2) mít oprávnění uzavírat závazné smlouvy s naší společností podle všech příslušných zákonů a (3) mít pobyt v zemi, ve které je Služba k dispozici. Také prohlašujete, že všechny registrační informace, které jste odeslali naší společnosti, jsou pravdivé, přesné a úplné, a zavazujete se je takové udržovat.</p>\n" +
    "\n" +
    "<h2>2 Změny Dohod</h2>\n" +
    "<p>Příležitostně můžeme podle svého uvážení provést změny těchto Dohod. Pokud provedeme zásadní změny Dohod, okamžitě vás upozorníme způsobem přiměřeným okolnostem, například zobrazením výrazného upozornění ve Službě nebo odesláním e-mailu s upozorněním. V některých případech vás upozorníme předem. V takovém případě bude vaše další používání Služby i po provedení změn představovat váš souhlas se změnami. Proto si pozorně přečtěte jakékoli takové upozornění. Pokud nechcete pokračovat v používání Služby na základě nové verze Dohod, můžete tyto Dohody odmítnout kontaktováním naší společnosti.</p>\n" +
    "\n" +
    "<h2>3 Používání služby</h2>\n" +
    "<h3>3.1 Naše služby a placené odběry</h3>\n" +
    "<p>Poskytujeme službu procvičování a prohlížení výukového a jiného obsahu. Při plnění výukového cíle aplikace mohou některé obrázky detailně zobrazovat intimní části lidského těla: pokud Vám je méně než 18 let, poraďte se před použitím aplikace s rodiči. Některé služby společnosti jsou poskytovány bezplatně. Jiné služby vyžadují platbu, než k nim budete moci přistupovat. Služby, ke kterým lze přistupovat po platbě, jsou momentálně označovány jako „prémiová služba“, “prémiový obsah” a „neomezená služba“ (souhrnně „placené odběry“). Služba, která nevyžaduje platbu, je momentálně označována jako „bezplatná služba“. Další informace o našich službách můžete získat návštěvou našeho webu.</p>\n" +
    "\n" +
    "<p>Neomezená služba nemusí být k dispozici pro všechny uživatele. Při registraci do služby vás informujeme o službách, které jsou pro vás dostupné. Pokud zrušíte svůj odběr neomezené služby, nebo pokud dojde k přerušení vašeho odběru neomezené služby (například se změní vaše platební informace), nemusíte mít možnost znovu obnovit svůj odběr neomezené služby. Upozorňujeme, že v budoucnu může dojít k ukončení poskytování neomezené služby. V takovém případě vám za tuto Službu již nebudeme účtovat poplatky.</p>\n" +
    "<h3>3.2 Kódy a jiné předplacené nabídky</h3>\n" +
    "<p>Pokud jste si zakoupili nebo jste dostali kód, dárkovou kartu, předplacenou nabídku nebo jinou nabídku poskytovanou nebo prodávanou naší společností nebo v jejím jméně týkající se přístupu k placenému odběru (dále „kód“), mohou se na přístup ke Službě vztahovat samostatné podmínky, které vám byly poskytnuty společně s kódem. Souhlasíte, že budete tyto podmínky dodržovat. Nemožnost uplatnit takový kód z důvodu nedostupnosti obsahu nemůže být důvodem vymáhání škody či ztraceného zisku. </p>\n" +
    "<h3>3.3 Zkušební období</h3>\n" +
    "<p>Z času na čas může naše společnost nebo jiná společnost v našem jméně nabízet zkušební období placeného odběru na určité časové období bez nutnosti platby nebo se sníženou sazbou (dále „zkušební období“). Naše společnost si vyhrazuje právo na základě svého výhradního uvážení posoudit vaši vhodnost pro získání zkušebního období a (v souladu s příslušnými zákony) kdykoli stáhnout nebo upravit nabídku zkušebního období bez předchozího upozornění a bez jakékoli odpovědnosti v největším rozsahu povoleném zákonem.</p>\n" +
    "\n" +
    "<p>V případě některých zkušebních období budeme požadovat poskytnutí vašich platebních informací, než bude zahájeno zkušební období. NA KONCI TAKOVÝCH ZKUŠEBNÍCH OBDOBÍ VÁM MŮŽEME ZAČÍT AUTOMATICKY ÚČTOVAT PRAVIDELNÉ MĚSÍČNÍ POPLATKY ZA PŘÍSLUŠNÝ PLACENÝ ODBĚR POČÍNAJE PRVNÍM DNEM PO UKONČENÍ ZKUŠEBNÍHO OBDOBÍ. POSKYTNUTÍM SVÝCH PLATEBNÍCH INFORMACÍ V SOUVISLOSTI SE ZKUŠEBNÍM OBDOBÍM SOUHLASÍTE S TÍMTO POPLATKEM POMOCÍ PŘÍSLUŠNÝCH PLATEBNÍCH INFORMACÍ. POKUD NECHCETE, ABYCHOM VÁM PRAVIDELNĚ ÚČTOVALI TENTO POPLATEK, MUSÍTE ZRUŠIT PŘÍSLUŠNÝ PLACENÝ ODBĚR PROSTŘEDNICTVÍM STRÁNKY ODBĚRU ÚČTU SLUŽBY ANATOM NEBO ZRUŠIT SVŮJ ÚČET SLUŽBY ANATOM PŘED UKONČENÍM PRAVIDELNÉHO OBDOBÍ. PLACENÉ ODBĚRY NELZE UKONČIT PŘED KONCEM OBDOBÍ, ZA KTERÉ JSTE JIŽ ZAPLATILI, A S VÝJIMKOU PŘÍPADŮ VÝSLOVNĚ POPSANÝCH V TĚCHTO PODMÍNKÁCH NEBUDE NAŠE SPOLEČNOST VRACET ŽÁDNÉ POPLATKY, KTERÉ JSTE JIŽ ZAPLATILI. ČÁST OMEZENÍ UVÁDÍ DODATEČNÉ PODMÍNKY TÝKAJÍCÍ SE ZRUŠENÍ PLACENÉHO ODBĚRU.</p>\n" +
    "<h2>4 Práva, která vám udělujeme</h2>\n" +
    "<p>Služba a Obsah jsou majetkem naší společnosti nebo poskytovatelů licencí naší společnosti. Udělujeme vám omezenou, neexkluzivní, vratnou licenci na použití Služby a omezenou, neexkluzivní, vratnou licenci na osobní, nekomerční a vzdělávací použití Obsahu (dále „Licence“). Tato Licence bude platná, dokud její platnost neukončíte vy nebo naše společnost. Souhlasíte a zavazujete se, že budete Obsah používat pro vlastní osobní, nekomerční, vzdělávací použití, a že nebudete Službu ani Obsah dále poskytovat druhému, distribuovat ani převádět.</p>\n" +
    "\n" +
    "<p>Softwarové aplikace a Obsah vám nejsou prodávány, nýbrž poskytovány na základě licence. Poskytovatelé licence si ponechávají vlastnictví všech kopií softwarových aplikací Služby a Obsahu i po instalaci na vašich osobních počítačích, mobilních telefonech, tabletech nebo dalších relevantních zařízeních (dále „zařízení“). Práva poskytovatelů licencí jste povinni respektovat.</p>\n" +
    "\n" +
    "<p>Všechny ochranné známky, známky služby, obchodní názvy, loga, názvy domén a všechny další prvky značky Anatom (dále „prvky značky Anatom“) jsou výhradně vlastnictvím naší společnosti nebo jejích poskytovatelů licencí. Tyto Dohody vám neposkytují žádná práva týkající se použití prvků značky Anatom, ať už za komerčním nebo nekomerčním účelem.</p>\n" +
    "\n" +
    "<p>Souhlasíte, že budete dodržovat naše Pokyny pro uživatele a nebudete používat Službu, Obsah ani žádnou část této služby či obsahu žádným způsobem, který není výslovně povolen v těchto Dohodách. S výjimkou práv, které jsou vám výslovně uděleny v rámci těchto Dohod, vám naše společnost neuděluje žádná práva, podíl ani zájem týkající se Služby ani Obsahu.</p>\n" +
    "\n" +
    "<p>Software třetích stran (například otevřené softwarové knihovny) zahrnuté ve Službě jsou vám poskytnuty buď na základě licence v rámci Dohod, nebo na základě licenčních podmínek relevantní třetí strany poskytující příslušnou softwarovou knihovnu, které jsou uvedeny v nápovědě nebo v části nastavení našeho klienta pro stolní počítače nebo mobilní zařízení nebo na našem webu.</p>\n" +
    "\n" +
    "<h2>5 Aplikace třetích stran</h2>\n" +
    "<p>Služba je integrovaná s aplikacemi, weby a službami třetích stran (dále „aplikace třetích stran“) za účelem poskytování obsahu, produktů nebo služeb. Tyto aplikace třetích stran mohou mít vlastní podmínky použití a zásady ochrany osobních údajů a vaše použití těchto aplikací třetích stran se bude řídit a bude podléhat příslušným podmínkám použití a zásadám ochrany osobních údajů. Rozumíte a souhlasíte, že naše společnost nedoporučuje ani nenese odpovědnost za chování, funkce ani obsah žádných aplikací třetích stran ani za žádné transakce, které mohou být provedeny mezi vámi a poskytovateli těchto aplikací třetích stran.</p>\n" +
    "<h2>6 Obsah generovaný uživateli</h2>\n" +
    "\n" +
    "<p>Prohlašujete, že co se týče jakéhokoli uživatelského obsahu, který zveřejňujete ve Službě, (1) máte právo ke zveřejnění příslušného uživatelského obsahu, a (2) tento uživatelský obsah nebo jeho použití naší společností v souladu s ustanoveními Dohod neporušuje tyto Dohody, příslušné zákony ani duševní vlastnictví, osobní ani veřejná práva jiných osob.</p>\n" +
    "\n" +
    "<p>Naše společnost může (avšak není povinná) sledovat, kontrolovat nebo upravovat uživatelský obsah. Naše společnost si všech případech vyhrazuje právo odstranit uživatelský obsah nebo k němu zakázat přístup z jakéhokoli nebo žádného důvodu, včetně (avšak nejenom) uživatelského obsahu, který podle výlučného názoru naší společnosti porušuje Dohody. Naše společnost může k těmto krokům přistoupit bez předchozího upozornění vaší osoby nebo jakékoli třetí strany. Odstranění nebo zakázání přístupu k uživatelskému obsahu bude probíhat výlučně na základě našeho uvážení a neslibujeme, že odstraníme jakýkoli konkrétní uživatelský obsah nebo že k němu zakážeme přístup.</p>\n" +
    "\n" +
    "<p>Nesete výhradní odpovědnost za všechen uživatelský obsah, který zveřejníte. Naše společnost není odpovědná za uživatelský obsah ani nedoporučuje žádné názory vyjádřené v příslušném uživatelském obsahu. SOUHLASÍTE, ŽE POKUD NĚKDO VZNESE VŮČI SPOLEČNOSTI NÁROK TÝKAJÍCÍ SE JAKÉHOKOLI UŽIVATELSKÉHO OBSAHU, KTERÝ ZVEŘEJNÍTE, ZBAVÍTE V ROZSAHU POVOLENÉM ZÁKONEM SPOLEČNOST JAKÉKOLI ZODPOVĚDNOSTI TÝKAJÍCÍ SE VŠECH ŠKOD, ZTRÁT A NÁKLADŮ JAKÉHOKOLI DRUHU (VČETNĚ PŘIMĚŘENÝCH NÁKLADŮ NA PRÁVNÍ ZASTOUPENÍ A POPLATKŮ), KTERÉ VYPLÝVAJÍ Z TAKOVÉHO NÁROKU.</p>\n" +
    "\n" +
    "<h2>7 Práva, která nám udělujete</h2>\n" +
    "<p>Výměnou za práva, která vám byla udělena v rámci těchto Dohod, nám udělujete právo (1) umožňující Službě využívat procesor, datové pásmo a úložný hardware na vašem zařízení za účelem umožnění provozu Služby a (2) poskytovat vám reklamy a jiné informace. Jakákoli část Služby či zobrazovaný obsah včetně jeho výběru a umístění mohou být ovlivněny komerčními faktory, včetně dohod s třetími stranami. Určitý obsah licencovaný nebo poskytovaný naší společností může obsahovat reklamu.</p>\n" +
    "\n" +
    "<p>Pokud naší společnosti poskytnete zpětnou vazbu, nápady nebo návrhy týkající se Služby nebo Obsahu (dále „zpětná vazba“), souhlasíte, že tato zpětná vazba není důvěrná a udělujete naší společnosti právo použít tuto zpětnou vazbu bez omezení a bez jakékoli finanční kompenzace vůči vaší osobě. Zpětná vazba je považována za druh uživatelského obsahu.</p>\n" +
    "<p>Udělujete naší společnosti neexkluzivní, přenosnou, dále licencovatelnou, osvobozenou od honoráře, trvalou (nebo, pokud takové trvání není v dané jurisdikci povoleno, trvající po dobu trvání Dohod plus dvacet (20) let), nevratnou, plně vyplacenou, celosvětovou licenci na použití, reprodukci, veřejné zpřístupnění (např. produkci nebo zobrazování), publikaci, překlad, úpravu, vytváření odvozených děl a distribuci jakéhokoli uživatelského obsahu ve spojitosti se Službou prostřednictvím jakéhokoli média, ať už samostatně nebo společně s jiným obsahem nebo materiály, jakýmkoli způsobem a jakýmikoli prostředky, formou nebo technologií, která je v současnosti známá nebo bude v budoucnu vyvinuta. Kromě práv, která v těchto podmínkách výslovně udělujete, si ponecháváte vlastnictví všech práv, včetně práv na duševní vlastnictví, týkajících se uživatelského obsahu.</p>\n" +
    "<h2>8 Pokyny pro uživatele </h2>\n" +
    "<p>Naše Společnost respektuje práva na duševní vlastnictví a očekává, že je budete respektovat i vy. Vytvořili jsme několik základních pravidel, které byste měli při používání Služby dodržovat, abychom se ujistili, že bude služba Anatom nadále příjemným místem pro všechny uživatele. Dodržujte tyto pravidla a podporujte v jejich dodržování i jiné uživatele.</p>\n" +
    "<p>Následující činnosti nejsou povoleny z jakéhokoli důvodu:</p>\n" +
    "<ul>\n" +
    "<li>kopírování, stahování, další distribuce, reprodukce, „ořezávání, nebo zveřejňování jakékoli části služby Anatom nebo obsahu, nebo jakékoli použití služby Anatom nebo obsahu, které není výslovně povoleno podle Dohod nebo příslušného zákona, nebo které jiným způsobem porušuje práva na duševní vlastnictví (například autorská práva) v rámci služby Anatom nebo obsahu nebo jakékoli jejich části,</li>\n" +
    "<li>přenos kopií obsahu uloženého ve vyrovnávací paměti z autorizovaného zařízení do jakéhokoli jiného zařízení jakýmkoli způsobem,</li>\n" +
    "<li>zpětná analýza, dekompilace, rozkládání, úprava nebo vytváření odvozených děl založených na službě Anatom, obsahu nebo jakékoli jejich části, pokud to není povoleno příslušným zákonem,</li>\n" +
    "<li>obcházení jakékoli technologie používané Společností, jejími poskytovateli licencí nebo jakoukoli třetí stranou k ochraně obsahu nebo Služby,</li>\n" +
    "<li>prodej, pronájem, poskytování další licence nebo půjčování jakékoli části služby Anatom nebo obsahu,</li>\n" +
    "<li>odstraňování nebo pozměňování jakýchkoli autorských práv, ochranných značek nebo jiných upozornění týkajících se duševního vlastnictví v rámci služby Anatom nebo poskytovaných jejím prostřednictvím (včetně takového konání za účelem utajení nebo změnění jakýchkoli známek vlastnictví nebo zdroje příslušného obsahu),</li>\n" +
    "<li>poskytnutí vašeho hesla jiné osobě nebo použití uživatelského jména a hesla jiné osoby,</li>\n" +
    "<li>„procházení“ služby nebo použití jiných automatizovaných způsobů (včetně botů a robotů scraper nebo spider) ke shromažďování informací ze služby Anatom, nebo</li>\n" +
    "<li>prodej uživatelského účtu nebo přijetí jakékoli jiné kompenzace finanční či jiné povahy k ovlivnění názvu účtu nebo obsahu zahrnutému v účtu.</li>\n" +
    "</ul>\n" +
    "\n" +
    "<p>Respektujte službu Anatom, majitele obsahu a jiné uživatele služby Anatom. Nepodílejte se na žádné činnosti, nezveřejňujte žádný uživatelský obsah ani neprovádějte registraci ani nepoužívejte uživatelské jméno, které představuje nebo zahrnuje materiál, který:</p>\n" +
    "<ul>\n" +
    "<li>je urážlivý, hanlivý, poškozující dobré jméno, pornografický, výhrůžný nebo obscénní,</li>\n" +
    "<li>je nelegální nebo je jeho účelem podporovat nebo provádět nelegální činnost jakéhokoli druhu, včetně (avšak nejenom) porušení práv na duševní vlastnictví, práv na ochranu osobních údajů nebo vlastnických práv společnosti Anatom nebo třetí strany,</li>\n" +
    "<li>je navržen k zastrašování nebo obtěžování jiných uživatelů nebo jiné uživatele zastrašuje nebo obtěžuje,</li>\n" +
    "<li>klamně naznačuje nebo představuje vaši souvislost s jiným uživatelem, osobou nebo subjektem, nebo je jiným způsobem podvodný, nepravdivý, klamný nebo zavádějící,</li>\n" +
    "<li>používá automatické prostředky k umělé propagaci obsahu,</li>\n" +
    "<li>zahrnuje přenos nevyžádané hromadné komunikace nebo jiných forem spamu (dále „spam“), reklamních mailů, řetězových dopisů nebo jiné komunikace prostřednictvím schránky ve službě Anatom,</li>\n" +
    "<li>zahrnuje komerční nebo marketingové aktivity, například reklamu, propagaci, soutěže, losování nebo pyramidové hry, které nejsou výslovně autorizovány naší společností,</li>\n" +
    "<li>odkazuje na komerční produkty nebo služby nebo je jiným způsobem propaguje, s výjimkou případů, kdy je to výslovně autorizováno naší společností,</li>\n" +
    "<li>jakýmkoli způsobem narušuje nebo ovlivňuje Službu, manipuluje s ní, porušuje její zabezpečení nebo se pokouší zkoumat, sondovat nebo testovat zranitelnost služby Anatom nebo počítačových systémů, sítě, pravidel použití služby Anatom nebo jakýchkoli dalších bezpečnostních součástí Služby, jejích ověřovacích opatření nebo jakýchkoli jiných ochranných opatření vztahujících se ke Službě, obsahu nebo jakékoli jejich části, nebo</li>\n" +
    "<li>je v rozporu s Dohodami podle uvážení naší společnosti.</li>\n" +
    "</ul>\n" +
    "\n" +
    "<p>Rozumíte a souhlasíte, že zveřejnění jakéhokoli takového uživatelského obsahu může vést k okamžitému zrušení nebo pozastavení vašeho účtu služby Anatom. Také souhlasíte, že služba Anatom může z jakéhokoli důvodu vznést nárok na vaše uživatelské jméno.</p>\n" +
    "<p>Používejte službu Anatom a sdílejte obsah s rozvahou. Nezapomínejte, že sdílené nebo veřejně dostupné informace mohou být použity a znovu sdíleny jinými uživateli služby Anatom nebo na internetu, proto používejte službu Anatom opatrně a věnujte pozornost nastavením svého účtu. Naše společnost nenese žádnou odpovědnost za vaše rozhodnutí týkající se zveřejňování materiálu ve Službě.</p>\n" +
    "<p>Váš uživatelský účet je chráněn heslem a nesete výlučnou odpovědnost za uchování důvěrnosti a bezpečnosti svého hesla. Uvědomujete si, že jste odpovědní za všechna použití svého uživatelského jména a hesla ve Službě. Pokud dojde ke ztrátě nebo odcizení vašeho uživatelského jména nebo hesla, nebo pokud se domníváte, že došlo k neoprávněnému použití vašeho účtu třetími stranami, okamžitě nás na tuto skutečnost upozorněte a co nejdřív změňte svoje heslo.</p>\n" +
    "<h2>9 Omezení a úpravy služeb</h2>\n" +
    "<p>Naše společnost vynaloží přiměřené úsilí k zachování provozu Služby. Z času na čas však může dojít v důsledku technických potíží nebo údržby k dočasnému přerušení služby. V rozsahu povoleném příslušnými zákony si naše společnost vyhrazuje právo pravidelně a kdykoli upravit nebo přerušit, dočasně nebo trvale, funkce a prvky Služby, ať už s upozorněním nebo bez něj. V žádném takovém případě nenese vůči vám žádnou odpovědnost (pokud to nevylučuje zákon) za žádné přerušení, úpravu ani ukončení Služby ani žádných funkcí ani prvků Služby. Bez ohledu na uvedené platí, že pokud máte předplacené poplatky za placené odběry, které naše společnost trvale ukončí před koncem předplacené doby (podle definice v části Platby, zrušení a pozastavení), naše společnost vám po takovém ukončení vrátí poměrnou část předplacených poplatků za danou předplacenou dobu. Rozumíte, souhlasíte a akceptujete, že naše společnost nemá žádnou povinnost udržovat, podporovat, upgradovat ani aktualizovat Službu ani poskytovat jakýkoli nebo všechen konkrétní obsah prostřednictvím Služby. Tato část bude uplatňována v rozsahu povoleném příslušnými zákony. Naše společnost nebo majitelé obsahu mohou z času na čas takový obsah odstranit bez upozornění v rozsahu povoleném příslušnými zákony.</p>\n" +
    "<h2>10 Platby, zrušení, pozastavení, odstoupení od smlouvy</h2>\n" +
    "<p>Placené odběry lze zakoupit pomocí předplatného, které vám poskytne přístup ke Službě na určité časové období (dále „předplacená doba“). Platbu je nutno provést před započetím doby užívání. Váš placený odběr bude automaticky ukončen na konci předplacené doby.</p>\n" +
    "\n" +
    "<p>Pokud se zaregistrujete na placený odběr, zkušební období nebo získání kódu online, souhlasíte s okamžitým získáním přístupu k prémiové Službě. Pokud se zaregistrujete na placený odběr nebo získání kódu online, můžete z jakéhokoli důvodu nebo bez udání důvodu změnit názor do čtrnácti (14) dnů (dále „období pozastavení“) a získat zpět všechny zaplacené prostředky (tj. odstoupit od smlouvy). Pokud jste však kdykoli v průběhu období pozastavení využili přístup k více než 10 otázkám nebo obrázkům Služby, ztrácíte nárok na vrácení prostředků.</p>\n" +
    "\n" +
    "<p>Po ukončení placeného odběru bude Váš účet omezen na bezplatnou službu. Pokud však zrušíte platbu nebo placený odběr nebo zrušíte kteroukoli z Dohod (1) poté, co jste v průběhu období pozastavení využili přístup ke Službě, nebo (2) po ukončení období pozastavení (pokud je to možné), nebo (3) před koncem aktuálního období odběru, nevrátíme vám žádné poplatky za odběr, které jste nám již zaplatili.</p>\n" +
    "\n" +
    "<p>Pokud chcete před uplynutím období pozastavení získat vrácení všech zaplacených prostředků, musíte kontaktovat naší společnost.</p>\n" +
    "\n" +
    "<p>Naše společnost může z času na čas změnit výši platby za placené odběry, předplacená období (pro období, za která jste ještě nezaplatili) nebo kódy. Tyto změny poplatků vám předem oznámí společně se způsobem, jakým můžete tyto změny přijmout (pokud je to potřebné). Změny plateb za placené odběry vstoupí do platnosti na začátku následujícího období odběru po datu změny výše poplatků. Pokud to povoluje zákon v místě poskytnutí služby, dalším používáním Služby po uplatnění změny výše poplatků přijímáte novou výši poplatků. Pokud nesouhlasíte se změnou výše poplatků, máte právo tuto změnu odmítnout zrušením odběru Služby dříve, než vstoupí změna výše poplatků do platnosti. Proto si pozorně přečtěte jakékoli upozornění týkající se změny výše poplatků.</p>\n" +
    "<h2>11 Trvání a ukončení</h2>\n" +
    "\n" +
    "<p>Dohody budou platit, dokud je neukončíte vy nebo naše společnost. Přesto však rozumíte a souhlasíte, že trvalá licence, kterou jste udělili společnosti vzhledem k uživatelskému obsahu včetně zpětné vazby, je nevratná a proto bude nadále v platnosti i po vypršení platnosti nebo ukončení jakýchkoli Dohod z jakéhokoli důvodu. Naše společnost může ukončit platnost Dohod nebo kdykoli pozastavit váš přístup ke Službě, včetně případu, kdy neoprávněně použijete Službu nebo Obsah (nebo existuje podezření na takové použití), nebo nedodržíte Dohody. Pokud dojde k ukončení Dohod vámi nebo naší společností, nebo pokud naše společnost pozastaví váš přístup ke Službě, souhlasíte, že naše společnost nebude nést žádnou zodpovědnost vůči vaší osobě a nevrátí vám žádné poplatky, které jste již zaplatili. To platí v plném rozsahu povoleném příslušným zákonem. Pokud chcete zjistit, jak můžete ukončit svůj účet Služby, kontaktujte naši společnost. Tato část bude uplatňována v rozsahu povoleném příslušnými zákony. Dohody můžete ukončit kdykoli.</p>\n" +
    "\n" +
    "<p>Části 6, 7, 8, 9, 11, 12, 13, 14, 15, 16, 17, a 18 tohoto dokumentu, stejně jako jiné části Dohod, které musí výslovně nebo ze svojí podstaty nadále zůstat v platnosti i po ukončení Dohod, budou platit i po ukončení Dohod.</p>\n" +
    "<h2>12 Záruka a prohlášení</h2>\n" +
    "\n" +
    "<p>SNAŽÍME SE POSKYTOVAT CO NEJLEPŠÍ SLUŽBY, PŘESTO ROZUMÍTE A SOUHLASÍTE, ŽE SLUŽBA JE POSKYTOVÁNA „TAK, JAK JE“ A „TAK, JAK JE K DISPOZICI“, BEZ VÝSLOVNÉ NEBO NAZNAČENÉ ZÁRUKY NEBO PODMÍNKY JAKÉHOKOLI DRUHU. SLUŽBU POUŽÍVÁTE NA VLASTNÍ RIZIKO. V ÚPLNÉM ROZSAHU POVOLENÉM PŘÍSLUŠNÝM ZÁKONEM ODMÍTAJÍ NAŠE SPOLEČNOST A VLASTNÍCI OBSAHU POSKYTNOUT JAKÁKOLI PROHLÁŠENÍ A ODMÍTAJÍ JAKÉKOLI ZÁRUKY NEBO PODMÍNKY TÝKAJÍCÍ SE USPOKOJIVÉ KVALITY, OBCHODOVATELNOSTI, VHODNOSTI KE KONKRÉTNÍMU ÚČELU NEBO NEPORUŠOVÁNÍ PRÁV. NAŠE SPOLEČNOST ANI ŽÁDNÝ VLASTNÍK OBSAHU NEZARUČUJÍ, ŽE SLUŽBA NEOBSAHUJE ŠKODLIVÝ SOFTWARE NEBO JINÉ ŠKODLIVÉ SOUČÁSTI. NAŠE SPOLEČNOST NAVÍC NEPOSKYTUJE ŽÁDNÉ PROHLÁŠENÍ ANI NEZARUČUJE, NEDOPORUČUJE ANI NENESE ŽÁDNOU ODPOVĚDNOST ZA APLIKACE TŘETÍCH STRAN (ANI JEJICH OBSAH), UŽIVATELSKÝ OBSAH ANI ŽÁDNÝ JINÝ PRODUKT NEBO SLUŽBU PROPAGOVANOU NEBO NABÍZENOU TŘETÍ STRANOU VE SLUŽBĚ NEBO JEJÍM PROSTŘEDNICTVÍM NEBO POMOCÍ JAKÉHOKOLI ODKAZOVANÉHO WEBU, PŘÍPADNĚ NABÍZENOU POMOCÍ JAKÉHOKOLI REKLAMNÍHO PROUŽKU NEBO JINÉ REKLAMY. ROZUMÍTE A SOUHLASÍTE, ŽE SLUŽBA NENESE ODPOVĚDNOST ANI NEZODPOVÍDÁ ZA ŽÁDNÉ TRANSAKCE MEZI VÁMI A TŘETÍMI STRANAMI POSKYTUJÍCÍMI APLIKACE TŘETÍCH STRAN NEBO PRODUKTY ČI SLUŽBY PROPAGOVANÉ VE SLUŽBĚ NEBO JEJÍM PROSTŘEDNICTVÍM. STEJNĚ JAKO V PŘÍPADĚ JAKÉHOKOLI NÁKUPU PRODUKTU NEBO SLUŽBY PROSTŘEDNICTVÍM JAKÉHOKOLI MÉDIA NEBO V JAKÉMKOLI PROSTŘEDÍ BYSTE SE MĚLI ŘÍDIT SVÝM ÚSUDKEM A POKUD JE TO POTŘEBNÉ, ZACHOVÁVAT OPATRNOST. ŽÁDNÉ RADY ANI INFORMACE, AŤ UŽ ÚSTNÍ NEBO PÍSEMNÉ, ZÍSKANÉ OD NAŠÍ SPOLEČNOSTI, NEBUDOU PŘEDSTAVOVAT ŽÁDNOU ZÁRUKU ZE STRANY NAŠÍ SPOLEČNOSTI TÝKAJÍCÍ SE TĚCHTO PRODUKTŮ NEBO SLUŽEB. NĚKTERÁ USTANOVENÍ TÉTO ČÁSTI NEMUSÍ PLATIT V JURISDIKCÍCH, KDE TO NEUMOŽŇUJE PLATNÝ ZÁKON.</p>\n" +
    "\n" +
    "<p>TATO ČÁST NEMÁ VLIV NA VAŠE SPOTŘEBITELSKÁ PRÁVA VYPLÝVAJÍCÍ ZE ZÁKONA.</p>\n" +
    "<h2>13 Omezení</h2>\n" +
    "\n" +
    "<p>SOUHLASÍTE, ŽE V ROZSAHU POVOLENÉM PŘÍSLUŠNÝM ZÁKONEM, JE VÁŠ JEDINÝ A VÝLUČNÝ NÁPRAVNÝ PROSTŘEDEK TÝKAJÍCÍ SE JAKÝCHKOLI PROBLÉMŮ NEBO NESPOKOJENOSTI SE SLUŽBOU PŘEDSTAVOVÁN ODINSTALOVÁNÍM SOFTWARU SLUŽBY A UKONČENÍM POUŽÍVÁNÍ SLUŽBY. I KDYŽ NAŠE SPOLEČNOST NEPŘIJÍMÁ ŽÁDNOU ZODPOVĚDNOST ZA APLIKACE TŘETÍCH STRAN ANI JEJICH OBSAH, A I KDYŽ SE MŮŽE VÁŠ VZTAH S PŘÍSLUŠNÝMI APLIKACEMI TŘETÍCH STRAN ŘÍDIT SAMOSTATNÝMI DOHODAMI S PŘÍSLUŠNÝMI TŘETÍMI STRANAMI, V ROZSAHU POVOLENÉM PŘÍSLUŠNÝM ZÁKONEM JE VÁŠ JEDINÝ A VÝLUČNÝ NÁPRAVNÝ PROSTŘEDEK TÝKAJÍCÍ SE JAKÝCHKOLI PROBLÉMŮ NEBO NESPOKOJENOSTI S APLIKACEMI TŘETÍCH STRAN NEBO JEJICH OBSAHEM PŘEDSTAVOVÁN ODINSTALOVÁNÍM NEBO UKONČENÍM POUŽÍVÁNÍ JAKÝCHKOLI PŘÍSLUŠNÝCH APLIKACÍ TŘETÍCH STRAN.</p>\n" +
    "\n" +
    "<p>V ÚPLNÉM ROZSAHU POVOLENÉM ZÁKONEM NEBUDE NAŠE SPOLEČNOST, JEJÍ VEDOUCÍ, AKCIONÁŘI, ZAMĚSTNANCI, ZÁSTUPCI, ŘEDITELÉ, DCEŘINÉ SPOLEČNOSTI, PŘIDRUŽENÉ SUBJEKTY, NÁSLEDNICKÉ SUBJEKTY, POVĚŘENÉ OSOBY, DODAVATELÉ ANI POSKYTOVATELÉ LICENCÍ NÉST ZODPOVĚDNOST ZA (1) ŽÁDNÉ NEPŘÍMÉ, ZVLÁŠTNÍ, NÁHODNÉ, TRESTNÍ, EXEMPLÁRNÍ ANI NÁSLEDNÉ ÚJMY, (2) ŽÁDNOU ZTRÁTU POUŽITÍ, DAT, OBCHODŮ NEBO ZISKŮ (AŤ UŽ PŘÍMÝCH NEBO NEPŘÍMÝCH), VE VŠECH PŘÍPADECH VYPLÝVAJÍCÍCH Z POUŽITÍ NEBO NEMOŽNOSTI POUŽITÍ SLUŽBY, APLIKACÍ TŘETÍCH STRAN NEBO OBSAHU APLIKACÍ TŘETÍCH STRAN, BEZ OHLEDU NA PRÁVNÍ TEORII A BEZ OHLEDU NA TO, ZDA BYLA NAŠE SPOLEČNOST VAROVÁNA OHLEDNĚ MOŽNOSTI TĚCHTO ŠKOD A I V PŘÍPADĚ, ŽE NÁPRAVNÝ PROSTŘEDEK NESPLNÍ SVŮJ ZÁKLADNÍ ÚČEL, NEBO (3) SOUHRNNOU ZODPOVĚDNOST ZA VŠECHNY NÁROKY TÝKAJÍCÍ SE SLUŽBY, APLIKACÍ TŘETÍCH STRAN NEBO OBSAHU APLIKACÍ TŘETÍCH STRAN V ROZSAHU VYŠŠÍM, NEŽ JE ČÁSTKA, KTEROU JSTE ZAPLATILI NAŠÍ SPOLEČNOSTI V PRŮBĚHU UPLYNULÝCH DVANÁCTI MĚSÍCŮ, V ÚPLNÉM ROZSAHU POVOLENÉM PŘÍSLUŠNÝM ZÁKONEM.</p>\n" +
    "\n" +
    "<p>Žádná část Dohod nezbavuje naši společnost zodpovědnosti ani neomezuje zodpovědnost týkající se podvodu, podvodného zavádění, úmrtí nebo zranění osob v důsledku zanedbání ze strany společnosti, nebo (pokud to vyžaduje příslušný zákon) hrubého zanedbání. Některá ustanovení této části nemusí platit v jurisdikcích, kde to neumožňuje platný zákon.</p>\n" +
    "<h2>14 Práva třetích stran</h2>\n" +
    "\n" +
    "<p>Rozumíte a souhlasíte, že vlastníci obsahu a někteří distributoři (například poskytovatelé obchodů s aplikacemi) představují zamýšlené beneficienty Dohod a mají právo přímo vynucovat vaše dodržování Dohod. V případech, které nejsou uvedeny v této části, není cílem Dohod udělovat práva žádné další straně kromě vás a naší společnosti, a v žádném případě nebudou tyto Dohody základem pro práva beneficientů týkající se jakýchkoli třetích stran. Navíc platí, že práva týkající se ukončení, anulování nebo poskytnutí souhlasu s jakoukoli úpravou, zřeknutím se nebo vyrovnáním týkajícím se Dohod nepodléhají souhlasu žádné další osoby.</p>\n" +
    "<h2>15 Celá dohoda</h2>\n" +
    "\n" +
    "<p>Kromě případů uvedených v této části nebo výslovně písemně dohodnutých mezi vámi a naší společností představují Dohody všechny podmínky, na kterých jste se vy a naše společnost dohodli, a mají přednost před jakýmikoli předchozími dohodami týkajícími se předmětů těchto Dohod, ať už písemnými nebo ústními.</p>\n" +
    "\n" +
    "<p>Upozorňujeme však, že se jiné stránky vašeho používání Služby mohou řídit dodatečnými dohodami. Tyto stránky mohou například zahrnovat přístup ke Službě v důsledku použití dárkové karty nebo bezplatného či zlevněného zkušebního období. Pokud dostanete nabídku týkající se takových stránek použití, bude vám poskytnuta jakákoli příslušná dodatečná dohoda a můžete mít možnost souhlasit s dodatečnými podmínkami. Některé z těchto dodatečných podmínek jsou uvedeny na webu naší společnosti. V případě, že dochází k neslučitelnému konfliktu mezi dodatečnými podmínkami a těmito podmínkami, budou mít přednost dodatečné podmínky.</p>\n" +
    "<h2>16 Možnost rozvázaní a zřeknutí se práv</h2>\n" +
    "\n" +
    "<p>V případě, že to není jinak uvedeno v těchto Dohodách, pokud se ukáže, že je kterékoli ustanovení Dohod považováno za neplatné nebo nevymahatelné z jakéhokoli důvodu nebo v jakémkoli rozsahu, nebude tato neplatnost nebo nevymahatelnost žádným způsobem ovlivňovat platnost nebo vymahatelnost zbývajících ustanovení Dohod a uplatnění příslušného ustanovení bude vymáhána v nejširším rozsahu povoleném zákonem.</p>\n" +
    "\n" +
    "<p>Jakákoli nečinnost ze strany naší společnosti nebo jakékoli třetí strany, která je beneficientem těchto Dohod, týkající se vymáhání Dohod nebo jakéhokoli ustanovení, nebude považována za zřeknutí se příslušných práv na takové vymáhání ze strany naší společnosti nebo třetí strany a beneficienta.</p>\n" +
    "<h2>17 Přiřazení</h2>\n" +
    "<p>Naše společnost může přiřadit Dohody nebo jakoukoli jejich část. Naše společnost může také delegovat jakékoli ze svých povinností podle těchto Dohod. Nemůžete přiřadit Dohody ani jakoukoli jejich část, ani přenést ani dále licencovat svoje práva podle Dohody žádné třetí straně.</p>\n" +
    "<h2>18 Zbavení odpovědnosti</h2>\n" +
    "\n" +
    "<p>V plném rozsahu povoleném příslušným zákonem souhlasíte, že zbavíte naši společnost zodpovědnosti za všechny škody, ztráty a výdaje jakéhokoli druhu (včetně přiměřených poplatků a nákladů na právní zastoupení) vyplývající z: (1) vašeho porušení této Dohody, (2) jakéhokoli uživatelského obsahu, (3) jakékoli aktivity, do které jste se zapojili ve Službě nebo jejím prostřednictvím, a (4) vašeho porušení jakýchkoli zákonů nebo práv třetí strany.</p>\n" +
    "\n" +
    "<h2>Uživatelská podpora</h2>\n" +
    "Samuel Bakoš <br>\n" +
    "Email: anatom/zavináč/googlegroups.com <br>\n" +
    "Tel: +421.917.588.911 <br>\n" +
    "       \n" +
    "<h2>Administrativní kontakt a smluvní provozovatel</h2>\n" +
    "MUDr. Marek Čierny<br>\n" +
    "Konečného 2170/4, <br>\n" +
    "Brno, 61500, ČR<br>\n" +
    "IČ: 74284854<br>\n" +
    "DIČ: neplátce DPH<br>\n" +
    "<br>\n" +
    "E-mail: marek/zavináč/cierny.cz<br>\n" +
    "Tel.: +1 4145529025<br>\n" +
    "\n" +
    "<h2>Zakladatelé</h2>\n" +
    "<p>Jan Papoušek, Vít Stanislav, Marek Čierny, Linda Kašičková</p>\n" +
    "\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div class=\"clearfix\"></div>\n" +
    "");
  $templateCache.put("static/tpl/terms_of_use_en.html",
    "<br>\n" +
    "<div class=\"terms-of-use row\">\n" +
    "  <div class=\"col-sm-offset-2 col-sm-8\">\n" +
    "    <div class=\"panel panel-default\">\n" +
    "      <div class=\"panel-heading\">\n" +
    "        <h1>PracticeAnatomy.com Terms and Conditions of use </h1>\n" +
    "      </div>\n" +
    "      <div class=\"panel-body\">\n" +
    "<p>Effective as of October 22, 2016</p>\n" +
    "<p>Hello, and welcome to our Terms and Conditions of Use. This is important and affects your legal rights, so please read them and our Privacy Policy and other terms referenced in this document carefully.</p>\n" +
    "<h2>1 Introduction</h2>\n" +
    "<p>Thanks for choosing Practice Anatomy (“PracticeAnatomy”, “PracticeAnatomy.com”, “PA”, “we”, “us”, “our”). By signing up or otherwise using the PracticeAnatomy service, websites, and software applications (together, the “PracticeAnatomy Service” or “Service”), or accessing any content or material that is made available by PracticeAnatomy through the Service (the “Content”) you are entering into a binding contract with the Marek Cierny entity indicated at the bottom of this document (“our Company”).</p>\n" +
    "<p>Your agreement with us includes these Terms and Conditions of Use (“Terms”) and our Privacy Policy. (The Terms, Privacy Policy, and any additional terms that you agree to, as discussed in the Entire Agreement section, are referred to together as the “Agreements”.) If you wish to review the terms of the Agreements, the effective version of the Agreements can be found on PracticeAnatomy’s website. You acknowledge that you have read and understood the Agreements, accept these Agreements, and agree to be bound by them. If you don’t agree with (or cannot comply with) the Agreements, then you may not use the PracticeAnatomy Service or consume any Content.</p>\n" +
    "<p>Please read the Agreements carefully. They cover important information about PracticeAnatomy Services provided to you and any charges, taxes, and fees we bill you. The Agreements include information about future changes to the Agreements, automatic renewals, limitations of liability, and privacy information.</p>\n" +
    "<p>In order to use the PracticeAnatomy Service and access the Content, you need to (1) be 18 or older, or be 13 or older and have your parent or guardian’s consent to the Agreements (except as set forth in the chart below), (2) have the power to enter a binding contract with us and not be barred from doing so under any applicable laws, and (3) be resident in a country where the Service is available. You also promise that any registration information that you submit to PracticeAnatomy is true, accurate, and complete, and you agree to keep it that way at all times.</p>\n" +
    "<h2>2 Changes to the Agreements</h2>\n" +
    "<p>Occasionally we may, in our discretion, make changes to the Agreements. When we make material changes to the Agreements, we’ll provide you with prominent notice as appropriate under the circumstances, e.g., by displaying a prominent notice within the Service or by sending you an email. In some cases, we will notify you in advance, and your continued use of the Service after the changes have been made will constitute your acceptance of the changes. Please therefore make sure you read any such notice carefully. If you do not wish to continue using the Service under the new version of the Agreements, you may terminate the Agreements by contacting us.</p>\n" +
    "<h2>3 Enjoying Practice Anatomy</h2>\n" +
    "<h3>3.1 Our Services & Paid Subscriptions</h3>\n" +
    "<p>We provide the service of practicing, teaching and delivering of educational and other content. While delivering high eduacational value, some of images might depict intimate parts of human body in detail; if you are less than 18 years old or uncomfortable seeing such images, please consult your parents or reconsider using thi application,respectivelly.   Certain Practice Anatomy services are provided to you free-of-charge. Other Practice Anatomy services require payment before you can access them. The Practice Anatomy services that may be accessed after payment are currently referred to as the “Premium Service”, “Premium Content” and the “Unlimited Service” (together, the “Paid Subscriptions”). The Practice Anatomy service that does not require payment is currently referred to as the “Free Service”. You can learn more about our services by visiting our website.</p>\n" +
    "\n" +
    "<p>The Unlimited Service may not be available to all users. We will explain which services are available to you when you are signing up for the services. If you cancel your subscription to the Unlimited Service, or if your subscription to the Unlimited Service is interrupted (for example, if you change your payment details), you may not be able to re-subscribe for the Unlimited Service. Note that the Unlimited Service may be discontinued in the future, in which case you will no longer be charged for the Service.</p>\n" +
    "<h3>3.2 Codes and other pre-paid offers</h3>\n" +
    "<p>If you have purchased or received a code, gift card, pre-paid offer or other offer provided or sold by or on behalf of Practice Anatomy for access to a Paid Subscription (“Code”), separate terms and conditions presented to you along with the Code may also apply to your access to the Service and you agree to comply with any such terms and conditions.</p>\n" +
    "<h3>3.3 Trials</h3>\n" +
    "<p>From time to time, we or others on our behalf may offer trials of Paid Subscriptions for a specified period without payment or at a reduced rate (a “Trial”). Practice Anatomy reserves the right, in its absolute discretion, to determine your eligibility for a Trial, and, subject to applicable laws, to withdraw or to modify a Trial at any time without prior notice and with no liability, to the greatest extent permitted under the law.</p>\n" +
    "<p>For some Trials, we’ll require you to provide your payment details to start the Trial. AT THE END OF SUCH TRIALS, WE MAY AUTOMATICALLY START TO CHARGE YOU FOR THE APPLICABLE PAID SUBSCRIPTION ON THE FIRST DAY FOLLOWING THE END OF THE TRIAL, ON A RECURRING MONTHLY BASIS. BY PROVIDING YOUR PAYMENT DETAILS IN CONJUNCTION WITH THE TRIAL, YOU AGREE TO THIS CHARGE USING SUCH PAYMENT DETAILS. IF YOU DO NOT WANT TO CONTINUE TO BE CHARGED ON A RECURRING BASIS, YOU MUST CANCEL THE APPLICABLE PAID SUBSCRIPTION THROUGH YOUR PRACTICE ANATOMY ACCOUNT’S SUBSCRIPTION PAGE OR TERMINATE YOUR PRACTICE ANATOMY ACCOUNT BEFORE THE END OF THE RECURRING PERIOD. PAID SUBSCRIPTIONS CANNOT BE TERMINATED BEFORE THE END OF THE PERIOD FOR WHICH YOU HAVE ALREADY PAID, AND EXCEPT AS EXPRESSLY PROVIDED IN THESE TERMS, SPOTIFY WILL NOT REFUND ANY FEES THAT YOU HAVE ALREADY PAID. THE LIMITATION SECTION SETS FORTH ADDITIONAL TERMS REGARDING CANCELLATION OF YOUR PAID SUBSCRIPTION.</p>\n" +
    "<h2>4 Rights we grant you</h2>\n" +
    "<p>The Practice Anatomy Service and the Content are the property of Practice Anatomy or Spotify's licensors. We grant you a limited, non-exclusive, revocable licence to make use of the Practice Anatomy Service, and a limited, non-exclusive, revocable licence to make personal, non-commercial, entertainment use of the Content (the “Licence”). This Licence shall remain in effect until and unless terminated by you or Practice Anatomy. You promise and agree that you are using the Content for your own personal, non-commercial, entertainment use and that you will not redistribute or transfer the Spotify Service or the Content.</p>\n" +
    "<p>The Practice Anatomy software applications and the Content are licensed, not sold, to you, and Practice Anatomy and its licensors retain ownership of all copies of the Practice Anatomy software applications and Content even after installation on your personal computers, mobile handsets, tablets, and/or other relevant devices (“Devices”). You agree to respect the right of providers of licensed content.</p>\n" +
    "<p>All Practice Anatomy trademarks, service marks, trade names, logos, domain names, and any other features of the Practice Anatomy brand (“Practice Anatomy  Brand Features”) are the sole property of Practice Anatomy or its licensors. The Agreements do not grant you any rights to use any Practice Anatomy Brand Features whether for commercial or non-commercial use.</p>\n" +
    "<p>You agree to abide by our User guidelines and not to use the Practice Anatomy Service, the Content, or any part thereof in any manner not expressly permitted by the Agreements. Except for the rights expressly granted to you in these Agreements, Practice Anatomy grants no right, title, or interest to you in the Spotify Service or Content.</p>\n" +
    "<p>Third party software (for example, open source software libraries) included in the Practice Anatomy Service are licensed to you either under the Agreements or under the relevant third party software library’s licence terms as published in the help or settings section of our desktop and mobile client and/or on our website.</p>\n" +
    "<h2>5 Third Party Applications</h2>\n" +
    "<p>The Practice Anatomy Service is integrated with third party applications, websites, and services (“Third Party Applications”) to make available content, products, and/or services to you. These Third Party Applications may have their own terms and conditions of use and privacy policies and your use of these Third Party Applications will be governed by and subject to such terms and conditions and privacy policies. You understand and agree that Practice Anatomy does not endorse and is not responsible or liable for the behavior, features, or content of any Third Party Application or for any transaction you may enter into with the provider of any such Third Party Applications.</p>\n" +
    "<h2>6 User-Generated Content</h2>\n" +
    "<p>You promise that, with respect to any User Content you post on Practice Anatomy, (1) you have the right to post such User Content, and (2) such User Content, or its use by Spotify as contemplated by the Agreements, does not violate the Agreements, applicable law, or the intellectual property, publicity, personality, or other rights of others.</p>\n" +
    "<p>Practice Anatomy may, but has no obligation to, monitor, review, or edit User Content. In all cases, Practice Anatomy reserves the right to remove or disable access to any User Content for any or no reason, including but not limited to, User Content that, in PracticeAnatomy’s sole discretion, violates the Agreements. Practice Anatomy may take these actions without prior notification to you or any third party. Removal or disabling of access to User Content shall be at our sole discretion, and we do not promise to remove or disable access to any specific User Content.</p>\n" +
    "<p>You are solely responsible for all User Content that you post. Practice Anatomy is not responsible for User Content nor does it endorse any opinion contained in any User Content. YOU AGREE THAT IF ANYONE BRINGS A CLAIM AGAINST Practice Anatomy RELATED TO USER CONTENT THAT YOU POST, THEN, TO THE EXTENT PERMISSIBLE UNDER LOCAL LAW, YOU WILL INDEMNIFY AND HOLD Practice Anatomy HARMLESS FROM AND AGAINST ALL DAMAGES, LOSSES, AND EXPENSES OF ANY KIND (INCLUDING REASONABLE ATTORNEY FEES AND COSTS) ARISING OUT OF SUCH CLAIM.</p>\n" +
    "<h2>7 Rights you grant us</h2>\n" +
    "<p>In consideration for the rights granted to you under the Agreements, you grant us the right (1) to allow the Practice Anatomy Service to use the processor, bandwidth, and storage hardware on your Device in order to facilitate the operation of the Service, (2) to provide advertising and other information to you. In any part of the Practice Anatomy Service, the Content you view, including its selection and placement, may be influenced by commercial considerations, including agreements with third parties. Some Content licensed or provided to Practice Anatomy (e.g. podcasts) may contain advertising as part of the Content.</p>\n" +
    "<p>If you provide feedback, ideas or suggestions to Spotify in connection with the Practice Anatomy Service or Content (“Feedback”), you acknowledge that the Feedback is not confidential and you authorize Spotify to use that Feedback without restriction and without payment to you. Feedback is considered a type of User Content.</p>\n" +
    "<p>You grant Practice Anatomy a non-exclusive, transferable, sub-licensable, royalty-free, perpetual (or, in jurisdictions where this is not permitted, for a term equal to the duration of the Agreements plus twenty (20) years), irrevocable, fully paid, worldwide licence to use, reproduce, make available to the public (e.g. perform or display), publish, translate, modify, create derivative works from, and distribute any of your User Content in connection with the Service through any medium, whether alone or in combination with other content or materials, in any manner and by any means, method or technology, whether now known or hereafter created. Aside from the rights specifically granted herein, you retain ownership of all rights, including intellectual property rights, in the User Content. </p>\n" +
    "<h2>8 User guidelines</h2>\n" +
    "<p>Practice Anatomy respects intellectual property rights and expects you to do the same. We’ve established a few ground rules for you to follow when using the Service, to make sure Practice Anatomy stays enjoyable for everyone. Please follow these rules and encourage other users to do the same.</p>\n" +
    "<p>The following is not permitted for any reason whatsoever:</p>\n" +
    "<ul>\n" +
    "<li>copying, downloading, redistributing, reproducing, “ripping”, or making available to the public any part of the Practice Anatomy Service or the Content, or otherwise making any use of the Practice Anatomy Service or the Content which is not expressly permitted under the Agreements or applicable law or which otherwise infringes the intellectual property rights (such as copyright) in the Practice Anatomy Service or the Content or any part of it;</li>\n" +
    "<li>transferring copies of cached Content from an authorized Device to any other Device via any means;</li>\n" +
    "<li>reverse-engineering, decompiling, disassembling, modifying, or creating derivative works based on the Practice Anatomy Service, Content or any part thereof unless permitted by applicable law;</li>\n" +
    "<li>circumventing any technology used by Practice Anatomy, its licensors, or any third party to protect the Content or the Service;</li>\n" +
    "<li>selling, renting, sublicensing or leasing of any part of the Practice Anatomy Service or the Content;</li>\n" +
    "<li>removing or altering any copyright, trademark, or other intellectual property notices contained on or provided through the Practice Anatomy Service (including for the purpose of disguising or changing any indications of the ownership or source of any Content);</li>\n" +
    "<li>providing your password to any other person or using any other person’s username and password;</li>\n" +
    "<li>“crawling” the Service or otherwise using any automated means (including bots, scrapers, and spiders) to collect information from Practice Anatomy; or</li>\n" +
    "<li>selling a user account, or otherwise accepting any compensation, financial or otherwise, to influence the name of an account or the content included on an account.</li>\n" +
    "</ul>\n" +
    "<p>Please respect Practice Anatomy, the owners of the Content, and other users of the Practice Anatomy Service. Don’t engage in any activity, post any User Content, or register and/or use a username, which is or includes material that:</p>\n" +
    "<ul>\n" +
    "<li>is offensive, abusive, defamatory, pornographic, threatening, or obscene;</li>\n" +
    "<li>is illegal, or intended to promote or commit an illegal act of any kind, including but not limited to violations of intellectual property rights, privacy rights, or proprietary rights of Practice Anatomy or a third party;</li>\n" +
    "<li>is intended to or does harass or bully other users;</li>\n" +
    "<li>impersonates or misrepresents your affiliation with another user, person, or entity, or is otherwise fraudulent, false, deceptive, or misleading;</li>\n" +
    "<li>uses automated means to artificially promote content;</li>\n" +
    "<li>involves the transmission of unsolicited mass mailings or other forms of spam (“spam”), junk mail, chain letters, or similar, including through the Practice Anatomy inbox;</li>\n" +
    "<li>involves commercial or sales activities, such as advertising, promotions, contests, sweepstakes, or pyramid schemes, that are not expressly authorized by Practice Anatomy;</li>\n" +
    "<li>links to, references, or otherwise promotes commercial products or services, except as expressly authorized by Practice Anatomy;</li>\n" +
    "<li>interferes with or in any way disrupts the Practice Anatomy Service, tampers with, breaches, or attempts to probe, scan, or test for vulnerabilities in the Service or Practice Anatomy’s computer systems, network, usage rules, or any of Practice Anatomy’s security components, authentication measures or any other protection measures applicable to the Service, the Content or any part thereof; or</li>\n" +
    "<li>conflicts with the Agreements, as determined by Practice Anatomy.</li>\n" +
    "<p>You acknowledge and agree that posting any such User Content may result in immediate termination or suspension of your Practice Anatomy account. You also agree that Practice Anatomy may also reclaim your username for any reason.</p>\n" +
    "<p>Please be thoughtful about how you use the Practice Anatomy Service and what you share. Remember that shared or publicly available information may be used and re-shared by other users on Practice Anatomy or across the web, so please use Practice Anatomy carefully and be mindful of your account settings. Practice Anatomy has no responsibility for your choices to post material on the Service.</p>\n" +
    "<p>Your password protects your user account, and you are solely responsible for keeping your password confidential and secure. You understand that you are responsible for all use of your username and password on the Service. If your username or password is lost or stolen, or if you believe there has been unauthorized access to your account by third parties, please notify us immediately and change your password as soon as possible.</p>\n" +
    "<h2>9 Service limitations and modifications</h2>\n" +
    "<p>Practice Anatomy will make reasonable efforts to keep the Practice Anatomy Service operational. However, certain technical difficulties or maintenance may, from time to time, result in temporary interruptions. To the extent permissible under applicable law, Practice Anatomy reserves the right, periodically and at any time, to modify or discontinue, temporarily or permanently, functions and features of the Practice Anatomy Service, with or without notice, all without liability to you, except where prohibited by law, for any interruption, modification, or discontinuation of the Practice Anatomy Service or any function or feature thereof. Notwithstanding the foregoing, if you have prepaid fees for Paid Subscriptions that Spotify permanently discontinues prior to the end of the Pre-Paid Period (defined in the Payments, cancellations, and cooling off section), Practice Anatomy will refund you the an appropriate part of prepaid fees for the Pre-Paid Period after such discontinuation. You understand, agree, and accept that Practice Anatomy has no obligation to maintain, support, upgrade, or update the Service, or to provide all or any specific content through the Service. This section will be enforced to the extent permissible by applicable law. Spotify and/or the owners of any Content may, from time to time, remove any such Content without notice to the extent permitted by applicable law.</p>\n" +
    "<h2>10 Payments, cancellations, cooling off, and </h2>\n" +
    "<p>Paid Subscriptions can be purchased by pre-payment giving you access to the Spotify Service for a specific time period (“Pre-Paid Period”). The payment is due before starting the use of the service. Your paid subscription will be automatically terminated at the end of you pre-paid period.</p>\n" +
    "<p>When you register for a Paid Subscription, Trial, or Code online, you consent to get access to Spotify Premium immediately. If you register for a Paid Subscription or Code online, you may change your mind, cancel your order, for any or no reason and receive a full refund of all monies paid within fourteen (14) days (the “Cooling-off Period”). Refunds will not, however, be provided if you have accessed more than 10 Practice Anatomy questions or images at any time during the Cooling-off Period.</p>\n" +
    "<p>When the pre-paid subscription terminates, you will be downgraded to the Free Service. However, if you cancel your payment or Paid Subscription and/or terminate any of the Agreements (1) after you have accessed Spotify during the Cooling-off Period, or (2) after the Cooling-off Period is over (where applicable), or (3) before the end of the current subscription period, we will not refund any subscription fees already paid to us.</p>\n" +
    "<p>If you wish to receive a full refund of all monies paid before the Cooling-off Period is over, you must contact Customer Support.</p>\n" +
    "<p>Practice Anatomy may change the price for the Paid Subscriptions, Pre-Paid Period (for periods not yet paid for), or Codes from time to time, and will communicate any price changes to you in advance and, if applicable, how to accept those changes. Price changes for Paid Subscriptions will take effect at the start of the next subscription period following the date of the price change. As permitted by local law, you accept the new price by continuing to use the Practice Anatomy Service after the price change takes effect. If you do not agree with the price changes, you have the right to reject the change by unsubscribing from the Practice Anatomy Service prior to the price change going into effect. Please therefore make sure you read any such notification of price changes carefully.</p>\n" +
    "<h2>11 Term and termination</h2>\n" +
    "<p>The Agreements will continue to apply to you until terminated by either you or Practice Anatomy. However, you acknowledge and agree that the perpetual licence granted by you in relation to User Content, including Feedback, is irrevocable and will therefore continue after expiry or termination of any of the Agreements for any reason. Practice Anatomy may terminate the Agreements or suspend your access to the Practice Anatomy Service at any time, including in the event of your actual or suspected unauthorised use of the Practice Anatomy Service and/or Content, or non-compliance with the Agreements. If you or Practice Anatomy terminate the Agreements, or if Practice Anatomy suspends your access to the Practice Anatomy Service, you agree that Practice Anatomy shall have no liability or responsibility to you and Practice Anatomy will not refund any amounts that you have already paid, to the fullest extent permitted under applicable law. To learn how to terminate your Practice Anatomy account, please contact us through the Customer Service contact form which is available on our About Us page. This section will be enforced to the extent permissible by applicable law. You may terminate the Agreements at any time.</p>\n" +
    "<p>Sections 6, 7, 8, 9, 11, 12, 13, 14, 15, 16, 17, a 18 as well as any other sections of the Agreements that, either explicitly or by their nature, must remain in effect even after termination of the Agreements, shall survive termination.</p>\n" +
    "<h2>12 Warranty and disclaimer</h2>\n" +
    "<p>WE ENDEAVOUR TO PROVIDE THE BEST SERVICE WE CAN, BUT YOU UNDERSTAND AND AGREE THAT THE PRACTICE ANATOMY SERVICE IS PROVIDED “AS IS” AND “AS AVAILABLE”, WITHOUT EXPRESS OR IMPLIED WARRANTY OR CONDITION OF ANY KIND. YOU USE THE PRACTICE ANATOMY SERVICE AT YOUR OWN RISK. TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, SPOTIFY AND ALL OWNERS OF THE CONTENT MAKE NO REPRESENTATIONS AND DISCLAIM ANY WARRANTIES OR CONDITIONS OF SATISFACTORY QUALITY, MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT. NEITHER SPOTIFY NOR ANY OWNER OF CONTENT WARRANTS THAT THE PRACTICE ANATOMY SERVICE IS FREE OF MALWARE OR OTHER HARMFUL COMPONENTS. IN ADDITION, SPOTIFY MAKES NO REPRESENTATION NOR DOES IT WARRANT, ENDORSE, GUARANTEE, OR ASSUME RESPONSIBILITY FOR ANY THIRD PARTY APPLICATIONS (OR THE CONTENT THEREOF), USER CONTENT, OR ANY OTHER PRODUCT OR SERVICE ADVERTISED OR OFFERED BY A THIRD PARTY ON OR THROUGH THE PRACTICE ANATOMY SERVICE OR ANY HYPERLINKED WEBSITE, OR FEATURED IN ANY BANNER OR OTHER ADVERTISING. YOU UNDERSTAND AND AGREE THAT PRACTICE ANATOMY IS NOT RESPONSIBLE OR LIABLE FOR ANY TRANSACTION BETWEEN YOU AND THIRD PARTY PROVIDERS OF THIRD PARTY APPLICATIONS OR PRODUCTS OR SERVICES ADVERTISED ON OR THROUGH THE PRACTICE ANATOMY SERVICE. AS WITH ANY PURCHASE OF A PRODUCT OR SERVICE THROUGH ANY MEDIUM OR IN ANY ENVIRONMENT, YOU SHOULD USE YOUR JUDGMENT AND EXERCISE CAUTION WHERE APPROPRIATE. NO ADVICE OR INFORMATION WHETHER ORAL OR IN WRITING OBTAINED BY YOU FROM PRACTICE ANATOMY SHALL CREATE ANY WARRANTY ON BEHALF OF PRACTICE ANATOMY IN THIS REGARD. SOME ASPECTS OF THIS SECTION MAY NOT APPLY IN SOME JURISDICTIONS IF PROHIBITED BY APPLICABLE LAW.</p>\n" +
    "<p>THIS DOES NOT AFFECT YOUR STATUTORY RIGHTS AS A CONSUMER.</p>\n" +
    "<h2>13 Limitation</h2>\n" +
    "<p>YOU AGREE THAT, TO THE EXTENT PERMITTED BY APPLICABLE LAW, YOUR SOLE AND EXCLUSIVE REMEDY FOR ANY PROBLEMS OR DISSATISFACTION WITH THE PRACTICE ANATOMY SERVICE IS TO UNINSTALL ANY PRACTICE ANATOMY SOFTWARE AND TO STOP USING THE PRACTICE ANATOMY SERVICE. WHILE PRACTICE ANATOMY ACCEPTS NO RESPONSIBILITY FOR THIRD PARTY APPLICATIONS OR THE CONTENT THEREOF, AND WHILE YOUR RELATIONSHIP WITH SUCH THIRD PARTY APPLICATIONS MAY BE GOVERNED BY SEPARATE AGREEMENTS WITH SUCH THIRD PARTIES, TO THE EXTENT PERMITTED BY APPLICABLE LAW, YOUR SOLE AND EXCLUSIVE REMEDY, AS WITH RESPECT TO PRACTICE ANATOMY, FOR ANY PROBLEMS OR DISSATISFACTION WITH THIRD PARTY APPLICATIONS OR THE CONTENT THEREOF, IS TO UNINSTALL AND/OR STOP USING ANY SUCH THIRD PARTY APPLICATIONS.</p>\n" +
    "<p>TO THE FULLEST EXTENT PERMITTED BY LAW, IN NO EVENT WILL PRACTICE ANATOMY, ITS OFFICERS, SHAREHOLDERS, EMPLOYEES, AGENTS, DIRECTORS, SUBSIDIARIES, AFFILIATES, SUCCESSORS, ASSIGNS, SUPPLIERS, OR LICENSORS BE LIABLE FOR (1) ANY INDIRECT, SPECIAL, INCIDENTAL, PUNITIVE, EXEMPLARY, OR CONSEQUENTIAL DAMAGES; (2) ANY LOSS OF USE, DATA, BUSINESS, OR PROFITS (WHETHER DIRECT OR INDIRECT), IN ALL CASES ARISING OUT OF THE USE OR INABILITY TO USE THE PRACTICE ANATOMY SERVICE, THIRD PARTY APPLICATIONS, OR THIRD PARTY APPLICATION CONTENT, REGARDLESS OF LEGAL THEORY, WITHOUT REGARD TO WHETHER SPOTIFY HAS BEEN WARNED OF THE POSSIBILITY OF THOSE DAMAGES, AND EVEN IF A REMEDY FAILS OF ITS ESSENTIAL PURPOSE; OR (3) AGGREGATE LIABILITY FOR ALL CLAIMS RELATING TO THE PRACTICE ANATOMY SERVICE, THIRD PARTY APPLICATIONS, OR THIRD PARTY APPLICATION CONTENT MORE THAN THE AMOUNTS PAID BY YOU TO PRACTICE ANATOMY DURING THE PRIOR TWELVE MONTHS IN QUESTION, TO THE EXTENT PERMISSIBLE BY APPLICABLE LAW.</p>\n" +
    "<p>Nothing in the Agreements removes or limits PracticeAnatomy’s liability for fraud, fraudulent misrepresentation, death or personal injury caused by its negligence, and, if required by applicable law, gross negligence. Some aspects of this section may not apply in some jurisdictions if prohibited by applicable law.</p>\n" +
    "<h2>14 Third party rights</h2>\n" +
    "<p>You acknowledge and agree that the owners of the Content and certain distributors (such as app store providers) are intended beneficiaries of the Agreements and have the right to enforce the Agreements directly against you. Other than as set out in this section, the Agreements are not intended to grant rights to anyone except you and Practice Anatomy, and in no event shall the Agreements create any third party beneficiary rights. Furthermore, the rights to terminate, rescind, or agree to any variation, waiver, or settlement of the Agreements are not subject to the consent of any other person.</p>\n" +
    "<h2>15 Entire agreement</h2>\n" +
    "<p>Other than as stated in this section or as explicitly agreed upon in writing between you and Practice Anatomy, the Agreements constitute all the terms and conditions agreed upon between you and Practice Anatomy and supersede any prior agreements in relation to the subject matter of these Agreements, whether written or oral.</p>\n" +
    "<p>Please note, however, that other aspects of your use of the Practice Anatomy Service may be governed by additional agreements. That could include, for example, access to the Practice Anatomy Service as a result of a gift card or free or discounted Trials. When you are presented with an offer for such aspects of your use, you will be presented with any related additional agreement, and you may have an opportunity to agree to additional terms. Some of those additional terms are listed on Practice Anatomy’s website. To the extent that there is any irreconcilable conflict between any additional terms and these Terms, the additional terms shall prevail.</p>\n" +
    "<h2>16 Severability and waiver</h2>\n" +
    "<p>Unless as otherwise stated in the Agreements, should any provision of the Agreements be held invalid or unenforceable for any reason or to any extent, such invalidity or enforceability shall not in any manner affect or render invalid or unenforceable the remaining provisions of the Agreements, and the application of that provision shall be enforced to the extent permitted by law.</p>\n" +
    "<p>Any failure by Practice Anatomy or any third party beneficiary to enforce the Agreements or any provision thereof shall not waive PracticeAnatomy ’s or the applicable third party beneficiary’s right to do so.</p>\n" +
    "<h2>17 Assignment</h2>\n" +
    "<p>Practice Anatomy may assign the Agreements or any part of them, and Practice Anatomy may delegate any of its obligations under the Agreements. You may not assign the Agreements or any part of them, nor transfer or sub-license your rights under the Agreements, to any third party.</p>\n" +
    "<h2>18 Indemnification</h2>\n" +
    "<p>To the fullest extent permitted by applicable law, you agree to indemnify and hold Practice Anatomy harmless from and against all damages, losses, and expenses of any kind (including reasonable attorney fees and costs) arising out of: (1) your breach of this Agreement; (2) any User Content; (3) any activity in which you engage on or through the Practice Anatomy Service; and (4) your violation of any law or the rights of a third party.</p>\n" +
    "<h2>Customer support </h2>\n" +
    "Email: anatom at googlegroups.com<br>\n" +
    "<h2>Administrative contact and Contracting entity</h2>\n" +
    "Marek Cierny<br>\n" +
    "Konecneho 2170/4, <br>\n" +
    "Brno, 61500, Czech republic<br>\n" +
    "Business ID: 74284854<br>\n" +
    "<br>\n" +
    "E-mail: marek at cierny.cz<br>\n" +
    "Phone: +1 414 552 9025<br>\n" +
    "\n" +
    "<h2>Founders</h2>\n" +
    "<p>Jan Papoušek, Vít Stanislav, Marek Čierny, Linda Kašičková</p>\n" +
    "\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div class=\"clearfix\"></div>\n" +
    "");
  $templateCache.put("static/tpl/tile.html",
    "<span \n" +
    "  ng-class=\"{\n" +
    "    'active' : category.selected && !user,\n" +
    "    'disabled' : disabled}\"\n" +
    "  class=\"col-xs-6 col-sm-3 tile fade-in-one-by-one\">\n" +
    "  <span class=\"in-tile\">\n" +
    "    <a class=\"tile-link\"\n" +
    "      href=\"/{{viewPath}}/{{category.identifier}}/{{user}}\"\n" +
    "      ng-click=\"clickFn($event)\"\n" +
    "      ng-style=\"{\n" +
    "          'background-image': 'url(\\'' + thumbnail + '\\')'\n" +
    "        }\" >\n" +
    "      <div class=\"top\" ng-if=\"category['not-in-model']\" translate>Připravujeme</div>\n" +
    "      <div class=\"top\" ng-if=\"disabled\" translate>Premium obsah</div>\n" +
    "      <div class=\"dummy\"></div>\n" +
    "      <div class=\"absolute fade-in\"\n" +
    "        ng-if=\"category.stats.number_of_items && showProgress\">\n" +
    "        <div round-progress \n" +
    "            max=\"category.stats.number_of_items\"\n" +
    "            current=\"category.stats.number_of_practiced_items\"\n" +
    "            color=\"#fe3\"\n" +
    "            bgcolor=\"rgba(190,190,190,0.5)\"\n" +
    "            responsive=\"true\"\n" +
    "            stroke=\"15\"\n" +
    "            rounded=\"true\"\n" +
    "            iterations=\"50\"\n" +
    "            animation=\"easeInOutQuart\"></div>\n" +
    "      </div>\n" +
    "      <div class=\"absolute fade-in\"\n" +
    "        ng-if=\"category.stats.number_of_mastered_items && showProgress\">\n" +
    "        <div round-progress\n" +
    "            max=\"category.stats.number_of_items\"\n" +
    "            current=\"category.stats.number_of_mastered_items\"\n" +
    "            color=\"#5CA03C\"\n" +
    "            bgcolor=\"rgba(0,0,0,0)\"\n" +
    "            responsive=\"true\"\n" +
    "            stroke=\"15\"\n" +
    "            rounded=\"true\"\n" +
    "            iterations=\"50\"\n" +
    "            animation=\"easeInOutQuart\"></div>\n" +
    "      </div>\n" +
    "      <div class=\"absolute progress-labels\" ng-if=\"wasHovered\">\n" +
    "        <span progress-labels skills=\"category.stats\" hide-labels=\"true\">\n" +
    "        </span>\n" +
    "      </div>\n" +
    "      <h2 ng-bind=\"category.name\"></h2>\n" +
    "    </a>\n" +
    "    <div class=\"dropdown\" ng-if=\"!user\">\n" +
    "      <a href=\"{{practicePath}}{{category.identifier}}\"\n" +
    "          class=\"btn btn-default btn-sm\"\n" +
    "          tooltip=\"{{'Procvičovat' | translate}}\"\n" +
    "          tooltip-placement=\"right\"\n" +
    "          ng-if=\"practicePath\"\n" +
    "          track-click=\"overview practice\" >\n" +
    "          <i class=\"glyphicon glyphicon-play\"></i>\n" +
    "      </a>\n" +
    "    </div> \n" +
    "    <div class=\"selector pull-right\" ng-if=\"!user && !hideSelect\">\n" +
    "      <button class=\"btn btn-default btn-sm\"\n" +
    "          ng-class=\"{'btn-primary' : category.selected}\"\n" +
    "          ng-click=\"category.selected = !category.selected\"\n" +
    "          tooltip=\"{{'Vybrat' | translate}}\"\n" +
    "          tooltip-placement=\"left\"\n" +
    "          track-click=\"overview selector\" >\n" +
    "          <i ng-class=\"{'glyphicon-empty' : !category.selected}\"\n" +
    "            class=\"glyphicon glyphicon-ok\"></i>\n" +
    "      </button>\n" +
    "    </div> \n" +
    "  </span>\n" +
    "</span>\n" +
    "");
  $templateCache.put("static/tpl/unauthorized.html",
    "<div class=\"col-sm-offset-2 col-sm-8\">\n" +
    "  <h1 translate>Přístup zamítnut</h1>\n" +
    "  <div class=\"alert alert-danger\">\n" +
    "    <span translate>Požadovaná stránka je dostupná jenom uživatlům s předplatným.</span>\n" +
    "    <a href=\"/premium/\"\n" +
    "       class=\"btn btn-primary\"\n" +
    "       translate\n" +
    "      >Zjistit více</a>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
  $templateCache.put("static/tpl/user_tpl.html",
    "<div class=\"profile \">\n" +
    "  <div class=\"col-sm-offset-2 col-sm-8\">\n" +
    "    <br>\n" +
    "    <div class=\"panel panel-default\" ng-hide=\"error\">\n" +
    "      <div class=\"panel-heading\">\n" +
    "        <h1 class=\"text-center\">{{user.username}}</h1>\n" +
    "      </div>\n" +
    "      <div class=\"panel-body\">\n" +
    "        <dl ng-show=\"user.first_name\">\n" +
    "          <dt>{{'Jméno' | translate }}</dt>\n" +
    "          <dd>{{user.first_name}}</dd>\n" +
    "        </dl>\n" +
    "        <dl ng-show=\"user.last_name\">\n" +
    "          <dt>{{'Příjmení' | translate }}</dt>\n" +
    "          <dd>{{user.last_name}}</dd>\n" +
    "        </dl>\n" +
    "        <dl ng-show=\"editRights\">\n" +
    "          <dt>{{'E-mail' | translate }}</dt>\n" +
    "          <dd>{{user.email}}</dd>\n" +
    "        </dl>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div ng-show=\"error\" ng-bind=\"error\" class=\"alert alert-danger\" ></div>\n" +
    "  </div>\n" +
    "  <br>\n" +
    "  <br>\n" +
    "  <br>\n" +
    "  <br>\n" +
    "  <br>\n" +
    "  <div class=\"clearfix\"></div>\n" +
    "</div>\n" +
    "<div id='subscriptions' class=\"flatblock block-welcome_page col-sm-offset-2 col-sm-8\">\n" +
    "  <div ng-if=\"isOwnProfile\" my-subscriptions></div>\n" +
    "</div>\n" +
    "");
  $templateCache.put("static/tpl/view_tpl.html",
    "<div class=\"container-fluid\">\n" +
    "  <div class=\"row header\">\n" +
    "    <div class=\"col-sm-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2\">\n" +
    "        <h1>\n" +
    "          <span>{{user ? user + ' - ' : ''}}</span>\n" +
    "          <span>{{category.name || ('Všechna schémata' | translate)}}</span>\n" +
    "        </h1>\n" +
    "        <div>\n" +
    "          <button class=\"btn btn-default btn-lg pull-right btn-share show hidden-xs\"\n" +
    "            track-click=\"share overview\"\n" +
    "            ng-disabled=\"disabled\"\n" +
    "            share-url=\"{{$location.absUrl() + userService.user.username}}\"\n" +
    "            share-title=\"{{'Pochlub se svými znalostmi' | translate}}\"\n" +
    "            share-demo-title=\"{{'Co uvidí na sdílené stránce ostatní?' | translate}}\"\n" +
    "            share-button>\n" +
    "              <i class=\"glyphicon glyphicon-share\"></i>\n" +
    "              <span translate>Sdílet</span>\n" +
    "          </button>\n" +
    "          <div class=\"clearfix\"></div>\n" +
    "        </div>\n" +
    "      <div class=\"row\">\n" +
    "        <div class=\"col-sm-6\" ng-if=\"!user\">\n" +
    "          <button class=\"btn btn-default btn-lg pull-right btn-share show visible-xs-block\"\n" +
    "            track-click=\"share overview\"\n" +
    "            share-url=\"{{$location.absUrl() + userService.user.username}}\"\n" +
    "            share-title=\"{{'Pochlub se svými znalostmi' | translate}}\"\n" +
    "            share-demo-title=\"{{'Co uvidí na sdílené stránce ostatní?' | translate}}\"\n" +
    "            share-button>\n" +
    "              <i class=\"glyphicon glyphicon-share\"></i>\n" +
    "              <span translate>Sdílet</span>\n" +
    "          </button>\n" +
    "          <a href=\"/practice/{{category.identifier}}/\" \n" +
    "            class=\"btn btn-default btn-lg\" \n" +
    "            track-click=\"view practice\" >\n" +
    "            <i class=\"glyphicon glyphicon-play\"></i>\n" +
    "            <span translate>\n" +
    "              Procvičovat kapitolu\n" +
    "            </span>\n" +
    "          </a>\n" +
    "          <span class=\"dropdown\" style=\"display: inline-block\">\n" +
    "            <button type=\"button\"\n" +
    "              class=\"btn btn-default btn-lg dropdown-toggle practice-dropdown\"\n" +
    "              data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"\n" +
    "              ng-click=\"usePracticeDwopdown()\">\n" +
    "              {{\"Procvičovat podkapitolu\" | translate}}\n" +
    "              <span class=\"caret\"></span>\n" +
    "            </button>\n" +
    "            <ul class=\"dropdown-menu pull-right\">\n" +
    "              <li ng-repeat=\"subcategory in subcategories\"\n" +
    "                  ng-if=\"subcategory.stats.number_of_items &gt; 9\">\n" +
    "                <a href=\"/practice/{{category.identifier}}/{{subcategory.identifier}}\"\n" +
    "                    track-click=\"view dropdown practice\" >\n" +
    "                 {{category.name}} - {{subcategory.name}}\n" +
    "                </a>\n" +
    "              </li>\n" +
    "            </ul>\n" +
    "          </span>\n" +
    "          <br>\n" +
    "        </div>\n" +
    "        <div class=\"col-sm-6\" ng-class=\"{'col-sm-offset-3' : user}\">\n" +
    "          <div category-progress skills=\"stats\"></div>\n" +
    "          <br>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div ng-hide=\"contexts || error\" class=\"loading-indicator\"></div>\n" +
    "  <div ng-show=\"error\" error-message ></div>\n" +
    "  <div class=\"overview view\">\n" +
    "    <div class=\"row ng-cloak\">\n" +
    "      <div class=\"col-sm-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2\">\n" +
    "        <span tile\n" +
    "          ng-repeat=\"context in contexts\"\n" +
    "          category=\"context\"\n" +
    "          index=\"$index\"\n" +
    "          thumbnail-path=\"'/media/tile-thumbs/'\"\n" +
    "          view-path=\"'image'\"\n" +
    "          click-action=\"activateContext\"\n" +
    "          hide-select=\"true\"\n" +
    "          practice-path=\"'/practice/?context='\">\n" +
    "        </span>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "<image-modal \n" +
    "  open-action=\"activateContext\"\n" +
    "  contexts=\"contexts\"\n" +
    "  category=\"category\"\n" +
    "  context=\"activeContext\">\n" +
    "</image-modal>\n" +
    "");
}]);
